webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(240);


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(208);
	
	Object.defineProperty(exports, 'API', {
	  enumerable: true,
	  get: function get() {
	    return _api.API;
	  }
	});
	
	var _roles = __webpack_require__(212);
	
	Object.defineProperty(exports, 'ROLES', {
	  enumerable: true,
	  get: function get() {
	    return _roles.ROLES;
	  }
	});
	
	var _plans = __webpack_require__(210);
	
	Object.defineProperty(exports, 'PLANS', {
	  enumerable: true,
	  get: function get() {
	    return _plans.PLANS;
	  }
	});
	
	var _provinces = __webpack_require__(211);
	
	Object.defineProperty(exports, 'PROVINCES', {
	  enumerable: true,
	  get: function get() {
	    return _provinces.PROVINCES;
	  }
	});
	
	var _constants = __webpack_require__(209);
	
	Object.defineProperty(exports, 'CONSTANTS', {
	  enumerable: true,
	  get: function get() {
	    return _constants.CONSTANTS;
	  }
	});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap) {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
	  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
	  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
	  return '/*# ' + data + ' */';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(343).Buffer))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "60fbaf968c2bbde49ad237389dd830d0.svg";

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3c103fd0100b254f3d8143756d7d90ac.svg";

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "17d2237db5a50a288c5e7582c2f73167.png";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5c700d5a1b08d0011311e6760e2cac6f.png";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3d96fc14d43499337ef5c8e671ec4085.jpg";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./avatar-1.png": 304,
		"./avatar-10.png": 305,
		"./avatar-2.png": 306,
		"./avatar-3.png": 307,
		"./avatar-4.png": 308,
		"./avatar-5.png": 309,
		"./avatar-6.png": 310,
		"./avatar-7.png": 311,
		"./avatar-8.png": 312,
		"./avatar-9.png": 313
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 30;


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports) {

	(function(window, angular, undefined) {'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.google.analytics
	 * Enables analytics support for Google Analytics (http://google.com/analytics)
	 */
	angular.module('angulartics.google.analytics', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	
	  // GA already supports buffered invocations so we don't need
	  // to wrap these inside angulartics.waitForVendorApi
	  $analyticsProvider.settings.pageTracking.trackRelativePath = true;
	  
	  // Set the default settings for this module
	  $analyticsProvider.settings.ga = {
	    additionalAccountNames: undefined,
	    // Select hits to send to all additional accounts
	    additionalAccountHitTypes: {
	      pageview: true,
	      event: true,
	      exception: false,
	      ecommerce: false,
	      userTiming: false,
	      setUserProperties: false,
	      userId: false
	    },
	    disableEventTracking: null,
	    disablePageTracking: null,
	    enhancedEcommerce: false, 
	    // GA supports transporting data via gif requests, XHRs, or sendBeacons
	    // @link https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#transport
	    transport: null,
	    userId: null
	  };
	
	  /**
	   * Track Pageview in GA
	   * @name pageTrack
	   *
	   * @param {string} path value of Page dimension stored with hit e.g. '/home'
	   * @param {object} properties Object with optional addtional Custom Dimensions/Metrics
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
	   * @link https://developers.google.com/analytics/devguides/collection/gajs/
	   */
	  $analyticsProvider.registerPageTrack(function (path, properties) {
	    
	    properties = properties || {};
	
	    // Do nothing if page tracking is disabled
	    if ($analyticsProvider.settings.ga.disablePageTracking) return;
	
	    dispatchToGa('pageview', 'send', angular.extend({}, properties, {
	      hitType: 'pageview',
	      page: path
	    }));
	
	  });
	
	  /**
	   * Track Event in GA
	   * @name eventTrack
	   *
	   * @param {string} action Required 'action' (string) associated with the event
	   * @param {object} properties Comprised of the mandatory field 'category' (string) and optional  fields 'label' (string), 'value' (integer) and 'nonInteraction' (boolean)
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/gajs/eventTrackerGuide#SettingUpEventTracking
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	   */
	  $analyticsProvider.registerEventTrack(function(action, properties) {
	
	    // Do nothing if event tracking is disabled
	    if ($analyticsProvider.settings.ga.disableEventTracking) return;
	
	    if (!action && action + '' !== '0') {
	      return;
	    }
	
	    // Sets default properties
	    properties = properties || {};
	    properties.category = properties.category || 'Event';
	
	    // GA requires that eventValue be an integer, see:
	    // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#eventValue
	    // https://github.com/luisfarzati/angulartics/issues/81
	    if (properties.value) {
	      var parsed = parseInt(properties.value, 10);
	      properties.value = isNaN(parsed) ? 0 : parsed;
	    }
	
	    // GA requires that hitCallback be an function, see:
	    // https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits#hitcallback
	    if (!angular.isFunction(properties.hitCallback)) {
	      properties.hitCallback = null;
	    }
	
	    // Making nonInteraction parameter more intuitive, includes backwards compatibilty
	    // https://github.com/angulartics/angulartics-google-analytics/issues/49
	    properties.nonInteraction = properties.nonInteraction || properties.noninteraction;
	
	    dispatchToGa('event', 'send', angular.extend({}, properties, {
	      hitType: 'event',
	      eventCategory: properties.category,
	      eventAction: action,
	      eventLabel: properties.label,
	      eventValue: properties.value,
	      nonInteraction: properties.nonInteraction,
	      page: properties.page || window.location.hash.substring(1) || window.location.pathname,
	      hitCallback: properties.hitCallback,
	    }));
	
	  });
	
	  /**
	   * Exception Track Event in GA
	   * @name exceptionTrack
	   * Sugar on top of the eventTrack method for easily handling errors
	   *
	   * @param {object} error An Error object to track: error.toString() used for event 'action', error.stack used for event 'label'.
	   * @param {object} cause The cause of the error given from $exceptionHandler, not used.
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	   */
	  $analyticsProvider.registerExceptionTrack(function (error, cause) {
	    dispatchToGa('exception', 'send', {
	      hitType: 'event',
	      eventCategory: 'Exceptions',
	      eventAction: error.toString(),
	      eventLabel: error.stack,
	      nonInteraction: true,
	      page: window.location.hash.substring(1) || window.location.pathname,
	      isException: true
	    });
	  });
	
	  /**
	   * Set Username
	   * @name setUsername
	   *
	   * @param {string} userId Registers User ID of user for use with other hits
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id#user_id
	   */
	  $analyticsProvider.registerSetUsername(function (userId) {
	    $analyticsProvider.settings.ga.userId = userId;
	  });
	
	  /**
	   * Set User Properties
	   * @name setUserProperties
	   *
	   * @param {object} properties Sets all properties with dimensionN or metricN to their respective values
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#customs
	   */
	  $analyticsProvider.registerSetUserProperties(function (properties) {
	
	    if (properties) {
	      dispatchToGa('setUserProperties', 'set', dimensionsAndMetrics(properties));
	    }
	
	  });
	
	  /**
	   * User Timings Event in GA
	   * @name userTimings
	   *
	   * @param {object} properties Comprised of the mandatory fields:
	   *     'timingCategory' (string),
	   *     'timingVar' (string),
	   *     'timingValue' (number)
	   * Properties can also have the optional fields:
	   *     'timingLabel' (string)
	   *     'optSampleRate' (number) Classic Analytics only - determines % of users to collect data from, handled serverside by UA
	   *     @link https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings#sampling_considerations
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings
	   */
	  $analyticsProvider.registerUserTimings(function (properties) {
	
	    if (!angular.isObject(properties) || angular.isArray(properties)) {
	      return console.log('Required argument properties is missing or not an object');
	    }
	
	    angular.forEach(['timingCategory', 'timingVar', 'timingValue'], function(prop) {
	      if (angular.isUndefined(properties[prop])) {
	        return console.log('Argument properties missing required property ' + prop);
	      }
	    });
	
	    dispatchToGa('userTiming', 'send', {
	      hitType: 'timing',
	      timingCategory: properties.timingCategory,
	      timingVar: properties.timingVar,
	      timingValue: properties.timingValue,
	      timingLabel: properties.timingLabel,
	      optSampleRate: properties.optSampleRate,  // Classic Analytics only
	      page: properties.page || window.location.hash.substring(1) || window.location.pathname,
	    });
	
	  });
	
	  /**
	   * Ecommerce Tracking in GA
	   * @name transactionTrack
	   *
	   * @param {object} transaction comprised of following fields:
	   *     'id': 'T12345',                         // Transaction ID. Required for purchases and refunds.
	   *     'affiliation': 'Online Store',
	   *     'revenue': '35.43',                     // Total transaction value (incl. tax and shipping)
	   *     'tax':'4.90',
	   *     'shipping': '5.99',
	   *     'coupon': 'SUMMER_SALE',                // Enhanced Ecommerce Only
	   *     'dimension1': 'Card ID #1234',          // Hit, Session, or User-level Custom Dimension(s)
	   *     'metric1': 1,                           // Custom Metric(s)
	   *     'currencyCode': 'EUR',                  // Currency Code to track the transaction with. Recognized codes: https://support.google.com/analytics/answer/6205902?hl=en#supported-currencies
	   *     'billingCity': 'San Francisco',                // Classic Analytics only
	   *     'billingRegion': 'California',                 // Classic Analytics only
	   *     'billingCountry': 'USA',                       // Classic Analytics only
	   *     'products': [{                            // List of products
	   *       'name': 'Triblend Android T-Shirt',     // Name or ID is required.
	   *       'id': '12345',                          // Product SKU
	   *       'price': '15.25',
	   *       'brand': 'Google',                      // Enhanced Ecommerce only
	   *       'category': 'Apparel',                 
	   *       'variant': 'Gray',                      // Enhanced Ecommerce only
	   *       'quantity': 1,
	   *       'coupon': '',                           // Enhanced Ecommerce only.
	   *       'currencyCode': 'BRL',                  // Product-level currency code, Enhanced Ecommerce only
	   *       'dimension2': 'Clearance',              // Product-level Custom Dimension
	   *       'metric2': 1                            // Product-level Custom Metric
	   *      },
	   *      ...
	   *    ]
	   *
	   * @param {object] properties comprised of custom dimensions and metrics to
	   * send with the transaction hit
	   * Utilizes traditional ecommerce tracking by default. To used Enhanced Ecommerce,
	   * set the $analytics.settings.ga.enhancedEcommerce flag to true
	   *
	   * Docs on traditional ecommerce (UA):
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce
	   *
	   * Docs on Enhanced Ecommerce
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce
	   *
	   * Docs on Classic Ecommerce (_gaq)
	   * @link https://developers.google.com/analytics/devguides/collection/gajs/gaTrackingEcommerce
	   **/
	  $analyticsProvider.registerTransactionTrack(function(transaction) {
	
	    var product;
	    var i;
	
	    // Universal Analytics splits off the ecommerce code into a separate
	    // library we must include by using the "require" command
	    dispatchToGa('ecommerce', 'require', 'ecommerce');
	    dispatchToGa('ecommerce', 'ecommerce:addTransaction', transaction);
	    
	    if (transaction.products) {
	      for (i = 0; i < transaction.products.length; i++) {
	
	        product = transaction.products[i];
	
	        // GA uses a SKU property and stores the transaction ID in the ID Field
	        product.sku = product.id;
	        product.id = transaction.id;
	
	        dispatchToGa('ecommerce', 'ecommerce:addItem', transaction.products[i]);
	
	      }
	    }
	
	    if (transaction.currencyCode) {
	
	      dispatchToGa('ecommerce', '_set', transaction.currencyCode); // Classic Anayltics only - UA uses fieldsObj.currencyCode instead
	
	    } 
	
	    dispatchToGa('ecommerce', 'ecommerce:send', angular.copy(transaction));
	
	  });
	
	  /**
	   * Detects if Universal Analytics is installed
	   *
	   * @name detectUniversalAnalytics
	   */
	  function detectUniversalAnalytics() {
	
	    // Use the GoogleAnalyticsObject property set by the default GA snippet
	    // to correctly determine the namespace of the GA global
	    var gaNamespace = window.GoogleAnalyticsObject;
	    return gaNamespace && window[gaNamespace];
	
	  }
	
	  /**
	   * Detects if Classic Analytics is installed
	   *
	   * @name detectClassicAnalytics
	   */
	  function detectClassicAnalytics() {
	
	    // If _gaq is undefined, we're trusting Classic Analytics to be there
	    return !angular.isUndefined(window._gaq);
	
	  }
	
	  /**
	   * Extract Custom Data for a hit
	   * @name dimensionsAndMetrics
	   * 
	   * @param {object} properties properties object from an API call that is filtered for Custom Dimensions & Metrics
	   *
	   * @returns {object} customData object with only Custom Dimensions/Metrics from properties argument
	   */
	  function dimensionsAndMetrics(properties) {
	    // add custom dimensions and metrics
	    var customData = {};
	    var key;
	
	    for (key in properties) {
	      // Keys must be dimensionXX or metricXX, e.g. dimension1, metric155, so
	      // if those strings aren't at zero (which evaluates to falsey), ignore
	      // the key
	      if (!key.indexOf('dimension') || !key.indexOf('metric')) {
	        customData[key] = properties[key];
	      }
	    }
	    return customData;
	  }
	
	  /**
	   * Handler for hits to GA. Dynamically adjusts syntax for
	   * targeted version based on global detection.
	   *
	   * @name dispatchToGa
	   *
	   * @param {string} method Name of angulartics method for checking if hits should be duplicated
	   * @param {string} command Standard Universal Analytics command (create, send, set)
	   * @param {object} fieldsObj object with hit-specific fields. Fields are whitelisted in handler - non-supported fields are ignored.
	   * 
	   */
	  var dispatchToGa = (function() {
	
	    var handler;
	
	    if (detectClassicAnalytics()) {
	      handler = dispatchToClassic_;
	    }
	
	    if (detectUniversalAnalytics()) {
	      handler = dispatchToUniversal_;
	    }
	
	    // If neither has been detected, GA is not above the angular code
	    if (!handler) {
	      return angular.noop;
	    }
	
	    return function(method, command, fieldsObj) {
	
	      var shouldCopyHit = $analyticsProvider.settings.ga.additionalAccountHitTypes[method];
	      handler(command, fieldsObj, shouldCopyHit);
	
	    }
	
	    /**
	     * Dispatches a hit using Universal syntax
	     *
	     * @name dispatchToUniversal_
	     * @private
	     *  
	     * @param {string} command Standard Universal Analytics command (create, send, set)
	     * @param {object} fieldsObj object with hit-specific fields. Fields are whitelisted in handler - non-supported fields are ignored.
	     * @param {boolean} shouldCopyHit should hit be propogated to all trackers
	     */
	    function dispatchToUniversal_(command, fieldsObj, shouldCopyHit) {
	
	      var userId = $analyticsProvider.settings.ga.userId;
	      var uaCommand,
	          pluginName;
	
	      if (command === 'require' && fieldsObj === 'ecommerce') {
	
	        pluginName = fieldsObj;
	  
	        if ($analyticsProvider.settings.ga.enhancedEcommerce) {
	  
	          pluginName = 'ec';
	
	        }
	      
	        // Exit here - require calls don't have fieldsObjs
	        return applyUniversalCall_([command, pluginName], shouldCopyHit);
	
	      }
	
	      // If our User ID is set, set it on the hit
	      if (userId && angular.isObject(fieldsObj)) fieldsObj.userId = userId;
	      // If a transport preference is specified, set it on the hit
	      if ($analyticsProvider.settings.ga.transport) {
	
	        fieldsObj.transport = $analyticsProvider.settings.ga.transport;
	
	      }
	
	      if (command.indexOf('ecommerce:') > -1 && $analyticsProvider.settings.ga.enhancedEcommerce) {
	
	        switch (command) {
	          case 'ecommerce:addTransaction':
	            command = ['ec:setAction', 'purchase'];
	            break;
	          case 'ecommerce:addItem':
	            command = 'ec:addProduct';
	            // Enhanced Ecommerce reverts to using the ID property for the SKU,
	            // so we swap them back here
	            fieldsObj.id = fieldsObj.sku;
	            break;
	          case 'ecommerce:send':
	            command = 'send';
	            fieldsObj.hitType = 'event';
	            fieldsObj.eventCategory = 'Angulartics Enhanced Ecommerce';
	            fieldsObj.eventAction = 'Purchase';
	            fieldsObj.nonInteraction = true;
	            break;
	        }
	
	      }
	
	
	      uaCommand = command instanceof Array ? command.concat(fieldsObj) : [command, fieldsObj];
	
	      applyUniversalCall_(uaCommand, shouldCopyHit);
	
	    }
	
	    /**
	     * Handles applying a constructed call to the global Universal GA object
	     * This exists primarily so calls within dispatchToUa_ can short circuit
	     * out of the function to handle specific edge cases, e.g. require commands
	     * @name applyUniversalCall_
	     * @private
	     *
	     * @param commandArray {array} command to be .apply()'d
	     * @param shouldCopyHit {boolean} should the command be applied to all accts
	     */
	    function applyUniversalCall_(commandArray, shouldCopyHit) {
	
	      var userId = $analyticsProvider.settings.ga.userId;
	      var gaNamespace = window.GoogleAnalyticsObject;
	      var commandClone;
	
	      // Perform our initial call
	      window[gaNamespace].apply(this, commandArray);
	
	      if (shouldCopyHit) {
	
	        commandClone = angular.copy(commandArray);
	
	        // If the userId shouldn't be duplicated, remove from the fieldsObj
	        if (userId && !$analyticsProvider.settings.ga.additionalAccountHitTypes.userId) {
	          
	          if (commandClone[2] && typeof commandClone[2] === 'object') {
	
	            delete commandClone[2].userId;
	
	          }
	  
	        }
	
	        angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
	       
	          commandClone[0] = accountName + '.' + commandClone[0];
	
	          window[gaNamespace].apply(this, commandClone);
	
	        }); 
	
	      }
	
	    }
	
	    /**
	     * Dispatches a hit using Classic syntax
	     * Translates Universal Syntax to Classic syntax
	     *
	     * @name dispatchToClassic_
	     * @private
	     *  
	     * @param {string} command Standard Universal Analytics command (create, send, set)
	     * @param {object} fieldsObj object with hit-specific fields. Fields are whitelisted in handler - non-supported fields are ignored.
	     * @param {boolean} shouldCopyHit should hit be propogated to all trackers
	     */
	    function dispatchToClassic_(command, fieldsObj, shouldCopyHit) {
	
	      if (command === 'set') {
	        return console.log('Classic Analytics does not support the "set" command or Custom Dimensions. Command ignored.');
	      }
	
	      var classicCommand;
	
	      // Transpose our syntax from Universal Analytics to Classic Analytics
	      // Currently we only support 'send' style commands
	      if (command === 'send') {
	
	        switch(fieldsObj.hitType) {
	          case 'pageview':
	            classicCommand = ['_trackPageview', fieldsObj.page];
	            break;
	          case 'event':
	            classicCommand = [
	              '_trackEvent',
	              fieldsObj.category,
	              fieldsObj.action,
	              fieldsObj.label,
	              fieldsObj.value,
	              fieldsObj.nonInteraction
	            ];
	            break;
	          case 'timing':
	            classicCommand = [
	              '_trackTiming',
	              fieldsObj.timingCategory,
	              fieldsObj.timingVar,
	              fieldsObj.timingValue,
	              fieldsObj.timingLabel,
	              fieldsObj.optSampleRate
	            ];
	            break;
	        }
	
	      }
	
	      if (command === 'ecommerce:addTransaction') {
	
	        classicCommand = [
	          '_addTrans',
	          fieldsObj.id,
	          fieldsObj.affiliation,
	          fieldsObj.revenue,
	          fieldsObj.tax,
	          fieldsObj.shipping,
	          fieldsObj.billingCity,
	          fieldsObj.billingRegion,
	          fieldsObj.billingCountry
	        ];
	
	      }
	
	      if (command === 'ecommerce:addItem') { 
	
	        classicCommand = [
	          '_addItem',
	          fieldsObj.id,
	          fieldsObj.sku,
	          fieldsObj.name,
	          fieldsObj.category,
	          fieldsObj.price,
	          fieldsObj.quantity
	        ];
	
	      }
	
	      if (command === '_set') {
	
	        classicCommand = [
	          '_set',
	          'currencyCode',
	          fieldsObj
	        ];
	
	      }
	
	      if (command === 'ecommerce:send') {
	
	        classicCommand = [
	          '_trackTrans' 
	        ];
	
	      }
	
	      if (!classicCommand) {
	        return console.log('Unable to find command ' + command + ' or fieldsObj missing required properties. Command ignored.');
	      }
	
	      // Issue our command to GA
	      window._gaq.push(classicCommand);
	
	      if (shouldCopyHit) {
	
	        angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
	          
	          var classicCommandClone = [].slice.call(classicCommand);
	          // Namespace the command as required
	          classicCommandClone[0] = accountName + '.' + classicCommandClone[0];
	
	          window._gaq.push(classicCommandClone);
	
	        });
	
	      }
	
	    }
	
	  })();
	
	}]);
	})(window, window.angular);


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(40)
	module.exports = 'angulartics.google.analytics'


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics
	 * (c) 2013 Luis Farzati http://angulartics.github.io/
	 * License: MIT
	 */
	(function(angular, analytics) {
	'use strict';
	
	var angulartics = window.angulartics || (window.angulartics = {});
	angulartics.waitForVendorCount = 0;
	angulartics.waitForVendorApi = function (objectName, delay, containsField, registerFn, onTimeout) {
	  if (!onTimeout) { angulartics.waitForVendorCount++; }
	  if (!registerFn) { registerFn = containsField; containsField = undefined; }
	  if (!Object.prototype.hasOwnProperty.call(window, objectName) || (containsField !== undefined && window[objectName][containsField] === undefined)) {
	    setTimeout(function () { angulartics.waitForVendorApi(objectName, delay, containsField, registerFn, true); }, delay);
	  }
	  else {
	    angulartics.waitForVendorCount--;
	    registerFn(window[objectName]);
	  }
	};
	
	/**
	 * @ngdoc overview
	 * @name angulartics
	 */
	angular.module('angulartics', [])
	.provider('$analytics', $analytics)
	.run(['$rootScope', '$window', '$analytics', '$injector', $analyticsRun])
	.directive('analyticsOn', ['$analytics', analyticsOn])
	.config(['$provide', exceptionTrack]);
	
	function $analytics() {
	  var vm = this;
	
	  var settings = {
	    pageTracking: {
	      autoTrackFirstPage: true,
	      autoTrackVirtualPages: true,
	      trackRelativePath: false,
	      trackRoutes: true,
	      trackStates: true,
	      autoBasePath: false,
	      basePath: '',
	      excludedRoutes: [],
	      queryKeysWhitelisted: [],
	      queryKeysBlacklisted: [],
	      filterUrlSegments: []
	    },
	    eventTracking: {},
	    bufferFlushDelay: 1000, // Support only one configuration for buffer flush delay to simplify buffering
	    trackExceptions: false,
	    optOut: false,
	    developerMode: false // Prevent sending data in local/development environment
	  };
	
	  // List of known handlers that plugins can register themselves for
	  var knownHandlers = [
	    'pageTrack',
	    'eventTrack',
	    'exceptionTrack',
	    'transactionTrack',
	    'setAlias',
	    'setUsername',
	    'setUserProperties',
	    'setUserPropertiesOnce',
	    'setSuperProperties',
	    'setSuperPropertiesOnce',
	    'incrementProperty',
	    'userTimings',
	    'clearCookies'
	  ];
	  // Cache and handler properties will match values in 'knownHandlers' as the buffering functons are installed.
	  var cache = {};
	  var handlers = {};
	  var handlerOptions = {};
	
	  // General buffering handler
	  function bufferedHandler(handlerName){
	    return function(){
	      if(angulartics.waitForVendorCount){
	        if(!cache[handlerName]){ cache[handlerName] = []; }
	        cache[handlerName].push(arguments);
	      }
	    };
	  }
	
	  // As handlers are installed by plugins, they get pushed into a list and invoked in order.
	  function updateHandlers(handlerName, fn, options){
	    if(!handlers[handlerName]){
	      handlers[handlerName] = [];
	    }
	    handlers[handlerName].push(fn);
	    handlerOptions[fn] = options;
	    return function(){
	      if(!this.settings.optOut) {
	        var handlerArgs = Array.prototype.slice.apply(arguments);
	        return this.$inject(['$q', angular.bind(this, function($q) {
	          return $q.all(handlers[handlerName].map(function(handlerFn) {
	            var options = handlerOptions[handlerFn] || {};
	            if (options.async) {
	              var deferred = $q.defer();
	              var currentArgs = angular.copy(handlerArgs);
	              currentArgs.unshift(deferred.resolve);
	              handlerFn.apply(this, currentArgs);
	              return deferred.promise;
	            } else{
	              return $q.when(handlerFn.apply(this, handlerArgs));
	            }
	          }, this));
	        })]);
	      }
	    };
	  }
	
	  // The api (returned by this provider) gets populated with handlers below.
	  var api = {
	    settings: settings
	  };
	
	  // Opt in and opt out functions
	  api.setOptOut = function(optOut) {
	    this.settings.optOut = optOut;
	    triggerRegister();
	  };
	
	  api.getOptOut = function() {
	    return this.settings.optOut;
	  };
	
	
	  // Will run setTimeout if delay is > 0
	  // Runs immediately if no delay to make sure cache/buffer is flushed before anything else.
	  // Plugins should take care to register handlers by order of precedence.
	  function onTimeout(fn, delay){
	    if(delay){
	      setTimeout(fn, delay);
	    } else {
	      fn();
	    }
	  }
	
	  var provider = {
	    $get: ['$injector', function($injector) {
	      return apiWithInjector($injector);
	    }],
	    api: api,
	    settings: settings,
	    virtualPageviews: function (value) { this.settings.pageTracking.autoTrackVirtualPages = value; },
	    trackStates: function (value) { this.settings.pageTracking.trackStates = value; },
	    trackRoutes: function (value) { this.settings.pageTracking.trackRoutes = value; },
	    excludeRoutes: function(routes) { this.settings.pageTracking.excludedRoutes = routes; },
	    queryKeysWhitelist: function(keys) { this.settings.pageTracking.queryKeysWhitelisted = keys; },
	    queryKeysBlacklist: function(keys) { this.settings.pageTracking.queryKeysBlacklisted = keys; },
	    filterUrlSegments: function(filters) { this.settings.pageTracking.filterUrlSegments = filters; },
	    firstPageview: function (value) { this.settings.pageTracking.autoTrackFirstPage = value; },
	    withBase: function (value) {
	      this.settings.pageTracking.basePath = (value) ? angular.element(document).find('base').attr('href') : '';
	    },
	    withAutoBase: function (value) { this.settings.pageTracking.autoBasePath = value; },
	    trackExceptions: function (value) { this.settings.trackExceptions = value; },
	    developerMode: function(value) { this.settings.developerMode = value; }
	  };
	
	  // General function to register plugin handlers. Flushes buffers immediately upon registration according to the specified delay.
	  function register(handlerName, fn, options){
	    // Do not add a handler if developerMode is true
	    if (settings.developerMode) {
	        return;
	    }
	    api[handlerName] = updateHandlers(handlerName, fn, options);
	    var handlerSettings = settings[handlerName];
	    var handlerDelay = (handlerSettings) ? handlerSettings.bufferFlushDelay : null;
	    var delay = (handlerDelay !== null) ? handlerDelay : settings.bufferFlushDelay;
	    angular.forEach(cache[handlerName], function (args, index) {
	      onTimeout(function () { fn.apply(this, args); }, index * delay);
	    });
	  }
	
	  function capitalize(input) {
	      return input.replace(/^./, function (match) {
	          return match.toUpperCase();
	      });
	  }
	
	  //provide a method to inject services into handlers
	  var apiWithInjector = function(injector) {
	    return angular.extend(api, {
	      '$inject': injector.invoke
	    });
	  };
	
	  // Adds to the provider a 'register#{handlerName}' function that manages multiple plugins and buffer flushing.
	  function installHandlerRegisterFunction(handlerName){
	    var registerName = 'register'+capitalize(handlerName);
	    provider[registerName] = function(fn, options){
	      register(handlerName, fn, options);
	    };
	    api[handlerName] = updateHandlers(handlerName, bufferedHandler(handlerName));
	  }
	
	  function startRegistering(_provider, _knownHandlers, _installHandlerRegisterFunction) {
	    angular.forEach(_knownHandlers, _installHandlerRegisterFunction);
	
	    for (var key in _provider) {
	      vm[key] = _provider[key];
	    }
	  }
	
	  // Allow $angulartics to trigger the register to update opt in/out
	  var triggerRegister = function() {
	    startRegistering(provider, knownHandlers, installHandlerRegisterFunction);
	  };
	
	  // Initial register
	  startRegistering(provider, knownHandlers, installHandlerRegisterFunction);
	
	}
	
	function $analyticsRun($rootScope, $window, $analytics, $injector) {
	
	  function matchesExcludedRoute(url) {
	    for (var i = 0; i < $analytics.settings.pageTracking.excludedRoutes.length; i++) {
	      var excludedRoute = $analytics.settings.pageTracking.excludedRoutes[i];
	      if ((excludedRoute instanceof RegExp && excludedRoute.test(url)) || url.indexOf(excludedRoute) > -1) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function arrayDifference(a1, a2) {
	    var result = [];
	    for (var i = 0; i < a1.length; i++) {
	      if (a2.indexOf(a1[i]) === -1) {
	        result.push(a1[i]);
	      }
	    }
	    return result;
	  }
	
	  function filterQueryString(url, keysMatchArr, thisType){
	    if (/\?/.test(url) && keysMatchArr.length > 0) {
	      var urlArr = url.split('?');
	      var urlBase = urlArr[0];
	      var pairs = urlArr[1].split('&');
	      var matchedPairs = [];
	
	      for (var i = 0; i < keysMatchArr.length; i++) {
	        var listedKey = keysMatchArr[i];
	        for (var j = 0; j < pairs.length; j++) {
	          if ((listedKey instanceof RegExp && listedKey.test(pairs[j])) || pairs[j].indexOf(listedKey) > -1) matchedPairs.push(pairs[j]);
	        }
	      }
	
	      var matchedPairsArr = (thisType == 'white' ? matchedPairs : arrayDifference(pairs,matchedPairs));
	      if(matchedPairsArr.length > 0){
	        return urlBase + '?' + matchedPairsArr.join('&');
	      }else{
	        return urlBase;
	      }
	    } else {
	      return url;
	    }
	  }
	
	  function whitelistQueryString(url){
	    return filterQueryString(url, $analytics.settings.pageTracking.queryKeysWhitelisted, 'white');
	  }
	
	  function blacklistQueryString(url){
	    return filterQueryString(url, $analytics.settings.pageTracking.queryKeysBlacklisted, 'black');
	  }
	
	  function filterUrlSegments(url){
	    var segmentFiltersArr = $analytics.settings.pageTracking.filterUrlSegments;
	
	    if (segmentFiltersArr.length > 0) {
	      var urlArr = url.split('?');
	      var urlBase = urlArr[0];
	
	      var segments = urlBase.split('/');
	
	      for (var i = 0; i < segmentFiltersArr.length; i++) {
	        var segmentFilter = segmentFiltersArr[i];
	
	        for (var j = 1; j < segments.length; j++) {
	          /* First segment will be host/protocol or base path. */
	          if ((segmentFilter instanceof RegExp && segmentFilter.test(segments[j])) || segments[j].indexOf(segmentFilter) > -1) {
	            segments[j] = 'FILTERED';
	          }
	        }
	      }
	
	      return segments.join('/');
	    } else {
	      return url;
	    }
	  }
	
	  function pageTrack(url, $location) {
	    if (!matchesExcludedRoute(url)) {
	      url = whitelistQueryString(url);
	      url = blacklistQueryString(url);
	      url = filterUrlSegments(url);
	      $analytics.pageTrack(url, $location);
	    }
	  }
	
	  if ($analytics.settings.pageTracking.autoTrackFirstPage) {
	    /* Only track the 'first page' if there are no routes or states on the page */
	    var noRoutesOrStates = true;
	    if ($injector.has('$route')) {
	       var $route = $injector.get('$route');
	       if ($route) {
	        for (var route in $route.routes) {
	          noRoutesOrStates = false;
	          break;
	        }
	       } else if ($route === null){
	        noRoutesOrStates = false;
	       }
	    } else if ($injector.has('$state')) {
	      var $state = $injector.get('$state');
	      if ($state.get().length > 1) noRoutesOrStates = false;
	    }
	    if (noRoutesOrStates) {
	      if ($analytics.settings.pageTracking.autoBasePath) {
	        $analytics.settings.pageTracking.basePath = $window.location.pathname;
	      }
	      $injector.invoke(['$location', function ($location) {
	        if ($analytics.settings.pageTracking.trackRelativePath) {
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          pageTrack(url, $location);
	        } else {
	          pageTrack($location.absUrl(), $location);
	        }
	      }]);
	    }
	  }
	
	  if ($analytics.settings.pageTracking.autoTrackVirtualPages) {
	    if ($analytics.settings.pageTracking.autoBasePath) {
	      /* Add the full route to the base. */
	      $analytics.settings.pageTracking.basePath = $window.location.pathname + "#";
	    }
	    var noRoutesOrStates = true;
	
	    if ($analytics.settings.pageTracking.trackRoutes) {
	      if ($injector.has('$route')) {
	        var $route = $injector.get('$route');
	        if ($route) {
	          for (var route in $route.routes) {
	            noRoutesOrStates = false;
	            break;
	          }
	        } else if ($route === null){
	          noRoutesOrStates = false;
	        }
	        $rootScope.$on('$routeChangeSuccess', function (event, current) {
	          if (current && (current.$$route||current).redirectTo) return;
	          $injector.invoke(['$location', function ($location) {
	            var url = $analytics.settings.pageTracking.basePath + $location.url();
	            pageTrack(url, $location);
	          }]);
	        });
	      }
	    }
	
	    if ($analytics.settings.pageTracking.trackStates) {
	      if ($injector.has('$state') && !$injector.has('$transitions')) {
	        noRoutesOrStates = false;
	        $rootScope.$on('$stateChangeSuccess', function (event, current) {
	          $injector.invoke(['$location', function ($location) {
	            var url = $analytics.settings.pageTracking.basePath + $location.url();
	            pageTrack(url, $location);
	          }]);
	        });
	      }
	      if ($injector.has('$state') && $injector.has('$transitions')) {
	        noRoutesOrStates = false;
	        $injector.invoke(['$transitions', function($transitions) {
	          $transitions.onSuccess({}, function($transition$) {
	            var transitionOptions = $transition$.options();
	
	            // only track for transitions that would have triggered $stateChangeSuccess
	            if (transitionOptions.notify) {
	              $injector.invoke(['$location', function ($location) {
	                var url = $analytics.settings.pageTracking.basePath + $location.url();
	                pageTrack(url, $location);
	              }]);
	            }
	          });
	        }]);
	      }
	    }
	
	    if (noRoutesOrStates) {
	      $rootScope.$on('$locationChangeSuccess', function (event, current) {
	        if (current && (current.$$route || current).redirectTo) return;
	        $injector.invoke(['$location', function ($location) {
	          if ($analytics.settings.pageTracking.trackRelativePath) {
	            var url = $analytics.settings.pageTracking.basePath + $location.url();
	            pageTrack(url, $location);
	          } else {
	            pageTrack($location.absUrl(), $location);
	          }
	        }]);
	      });
	    }
	  }
	  if ($analytics.settings.developerMode) {
	    angular.forEach($analytics, function(attr, name) {
	      if (typeof attr === 'function') {
	        $analytics[name] = function(){};
	      }
	    });
	  }
	}
	
	function analyticsOn($analytics) {
	  return {
	    restrict: 'A',
	    link: function ($scope, $element, $attrs) {
	      var eventType = $attrs.analyticsOn || 'click';
	      var trackingData = {};
	
	      angular.forEach($attrs.$attr, function(attr, name) {
	        if (isProperty(name)) {
	          trackingData[propertyName(name)] = $attrs[name];
	          $attrs.$observe(name, function(value){
	            trackingData[propertyName(name)] = value;
	          });
	        }
	      });
	
	      angular.element($element[0]).on(eventType, function ($event) {
	        var eventName = $attrs.analyticsEvent || inferEventName($element[0]);
	        trackingData.eventType = $event.type;
	
	        if($attrs.analyticsIf){
	          if(! $scope.$eval($attrs.analyticsIf)){
	            return; // Cancel this event if we don't pass the analytics-if condition
	          }
	        }
	        // Allow components to pass through an expression that gets merged on to the event properties
	        // eg. analytics-properites='myComponentScope.someConfigExpression.$analyticsProperties'
	        if($attrs.analyticsProperties){
	          angular.extend(trackingData, $scope.$eval($attrs.analyticsProperties));
	        }
	        $analytics.eventTrack(eventName, trackingData);
	      });
	    }
	  };
	}
	
	function exceptionTrack($provide) {
	  $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function ($delegate, $injector) {
	    return function (error, cause) {
	      var result = $delegate(error, cause);
	      var $analytics = $injector.get('$analytics');
	      if ($analytics.settings.trackExceptions) {
	        $analytics.exceptionTrack(error, cause);
	      }
	      return result;
	    };
	  }]);
	}
	
	function isCommand(element) {
	  return ['a:','button:','button:button','button:submit','input:button','input:submit'].indexOf(
	    element.tagName.toLowerCase()+':'+(element.type||'')) >= 0;
	}
	
	function inferEventType(element) {
	  if (isCommand(element)) return 'click';
	  return 'click';
	}
	
	function inferEventName(element) {
	  if (isCommand(element)) return element.innerText || element.value;
	  return element.id || element.name || element.tagName;
	}
	
	function isProperty(name) {
	  return name.substr(0, 9) === 'analytics' && ['On', 'Event', 'If', 'Properties', 'EventType'].indexOf(name.substr(9)) === -1;
	}
	
	function propertyName(name) {
	  var s = name.slice(9); // slice off the 'analytics' prefix
	  if (typeof s !== 'undefined' && s!==null && s.length > 0) {
	    return s.substring(0, 1).toLowerCase() + s.substring(1);
	  }
	  else {
	    return s;
	  }
	}
	})(angular);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(42);
	module.exports = 'angulartics';


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 88 */
87,
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".main-content{height:calc(100% - 60px);height:-webkit-calc(100% - 60px)}", ""]);
	
	// exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".footer{background-color:#1b1b1b;color:#fff;padding:3% 0}.footer .footerContent{max-width:600px}.footer .footerContent .logo-knowin{width:300px}.footer .footerContent .logo-thesafezone{width:60px}.footer .footerContent .navigation-links{font-size:19px}.footer .footerContent .copyright{font-size:15px}.footer a{text-decoration:none;color:#fff;cursor:pointer}#cookies_dialog a.more_info{text-decoration:none;color:inherit}#cookies_dialog a.more_info:hover{text-decoration:underline;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "#forgotPasswordContainer{background-color:#fff;max-width:450px;margin:5px;padding:15px 10px 30px;border-radius:15px;-ms-flex-preferred-size:auto!important}#forgotPasswordContainer #submit{padding-left:10px;padding-right:10px}", ""]);
	
	// exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".meredicte-logo:hover{cursor:pointer}.meredicte-logo .logo-image{height:54px;line-height:32px}.meredicte-logo .logo-text{color:#000}a.meredicte-logo{text-decoration:none}.logo-image{margin-left:5px;margin-right:5px}md-nav-bar{min-height:50px}md-toolbar.md-default-theme:not(.md-menu-toolbar),md-toolbar:not(.md-menu-toolbar){background-color:#fff;min-height:49px}#tsz-header .md-nav-bar{height:60px;padding-top:4px}#tsz-header .signup,#tsz-header .user-btn{margin:0 5px;padding-left:10px;border-left:thin solid rgba(0,0,0,.15)}#tsz-header .user-btn.xs{min-width:inherit!important}#tsz-header .user-bubble{position:fixed;top:5px;right:6px}#tsz-header .user-name{color:rgba(0,0,0,.54);text-transform:none}#tsz-header .user-logo{max-height:40px;max-width:200px;margin-left:5px}#tsz-header a.contract{text-decoration:none;color:#000}#tsz-header a.contract:hover{text-decoration:underline}#tsz-header tsz-contact>a{text-decoration:none;color:rgba(0,0,0,.54)}#tsz-header #user_menu{margin-top:5px}a.menu_help,a.menu_help:active,a.menu_help:hover,a.menu_help:visited{text-decoration:none;color:inherit}", ""]);
	
	// exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".myGrid{width:100%;min-width:1024px}.myGrid,.ui-grid,.ui-grid-viewport{height:auto!important}.ui-grid-pager-panel{position:relative!important;padding-top:0}.ui-grid-pager-container,.ui-grid-pager-count-container{margin-top:12px}.ui-grid-pager-control input{height:23px;padding:0 10px}.grid-align-center{text-align:center}.grid-align-right{text-align:right}input[type=text].ui-grid-filter-input{padding:0}.report-link{color:#000;text-decoration:none;cursor:pointer}.report-link:hover{font-weight:700}md-card.csv{max-width:500px;padding-top:20px}#commentsFilter{margin:2px 0 0}md-content.generalSearch{padding:8px 8px 0}#enableFiltersBtn{padding:4px}#home md-dialog{max-width:500px}", ""]);
	
	// exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".slick-prev{left:5px;z-index:1}.slick-next{right:18px}.slick-next:before,.slick-prev:before{font-size:35px}@media only screen and (min-width:480px){.slick-dots,.slick-next,.slick-prev{display:none}}.slick-dots{position:absolute;bottom:1%;display:block;background-color:hsla(0,0%,100%,.9);width:150px!important;margin-left:-75px;left:50%;border-radius:5px;padding-bottom:3px}.slick-dotted.slick-slider{margin-bottom:0!important}.slick-slider img{width:100%;min-height:10em;height:100%}.photo{background-size:100%;background-position:50%;background-repeat:no-repeat;padding-bottom:5%;will-change:transform}.photo:before{content:\"\";display:block}.wrapper{margin-right:auto;margin-left:auto;max-width:45em;width:90%}.landing-band{padding:10px}.band.gray{background-color:#eee}.band.white{background-color:#fff}.meredicte.band,.thesafezone.band{font-size:19px;line-height:1.5;padding-top:30px;padding-bottom:30px}.meredicte.band .limit-width,.thesafezone.band .limit-width{max-width:1024px}.thesafezone.band .title{font-size:30px;font-weight:500;margin-bottom:15px}.thesafezone.band .subtitle{color:#555;font-size:30px;font-weight:400;max-width:650px;text-align:center}.thesafezone.band img{max-width:400px}.thesafezone.band .band-content{text-align:justify}@media (min-width:960px){.thesafezone.band .band-content{max-width:530px}}@media (max-width:960px){.thesafezone.band .band-content{max-width:700px;margin:0 auto}}.meredicte.band .subtitle{color:#555;font-size:30px;font-weight:400;max-width:840px;text-align:center}.meredicte.band .logo{height:100px;margin-bottom:35px}.mt10{margin-top:10px}.overview .overview-content{padding:10px}.overview .logo{height:100px;margin-top:50px;margin-bottom:35px}.overview .title{margin-bottom:25px;font-weight:700;font-size:1.4em}.overview .description{max-width:400px;margin-bottom:70px}.overview.thesafezone{background-color:#1b1b1b;color:#fff}.overview.meredicte{background-color:#fff;color:#1b1b1b}.overview.thesafezone>a{color:#fff}.overview.meredicte>a{color:#1b1b1b}a.overview-content{text-decoration:none}.landing-band{background-color:#fff}.landing-band .meredicte{background-color:#eee;color:#1b1b1b}.landing-band .band-content{padding:10px}.landing-band .logo{height:50px;margin-bottom:15px}.landing-band .title{margin-top:70px;margin-bottom:10px;font-weight:700;font-size:1.4em}.landing-band .description,.landing-band .features{max-width:600px}.landing-band .features .feature{margin-top:20px}.landing-band .features .feature .item-img{height:50px}.landing-band .features .feature .item-description{margin-left:35px}.landing-band img.full-width{width:100%}.landing-band img.full-width.cheque{width:100%;max-width:300px}.landing-band img.full-width.cheque:hover{cursor:pointer}.landing-band a{text-decoration:underline;color:#1b1b1b;cursor:pointer}a.read-more{margin-top:10px;border:1px solid #000;padding:5px 25px;text-decoration:none;color:#000}a.read-more:hover{text-decoration:underline}.landing-band.gray,gray{background-color:#eee;color:#1b1b1b}", ""]);
	
	// exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "#loginContainer{background-color:#fff;max-width:450px;margin:5px;padding:15px 10px 30px;border-radius:15px;-ms-flex-preferred-size:auto!important}#loginContainer #submit{padding-left:40px;padding-right:40px}.login-background{min-height:85vh;padding:10px 0 30px;background-image:url(" + __webpack_require__(29) + ");background-repeat:no-repeat;background-size:cover}", ""]);
	
	// exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "#landing-meredite .menu{background-color:#fff;border-bottom:#eee;border-bottom-style:solid;border-bottom-width:1px}#landing-meredite .menu a{text-decoration:none;padding:30px 0;color:#1b1b1b;font-size:1.4em;background-color:#fff;cursor:pointer}#landing-meredite .menu a.selected{color:#fff;background-color:#1b1b1b}#landing-meredite .menu a.cte{background-color:#eee}#landing-meredite .menu a.cte:hover{background-color:#1b1b1b;color:#fff}#landing-meredite .menu a.selected:hover{color:#1b1b1b}#landing-meredite .menu a:hover{background-color:#eee}#landing-meredite .section{padding:3%;background-color:#fff}@media (min-width:960px){#landing-meredite .section .padding-left{padding-left:30px}}@media (min-width:960px){#landing-meredite .section .padding-right{padding-right:30px}}@media (min-width:960px){#landing-meredite .section .padding-top{padding-top:30px}}@media (min-width:960px){#landing-meredite .section .padding-bottom{padding-bottom:30px}}#landing-meredite .section a{text-decoration:underline;color:#1b1b1b;cursor:pointer}#landing-meredite .section-1 .logo-meredicte{width:200px}#landing-meredite .section-2{background-color:#1b1b1b;color:#fff}#landing-meredite .section-2 a{color:#fff}#landing-meredite .section-3 img,#landing-meredite .section-usages img{max-width:500px;width:100%}#landing-meredite .section-3 .usage,#landing-meredite .section-usages .usage{margin-top:30px}#landing-meredite .section-4{font-size:1.4em;width:100%;margin:0;padding:0;background-image:url(" + __webpack_require__(328) + ");background-size:cover;background-repeat:no-repeat;background-position:100%;height:400pxpx}@media (max-width:600px){#landing-meredite .section-4{background-image:url(" + __webpack_require__(329) + ")}}#landing-meredite .section-4 .description{width:700px;text-align:left;padding:30px}@media (max-width:960px){#landing-meredite .section-4 .description{position:relative;color:#000;background-color:hsla(0,0%,100%,.3);width:100%}}#landing-meredite .section-4 .title{font-weight:700}#landing-meredite .section-who{background-color:#eee}#landing-meredite .section-who img{width:100%}#landing-meredite .section-cte img{max-width:250px}#landing-meredite .section-cte a{text-decoration:underline;color:#1b1b1b;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "#passwordRecoveryContainer{background-color:#fff;max-width:450px;margin:5px;padding:15px 10px 30px;border-radius:15px;-ms-flex-preferred-size:auto!important}#passwordRecoveryContainer #submit{padding-left:40px;padding-right:40px}", ""]);
	
	// exports


/***/ }),
/* 98 */
87,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "[role=tabpanel]{transition:none}.me-notification-container{position:absolute;top:0}.me-notification-badge{display:block;padding:0 5px;height:16px;line-height:16px;text-align:center;font-weight:700;font-size:11px;color:#fff;background-color:#824bb0;border-radius:50px}tsz-progress-bar md-slider-container{padding-top:30px}.inputfile{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.inputfile+label{cursor:pointer}.no-js .inputfile+label{display:none}", ""]);
	
	// exports


/***/ }),
/* 100 */
87,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "#signUpContainer{background-color:#fff;max-width:450px;margin:5px;padding:15px 10px 30px;border-radius:15px;-ms-flex-preferred-size:auto!important}#signUpContainer md-input-container{margin:5px 0}#signUpContainer #submit{padding-left:40px;padding-right:40px}.login-background{min-height:85vh;width:100%;padding:10px 0 30px;background-image:url(" + __webpack_require__(29) + ");background-repeat:no-repeat;background-size:cover}.link{color:#1b95e0;text-decoration:none;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 102 */
87,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "#landing-thesafezone .menu{background-color:#fff}#landing-thesafezone .menu a{text-decoration:none;padding:30px 0;color:#1b1b1b;font-size:1.4em;background-color:#fff;cursor:pointer}#landing-thesafezone .menu a.training{background-color:#eee}#landing-thesafezone .menu a.selected,#landing-thesafezone .menu a.training:hover{background-color:#1b1b1b;color:#fff}#landing-thesafezone .menu a.selected:hover{color:#1b1b1b}#landing-thesafezone .menu a:hover{background-color:#eee}#landing-thesafezone .section ul li{margin-bottom:20px}#landing-thesafezone .section{padding:3%;background-color:#fff}#landing-thesafezone .section a{color:#1b1b1b}#landing-thesafezone .section hr{margin-bottom:20px}#landing-thesafezone .section .padding-left{padding-left:30px}#landing-thesafezone .section .padding-right{padding-right:30px}#landing-thesafezone .section .padding-top{padding-top:30px}#landing-thesafezone .section .padding-bottom{padding-bottom:30px}#landing-thesafezone .section-1{color:#fff;font-size:1.4em;width:100%;margin:0;padding:0;background-image:url(" + __webpack_require__(337) + ");background-size:cover;background-repeat:no-repeat;background-position:100%;height:256px}@media (max-width:600px){#landing-thesafezone .section-1{background-image:url(" + __webpack_require__(338) + ")}}#landing-thesafezone .section-1 .description{max-width:600px;text-align:center;padding:30px}@media (max-width:600px){#landing-thesafezone .section-1 .description{color:#000}}#landing-thesafezone .section-1 img{max-width:100%}#landing-thesafezone .section-reports{background-color:#fff;color:#1b1b1b}#landing-thesafezone .section-reports img{max-width:300px}#landing-thesafezone .section-reports hr{width:60%}#landing-thesafezone .section-reports .description{display:table}#landing-thesafezone .section-reports .login{display:table-row;text-align:center}#landing-thesafezone .section-services{background-color:#eee;color:#1b1b1b}#landing-thesafezone .section-services .description{max-width:600px}#landing-thesafezone .section-services img{width:100%}#landing-thesafezone .section-services hr{width:60%}#landing-thesafezone .section-training{background-color:#fff;border-bottom:#eee;border-bottom-style:solid;border-bottom-width:2px;color:#1b1b1b}#landing-thesafezone .section-training img{width:100%}#landing-thesafezone .section-training hr{width:60%}#landing-thesafezone .section-training .description{padding:20px}#landing-thesafezone .section-5 hr{width:60%}", ""]);
	
	// exports


/***/ }),
/* 104 */
87,
/* 105 */,
/* 106 */
22,
/* 107 */
22,
/* 108 */
22,
/* 109 */
22,
/* 110 */
22,
/* 111 */
22,
/* 112 */
22,
/* 113 */
22,
/* 114 */
22,
/* 115 */
22,
/* 116 */
22,
/* 117 */
22,
/* 118 */
22,
/* 119 */
22,
/* 120 */
22,
/* 121 */
22,
/* 122 */
22,
/* 123 */
22,
/* 124 */
22,
/* 125 */
22,
/* 126 */
22,
/* 127 */
/***/ (function(module, exports) {

	module.exports = "<span class=reportActions> <i ng-click=$ctrl.edit() class=material-icons> &#xE3C9; <md-tooltip>Editar</md-tooltip> </i> <i ng-click=$ctrl.delete($event) class=material-icons> &#xE872; <md-tooltip>Eliminar</md-tooltip> </i> </span> ";

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	module.exports = "<form name=companySettingsForm novalidate ng-submit=$ctrl.updateCompanySettings(form)> <md-card class=tszCard> <md-card-title> <md-card-title-text> <span class=md-headline>Detalles de la compañía</span> </md-card-title-text> </md-card-title> <md-card-content> <div layout-gt-md=row layout-align=\"top end\" layout-margin> <div layout=column flex> <md-input-container class=md-block flex-gt-md> <label>Nombre</label> <input ng-model=$ctrl.company.name /> </md-input-container> <md-input-container class=md-block flex-gt-md> <label>CIF</label> <input name=cif ng-model=$ctrl.company.cif required md-auto-hide=false /> <div ng-messages=companySettingsForm.cif.$error ng-show=companySettingsForm.cif.$invalid> <div ng-message=required> Debes rellenar el CIF para poder generar informes para tus proyectos. </div> </div> </md-input-container> </div> <div layout=column layout-align=\"center center\" layout-margin> <button type=file ngf-select=$ctrl.uploadFile($file) accept=image/* ngf-max-height=2000 ngf-max-size=2MB> Subir logo </button> <img class=company_logo ng-src=\"{{ $ctrl.company.logo }}\"/> </div> </div> </md-card-content> <md-card-actions layout=row layout-align=\"end center\"> <md-button type=submit>Guardar</md-button> </md-card-actions> </md-card> </form> ";

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <form ng-cloak> <md-toolbar class=blue-toolbar> <div class=md-toolbar-tools> <h2>Editar suscripción</h2> <span flex></span> <md-icon class=material-icons aria-label=Cerrar ng-click=close() style=cursor:pointer>close</md-icon>  </div> </md-toolbar> <md-dialog-content> <div layout=column layout-margin layout-padding> <md-input-container class=md-block flex-gt-sm> <label>Tipo de licencia</label> <md-select ng-model=subscription.plan> <md-option ng-repeat=\"p in plans\" value=\"{{ p }}\">{{ p }}</md-option> </md-select> </md-input-container> <div layout-gt-xs=row> <md-input-container> <label>Fecha inicio</label> <md-datepicker ng-model=subscription.startDate name=dateField md-min-date=minDate md-max-date=maxDate></md-datepicker> </md-input-container> <md-input-container> <label>Fecha fin</label> <md-datepicker ng-model=subscription.endDate name=dateField md-min-date=minDate md-max-date=maxDate></md-datepicker> </md-input-container> </div> <div layout-gt-xs=row> <md-input-container> <label>Fecha pago</label> <md-datepicker ng-model=subscription.paymentDueDate name=dateField></md-datepicker> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Importe (&euro;)</label> <input ng-model=subscription.paymentDue type=number min=0 /> </md-input-container> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=close() class=md-raised>Cerrar</md-button> <md-button ng-click=save() md-no-ink class=\"md-raised md-primary\">Guardar</md-button> </md-dialog-actions> </form> </md-dialog> ";

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = "<md-list id=team-list> <md-subheader class=md-no-sticky>Suscripciones:</md-subheader> <md-list-item ng-repeat=\"s in $ctrl.subscriptions\" class=md-2-line> <img ng-src={{::$ctrl.getAvatar($index)}} class=md-avatar /> <div class=md-list-item-text> <h3>{{ s.plan }}</h3> <p>Válidez: {{ s.startDate | date:'dd-MM-yyyy' }} a {{ s.endDate | date:'dd-MM-yyyy' }}</p> <p>Creada por: {{ s.user }}</p> <md-icon aria-label=Editar class=\"md-secondary material-icons\" ng-click=$ctrl.edit(s)>edit <md-tooltip>Editar suscripción</md-tooltip> </md-icon> <md-icon aria-label=Eliminar class=\"md-secondary material-icons\" ng-click=\"$ctrl.showDeleteConfirm(s, $event)\">delete <md-tooltip>Eliminar suscripción</md-tooltip> </md-icon> </div> <md-button class=\"md-secondary md-icon-button\" ng-if=\"u.state=='INVITED'\" ng-click=doSecondaryAction($event) aria-label=\"Reenviar invitación\"> <md-icon aria-label=\"Reenviar invitación\" class=material-icons>send</md-icon> <md-tooltip>Reenviar invitación</md-tooltip> </md-button> </md-list-item> <div layout-margin> <md-button layout=row layout-align=\"center center\" ng-hide=\"$ctrl.subscriptions.length>0\" ng-click=$ctrl.create()> <i class=material-icons>add_box</i> <span style=padding-left:5px>Crear nueva</span> </md-button> </div> </md-list> ";

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog id=contact-dialog> <form ng-cloak name=contactForm ng-submit=send(contactForm)> <md-toolbar class=gray-toolbar> <div class=md-toolbar-tools> <h2>CONTACTO</h2> <span flex></span> <md-icon class=material-icons aria-label=Cerrar ng-click=close() style=cursor:pointer>close</md-icon>  </div> </md-toolbar> <md-dialog-content layout-padding> <md-content class=md-no-momentum layout=column layout-margin> <md-input-container class=md-block flex-gt-md> <label>Nombre</label> <md-icon aria-label=Nombre class=material-icons>person</md-icon> <input ng-model=message.name type=text> </md-input-container> <md-input-container class=md-block flex-gt-md> <md-icon aria-label=Teléfono class=material-icons>phone</md-icon> <input ng-model=message.phone type=text placeholder=Teléfono> </md-input-container> <md-input-container class=md-block flex-gt-md> <md-icon aria-label=Email class=material-icons>email</md-icon> <input ng-model=message.email type=email placeholder=\"Email (required)\" ng-required=true> </md-input-container> <md-input-container class=md-block flex-gt-md> <label>Mensaje</label> <md-icon aria-label=Mensaje class=material-icons>chat_bubble</md-icon> <textarea ng-model=message.message md-maxlength=1000 rows=3 md-select-on-focus></textarea> </md-input-container> <div layout=row layout-align=\"end center\" flex-gt-md> <md-input-container class=md-block> <md-checkbox id=privacy_policy name=privacy_policy ng-model=privacy_policy ng-true-value=\"'true'\" ng-false-value=\"'false'\" ng-required=true ng-pattern=\"'true'\" required> Acepto la política de privacidad </md-checkbox> <div ng-messages=contactForm.privacy_policy.$error class=gc-error-alert role=alert> <div ng-message=required>Debe aceptar la política de privacidad</div> </div> </md-input-container> </div> </md-content> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=close()> Cancelar </md-button> <md-button layout=row layout-align=center class=\"md-raised md-primary\" type=submit ng-disabled=contactForm.$invalid> <span ng-show=!$ctrl.loading>Enviar</span> <md-progress-circular ng-show=$ctrl.loading md-mode=indeterminate md-diameter=20 class=md-accent></md-progress-circular> </md-button> </md-dialog-actions> </form> </md-dialog> ";

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	module.exports = "<a ng-click=$ctrl.showContactForm($event) class=contact>{{ $ctrl.label }}</a> ";

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-toolbar class=gray-toolbar> <div class=md-toolbar-tools> <md-icon class=material-icons style=color:#000;margin-right:5px>fingerprint</md-icon> <h2>Importar desde CSV</h2> <span flex></span> <md-icon class=material-icons aria-label=Cerrar ng-click=close() style=cursor:pointer>close</md-icon>  </div> </md-toolbar> <md-dialog-content> <div id=calculator class=md-dialog-content> <form name=csvForm> <div layout=row layout-align=\"center center\"> <md-input-container class=\"md-block csv\"> <label>Código Seguro de Verificación</label> <input name=csv ng-model=csv placeholder=CSV required ng-pattern=/^[a-zA-Z0-9]{26}$/ maxlength=26 md-maxlength=26> <div ng-messages=csvForm.csv.$error role=alert multiple=multiple> <div ng-message=required class=my-message>Debes especificar un código de verificación.</div> <div ng-message=pattern class=my-message>El csv introducido no es válido</div> </div> <div ng-if=serverError style=color:#dd2c00;font-size:12px>{{ serverError }}</div> </md-input-container> <div layout=row layout-align=\"center center\"> <md-button ng-disabled=csvForm.$invalid ng-click=importCsv(csv)>Importar</md-button> </div> </div> </form> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=close()> Cerrar </md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	module.exports = "<md-button aria-label=Importar class=\"md-fab md-raised md-mini\" ng-click=$ctrl.showModal($event)> <md-tooltip>Importar CSV</md-tooltip> <md-icon aria-label=Importar class=material-icons>fingerprint</md-icon> </md-button> ";

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	module.exports = "<md-progress-circular md-mode=indeterminate class=loading></md-progress-circular> ";

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	module.exports = "<span class=\"tsz-notification-badge-total warn\" ng-show=$ctrl.total>{{$ctrl.total}}</span> <span class=\"tsz-notification-badge-total ok\" ng-show=\"!$ctrl.total && !$ctrl.hideWhenOk\">&#10003;</span> ";

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <form ng-cloak> <md-toolbar class=gray-toolbar> <div class=md-toolbar-tools> <h2>Calculadora de precios</h2> <span flex></span> <md-icon class=material-icons aria-label=Cerrar ng-click=close() style=cursor:pointer>close</md-icon>  </div> </md-toolbar> <md-dialog-content> <div id=calculator class=md-dialog-content> <div layout=column layout-margin> <div> <md-input-container class=md-block flex-gt-sm> <label>Uso del edificio</label> <md-select ng-model=report.building_usage ng-change=refreshPricing()> <md-option class=h32 ng-repeat=\"(key, value) in BUILDING_USAGE\" value={{key}}>{{value.name}}</md-option> </md-select> </md-input-container> </div> <div> <md-input-container class=md-block flex-gt-sm> <label>Tipo de diseño</label> <md-select ng-model=report.design_type ng-change=refreshPricing()> <md-option ng-repeat=\"(key, value) in PROJECT_TYPE\" value={{key}}>{{value.name}}</md-option> </md-select> </md-input-container> </div> <div> <md-input-container class=md-block flex-gt-sm> <label>Superficie edificación (m<sup>2</sup>)</label> <input ng-model=report.area ng-change=refreshPricing() type=number min=0 /> </md-input-container> </div> </div> <div class=price layout=row layout-align=center> <h1>{{ price | number : 0 }} <span>&euro;</span></h1> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=close()> Cerrar </md-button> </md-dialog-actions> </form> </md-dialog> ";

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports = "<span ng-click=$ctrl.showCalculator($event)>Calculadora de precios</span> ";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div layout-margin class=plans> <div class=container> <div class=time-selector layout=row layout-align=\"center center\"> <span class=\"option box left\" ng-class=\"{ 'selected': $ctrl.monthly }\" ng-click=$ctrl.setMonthly(true)>Mensual</span> <span class=\"option box right\" ng-class=\"{ 'selected': !$ctrl.monthly }\" ng-click=$ctrl.setMonthly(false)>Anual</span> </div> <div layout=row layout-align=\"center center\" ng-bind=$ctrl.promotionalMessage></div> <div layout-gt-sm=row layout-align=\"center start\"> <div layout=column flex> <md-card class=\"pricing style-2 basic\"> <div layout=row layout-align=\"center center\" class=\"plan-title waves-effect waves-block waves-light teal\"> <img class=subscription-logo src=" + __webpack_require__(316) + " /> <h5 class=white-text> <span class=plan>BÁSICO</span> </h5> </div> <div class=\"price waves-effect waves-block waves-light teal lighten-1\"> <h4 class=white-text> <span class=basic>Pago por informe</span> </h4> </div> <div class=card-content> <md-list class=collection> <md-list-item> <span flex>Usuario <b>individual</b></span> </md-list-item> <md-list-item> <span><b>Edición</b> y <b>gestión</b> de proyectos</span> </md-list-item> <md-list-item> <span>Generación de <b>informes Meredicte</b></span> </md-list-item> <md-list-item> <span>Diseño <b>prestacional/prescriptivo</b></span> </md-list-item> <md-list-item> <span>Sin limitación en superficie</span> </md-list-item> </md-list> <div layout=row> <md-button class=plan-signup-btn flex> <tsz-price-calculator flex></tsz-price-calculator> </md-button> </div> </div> </md-card> </div> <div layout=column flex> <md-card class=\"pricing style-2 professional\"> <div layout=row layout-align=\"center center\" class=\"plan-title waves-effect waves-block waves-light teal\"> <img class=subscription-logo src=" + __webpack_require__(322) + " /> <h5 class=white-text> <span class=plan>PROFESIONAL</span> </h5> </div> <div class=\"price waves-effect waves-block waves-light teal lighten-1\"> <h4 class=white-text> <span class=amount ng-show=!$ctrl.monthly ng-bind=\"$ctrl.plans['PROFESSIONAL'].yearlyPrice\"></span> <span class=period ng-show=!$ctrl.monthly>&euro;/año</span> <span class=amount ng-show=$ctrl.monthly ng-bind=\"$ctrl.plans['PROFESSIONAL'].monthlyPrice\"></span> <span class=period ng-show=$ctrl.monthly>&euro;/mes</span> </h4> </div> <div class=card-content> <md-list class=collection> <md-list-item> <span flex>Usuario <b>individual</b></span> </md-list-item> <md-list-item> <span><b>Edición</b> y <b>gestión</b> de proyectos</span> </md-list-item> <md-list-item> <span>Generación de <b>informes Meredicte</b></span> </md-list-item> <md-list-item> <span>Diseño <b>prestacional/prescriptivo</b></span> </md-list-item> <md-list-item> <span flex>Superficie máxima de <b><span ng-bind=\"$ctrl.plans['PROFESSIONAL'].maxArea\">2000</span> m<sup>2</sup></b></span> <md-icon class=material-icons> info_outline <md-tooltip>Resto según tarifa</md-tooltip> </md-icon> </md-list-item> <md-list-item> <span><b>Comparación</b> de proyectos</span> </md-list-item> <md-list-item> <span><b>Visualización</b> gráfica de resultados</span> </md-list-item> <md-list-item> <span flex><b ng-bind=\"$ctrl.plans['PROFESSIONAL'].maxReports\">5</b> informes al mes incluidos</span> <md-icon class=material-icons> info_outline <md-tooltip>Resto según tarifa</md-tooltip> </md-icon> </md-list-item> </md-list> <div layout=row> <md-button class=plan-signup-btn flex ng-show=$ctrl.showPurchaseButton() ng-click=\"$ctrl.subscribe('PROFESSIONAL')\"> <span ng-hide=\"$ctrl.activeSubscription.plan=='PROFESSIONAL'\" id=start-now-starter class=\"btn-large waves-effect waves-block waves-light no-margin white-text\">{{'SUBSCRIPTIONS.PURCHASE' | translate}}</span> </md-button> <md-button class=plan-signup-btn flex ng-show=$ctrl.showProfessionalButton()> <span ng-show=\"$ctrl.activeSubscription.plan=='PROFESSIONAL'\">Contratada hasta el {{ $ctrl.activeSubscription.endDate | date : \"dd/MM/yyyy\" }}</span> </md-button> </div> </div> </md-card> </div> <div layout=column flex> <md-card class=\"pricing style-2 enterprise\"> <div layout=row layout-align=\"center center\" class=\"plan-title waves-effect waves-block waves-light teal\"> <img class=subscription-logo src=" + __webpack_require__(318) + " /> <h5 class=white-text> <span class=plan>ENTERPRISE</span> </h5> </div> <div class=\"price waves-effect waves-block waves-light teal lighten-1\"> <h4 class=white-text> <span class=amount ng-show=!$ctrl.monthly ng-bind=\"$ctrl.plans['ENTERPRISE'].yearlyPrice\"></span> <span class=period ng-show=!$ctrl.monthly>&euro;/año</span> <span class=amount ng-show=$ctrl.monthly ng-bind=\"$ctrl.plans['ENTERPRISE'].monthlyPrice\"></span> <span class=period ng-show=$ctrl.monthly>&euro;/mes</span> </h4> </div> <div class=card-content> <md-list class=collection> <md-list-item> <span flex><b>Multiusuario</b></span> </md-list-item> <md-list-item> <span><b>Edición</b> y <b>gestión</b> de proyectos</span> </md-list-item> <md-list-item> <span>Generación de <b>informes Meredicte</b></span> </md-list-item> <md-list-item> <span>Diseño <b>prestacional/prescriptivo</b></span> </md-list-item> <md-list-item> <span><b>Sin limitación</b> en superficie</span> </md-list-item> <md-list-item> <span><b>Comparación</b> de proyectos</span> </md-list-item> <md-list-item> <span><b>Visualización</b> gráfica de resultados</span> </md-list-item> <md-list-item> <span><b>Sin limitación</b> número informes</span> </md-list-item> </md-list> <div layout=row> <md-button class=plan-signup-btn flex ng-show=$ctrl.showPurchaseButton() ng-click=\"$ctrl.subscribe('ENTERPRISE')\"> <span ng-hide=\"$ctrl.activeSubscription.plan=='ENTERPRISE'\" id=start-now-starter class=\"btn-large waves-effect waves-block waves-light no-margin white-text\">{{'SUBSCRIPTIONS.PURCHASE' | translate}}</span> </md-button> <md-button class=plan-signup-btn flex ng-show=$ctrl.showEnterpriseButton()> <span ng-show=\"$ctrl.activeSubscription.plan=='ENTERPRISE'\">Contratada hasta el {{ $ctrl.activeSubscription.endDate | date : \"dd/MM/yyyy\" }}</span> </md-button> <tsz-contact ng-show=$ctrl.showProfessionalButton() class=\"plan-signup-btn md-button\" flex label=\"Contacta para contratar\"></tsz-contact> </div> </div> </md-card> </div> </div> <div layout=row layout-align=\"center center\" ng-show=$ctrl.showCancelButton()> <span class=cancel-subscription>La suscripción se renovará de forma automática el {{ $ctrl.activeSubscription.endDate | date : \"dd/MM/yyyy\" }}. Si lo desea, puede cancelar su renovación pulsando el siguiente botón:</span> <md-button class=cancel-subscription ng-click=$ctrl.cancelSubscription()> <span ng-show=!$ctrl.cancellingSubscription>Cancelar</span> <md-progress-circular ng-show=$ctrl.cancellingSubscription md-mode=indeterminate md-diameter=20 class=md-accent></md-progress-circular> </md-button> </div> <div layout=row layout-padding layout-align=\"center center\"> <tsz-contact label=\"Contacta con nosotros para un asesoramiento personalizado\"></tsz-contact> </div> </div> </div> ";

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	module.exports = "<md-slider-container> <md-slider ng-model=$ctrl.value ng-disabled=true ng-readonly=true step=1 min=0 max={{$ctrl.max}} md-discrete aria-label=Progreso></md-slider> <span>{{$ctrl.value}}/{{$ctrl.max}}</span> </md-slider-container> ";

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	module.exports = "<span class=reportActions> <i ng-click=$ctrl.edit() class=material-icons> &#xE3C9; <md-tooltip>Editar</md-tooltip> </i> <i ng-click=$ctrl.download() class=material-icons ng-class=\"{ 'hidden': !$ctrl.report.downloadable }\"> &#xE2C0; <md-tooltip>Descargar</md-tooltip> </i> <i ng-click=$ctrl.export() class=material-icons> &#xE2C4; <md-tooltip>Exportar</md-tooltip> </i> <i ng-click=$ctrl.duplicate() class=material-icons> &#xE14D; <md-tooltip>Duplicar</md-tooltip> </i> <i ng-click=$ctrl.delete($event) class=material-icons> &#xE872; <md-tooltip>Eliminar</md-tooltip> </i> </span> ";

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	module.exports = "<md-bottom-sheet class=md-grid layout=column> <div layout=row layout-align=\"center center\" ng-cloak> <h4>Proyecto \"<i>{{ $ctrl.report.name }}</i>\"</h4> </div> <div ng-cloak> <md-list flex layout=row layout-align=\"center center\"> <md-list-item> <div> <md-button class=md-grid-item-content ng-click=$ctrl.edit()> <md-icon>edit</md-icon> <div class=md-grid-text>Editar</div> </md-button> </div> </md-list-item> <md-list-item ng-show=$ctrl.report.downloadable> <div> <md-button class=md-grid-item-content ng-click=$ctrl.download()> <md-icon>cloud_download</md-icon> <div class=md-grid-text>Descargar</div> </md-button> </div> </md-list-item> <md-list-item> <div> <md-button class=md-grid-item-content ng-click=$ctrl.export()> <md-icon>file_download</md-icon> <div class=md-grid-text>Exportar</div> </md-button> </div> </md-list-item> <md-list-item> <div> <md-button class=md-grid-item-content ng-click=$ctrl.duplicate()> <md-icon>content_copy</md-icon> <div class=md-grid-text>Duplicar</div> </md-button> </div> </md-list-item> <md-list-item> <div> <md-button class=md-grid-item-content ng-click=$ctrl.delete($event)> <md-icon>delete</md-icon> <div class=md-grid-text>Eliminar</div> </md-button> </div> </md-list-item> </md-list> </div> </md-bottom-sheet> ";

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	module.exports = "<md-button id=report-settings ng-click=$ctrl.openBottomSheet()> <md-icon>more_vert</md-icon> <md-tooltip>Acciones</md-tooltip> </md-button> ";

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports = "<div ng-repeat=\"parameter in $ctrl.param.parameters\" class=tsz-report-param> <h5 class=param-header ng-class=\"{ 'm20': parameter.type=='input'}\"> {{ parameter.name }} - {{ parameter.title }} <span ng-hide=\"!parameter.header || parameter.title == parameter.header\">({{ parameter.header }})</span> <span ng-show=parameter.info_template class=option_info> <md-icon class=material-icons ng-click=$ctrl.showInfoDialog(parameter.name)> info_outline <md-tooltip>Ayuda</md-tooltip> </md-icon> </span> <span ng-show=parameter.notes1 class=option_info> <md-icon class=material-icons ng-click=\"$ctrl.showTextDialog(parameter.title, parameter.notes)\"> comment <md-tooltip>Notas</md-tooltip> </md-icon> </span> </h5> <div class=param-description ng-show=parameter.description>{{ parameter.description }}</div> <md-radio-group ng-if=parameter.options ng-model=$ctrl.report[parameter.name] ng-change=$ctrl.onParamChange(parameter.name) ng-show=parameter.options> <div ng-repeat=\"o in parameter.options\" class=row> <div flex layout=row layout-align=\"start start\"> <md-radio-button ng-value=o.name class=md-primary ng-disabled=!$ctrl.editable> {{ o.description }} </md-radio-button> <div ng-show=o.info class=option_info> <md-icon class=material-icons ng-click=$ctrl.showInfoDialog($event)> info_outline <md-tooltip>More info</md-tooltip> </md-icon> </div> </div> </div> </md-radio-group> <md-input-container ng-if=\"parameter.type=='input'\" class=m20> <input ng-model=$ctrl.report[parameter.name] ng-change=$ctrl.onParamChange() /> </md-input-container> <md-divider ng-if=\"$ctrl.showDivider(parameter, $last)\"></md-divider> </div> ";

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports = "<div id=report layout-fill> <tsz-loading ng-show=$ctrl.loading></tsz-loading> <div layout-gt-md=row flex layout-fill> <div flex-gt-md=75 flex-md layout=column id=left-column> <div layout=row layout-align=\"start center\"> <div class=project-title flex> <h2>{{$ctrl.report.name}}</h2> </div> <div layout=row> <md-fab-speed-dial md-direction=left class=\"md-scale secondary\" ng-class=\"{ 'md-hover-full': demo.hover }\"> <md-fab-trigger> <md-button aria-label=menu class=\"md-fab md-primary\"> <md-tooltip md-direction=top md-visible=tooltipVisible>Menu</md-tooltip> <md-icon aria-label=Menu class=material-icons>menu</md-icon> </md-button> </md-fab-trigger> <md-fab-actions> <md-button aria-label=Importar class=\"md-fab md-raised md-mini\" ng-show=!$ctrl.report.downloadable> <input type=file tsz-file-upload=$ctrl.importReport($fileContent) name=file-1[] id=file-1 class=\"inputfile inputfile-1\" data-multiple-caption=\"{count} files selected\" multiple=multiple /> <label for=file-1> <md-tooltip>Importar .tsz / .json</md-tooltip> <md-icon aria-label=Importar class=material-icons>file_upload</md-icon> </label> </md-button> <tsz-import-csv ng-show=!$ctrl.report.downloadable></tsz-import-csv> <md-button aria-label=Exportar class=\"md-fab md-raised md-mini\" ng-click=$ctrl.export() ng-show=$ctrl.completion> <md-tooltip>Exportar</md-tooltip> <md-icon class=material-icons>file_download</md-icon> </md-button> <md-button aria-label=Descargar class=\"md-fab md-raised md-mini\" ng-click=$ctrl.download($event) ng-show=$ctrl.report.downloadable> <md-tooltip>Descargar</md-tooltip> <md-icon class=material-icons>cloud_download</md-icon> </md-button> <md-button aria-label=Eliminar class=\"md-fab md-raised md-mini\" ng-click=$ctrl.delete($event) ng-show=$ctrl.report.id> <md-tooltip>Eliminar</md-tooltip> <md-icon class=material-icons>delete</md-icon> </md-button> <md-button aria-label=Eliminar class=\"md-fab md-raised md-mini\" ng-click=$ctrl.save(reportForm) ng-show=$ctrl.isSaveBtnEnabled()> <md-tooltip>Guardar</md-tooltip> <md-icon class=material-icons>save</md-icon> </md-button> </md-fab-actions> </md-fab-speed-dial> <md-button class=\"md-warn md-fab\" aria-label=\"Crear nuevo informe\" ng-click=$ctrl.save(reportForm) ng-disabled=!$ctrl.isSaveBtnEnabled()> <md-tooltip md-direction={{item.direction}} md-visible=tooltipVisible md-autohide=false> Guardar informe </md-tooltip> <md-icon aria-label=\"Guardar informe\" class=material-icons>save</md-icon> </md-button> </div> </div> <div class=progress-bar> <tsz-progress-bar max=$ctrl.total value=$ctrl.completion></tsz-progress-bar> </div> <md-card flex> <md-tabs flex md-dynamic-height=\"{{ !$ctrl.bigScreen }}\" md-border-bottom=\"\" layout-fill> <md-tab layout=column layout-fill> <md-tab-label> Proyecto <tsz-notification-badge total=\"$ctrl.emptyCounter['PROJECT']\"></tsz-notification-badge> <md-tooltip>Datos generales del proyecto</md-tooltip> </md-tab-label> <md-tab-body layout=column layout-fill> <div layout-padding> <div layout-gt-sm=row layout-margin> <md-input-container class=md-block flex-gt-sm> <label>Nombre del sector</label> <input ng-model=\"$ctrl.report['name']\" ng-change=\"$ctrl.onParamChange('PROJECT')\"/> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Código de proyecto</label> <input ng-model=\"$ctrl.report['code']\" ng-change=\"$ctrl.onParamChange('PROJECT')\"/> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Evaluador del riesgo</label> <input ng-model=\"$ctrl.report['evaluator']\" ng-change=\"$ctrl.onParamChange('PROJECT')\"/> </md-input-container> </div> <div layout-gt-sm=row layout-margin> <md-input-container class=md-block flex-gt-sm> <label>Provincia</label> <md-select ng-model=\"$ctrl.report['province']\" ng-change=\"$ctrl.onParamChange('PROJECT')\"> <md-option ng-repeat=\"p in $ctrl.provinces\" value={{p}}>{{p}}</md-option> </md-select> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Dirección del sector</label> <input ng-model=\"$ctrl.report['address']\" ng-change=\"$ctrl.onParamChange('PROJECT')\"/> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Código postal</label> <input ng-model=\"$ctrl.report['postal_code']\" ng-change=\"$ctrl.onParamChange('PROJECT')\" ng-pattern=/^[0-9]{5}$/ md-maxlength=5 md-maxlength=5 /> <div ng-messages=userForm.postalCode.$error role=alert multiple=multiple> <div ng-message=required class=my-message>Debes especificar un código postal válido.</div> <div ng-message=pattern class=my-message>Código postal no válido.</div> <div ng-message=md-maxlength class=my-message> El código postal debe tener 5 caracteres. </div> <div ng-message=md-minlength class=my-message> El código postal debe tener 5 caracteres. </div> </div> </md-input-container> </div> <div layout-gt-sm=row layout-margin> <md-input-container class=md-block flex-gt-sm> <label>Uso del edificio</label> <md-select ng-model=\"$ctrl.report['building_usage']\" ng-change=\"$ctrl.onParamChange('PROJECT'); $ctrl.refreshPricing()\"> <md-option class=h32 ng-repeat=\"(key, value) in $ctrl.BUILDING_USAGE\" value={{key}}>{{value.name}}</md-option> </md-select> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Tipo de diseño</label> <md-select ng-model=\"$ctrl.report['design_type']\" ng-change=\"$ctrl.onParamChange('PROJECT'); $ctrl.refreshPricing()\"> <md-option ng-repeat=\"(key, value) in $ctrl.PROJECT_TYPE\" value={{key}}>{{value.name}}</md-option> </md-select> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Superficie de edificación (m<sup>2</sup>)</label> <input ng-model=\"$ctrl.report['area']\" ng-change=\"$ctrl.onParamChange('PROJECT'); $ctrl.refreshPricing()\" type=number min=0 /> </md-input-container> </div> <div class=\"row comments\" layout-margin> <div class=tsz-report-param> <h5 class=param-header> Objeto del informe / Observaciones </h5> <div class=param-description>Indique la motivación para la creación de este informe</div> <md-input-container class=\"md-block comments\" flex-gt-sm> <textarea ng-model=\"$ctrl.report['comments']\" md-maxlength=4096 maxlength=4096 rows=1 md-select-on-focus ng-change=$ctrl.checkChanges()></textarea> </md-input-container> </div> </div> </div> </md-tab-body> </md-tab> <md-tab ng-repeat=\"param in $ctrl.reportSchema\"> <md-tab-label> {{ param.name }} <tsz-notification-badge total=$ctrl.emptyCounter[param.name]></tsz-notification-badge> <md-tooltip>{{ param.title }}</md-tooltip> </md-tab-label> <md-tab-body> <div class=md-padding> <h4> {{ param.name }}: {{ param.title }} </h4> <div ng-show=param.categories> <div ng-repeat=\"category in param.categories\"> <h5 ng-show=$ctrl.showCategory(category)>{{ category.name }} - {{ category.title }}</h5> <tsz-report-param report=$ctrl.report param=category version=$ctrl.meredicteVersion.name section=param editable=$ctrl.canEditParameters callback=$ctrl.onParamChange(param)></tsz-report-param> <div ng-repeat=\"subcategory in category.subcategories\"> <h5>{{ subcategory.name }} - {{ subcategory.title }}</h5> <tsz-report-param report=$ctrl.report param=subcategory version=$ctrl.meredicteVersion.name section=param editable=$ctrl.canEditParameters callback=$ctrl.onParamChange(param)></tsz-report-param> </div> </div> </div> <tsz-report-param report=$ctrl.report param=param version=$ctrl.meredicteVersion.name section=param editable=$ctrl.canEditParameters callback=$ctrl.onParamChange(param);></tsz-report-param> </div> </md-tab-body> </md-tab> </md-tabs> </md-card> </div> <div layout=column flex id=right-column> <div layout=row ng-show=$ctrl.showGenerateReportBox()> <md-card layout-padding flex> <div class=\"price waves-effect waves-block waves-light teal lighten-1\"> <h4 ng-show=$ctrl.price class=white-text> <span class=amount>{{ $ctrl.price }}</span> <span class=currency>&euro;</span> </h4> <md-button md-no-ink class=\"md-raised md-primary\" ng-disabled=$ctrl.changed ng-show=$ctrl.showGenerateReportBtn() ng-click=$ctrl.generate()> <span ng-show=!$ctrl.generatingReport>Generar informe</span> <md-progress-circular ng-show=$ctrl.generatingReport md-mode=indeterminate md-diameter=20 class=md-accent></md-progress-circular> <md-icon ng-show=\"$ctrl.price > 0\" class=material-icons>add_shopping_cart</md-icon> </md-button> </div> </md-card> </div> <md-card> <md-card-title> <md-card-title-text> <span class=chart-meredicte-version layout=row layout-align=\"center center\">{{ $ctrl.meredicteVersion.title }}</span> <span class=chart-headline layout=row layout-align=\"center center\">Nivel de Riesgo Global<span ng-if=$ctrl.canSeeCuantitativeResults>: {{ $ctrl.reportOutput['nrg'] | number:2 }}</span></span> <span class=\"chart-headline nrg\" layout=row layout-align=\"center center\" ng-style=$ctrl.nrgStyle>{{ $ctrl.reportOutput['nrg'] | nrg }}</span> </md-card-title-text> </md-card-title> <div class=chart-container> <canvas id=bar class=\"chart chart-bar\" style=margin:8px chart-data=$ctrl.mainChart.data chart-labels=$ctrl.mainChart.labels chart-series=$ctrl.mainChart.series chart-colors=$ctrl.mainChart.colors chart-dataset-override=$ctrl.mainChart.datasetOverride chart-options=$ctrl.chartOptions chart-legend=$ctrl.mainChart.legend.display> </canvas> </div> <div> <div class=out_params layout=column layout-align=\"center center\" ng-show=$ctrl.canSeeCuantitativeResults> <table> <tr class=l1> <th class=pp colspan=4> PP: <span> {{ $ctrl.reportOutput['pp'] | number:2 }} <md-tooltip ng-show=$ctrl.comparisonMode>{{ $ctrl.report['name'] }}</md-tooltip> </span> <span ng-show=$ctrl.comparisonMode style=font-weight:400> / {{ $ctrl.selectedReport['pp'] | number:2 }} <md-tooltip>{{ $ctrl.selectedReport['name'] }}</md-tooltip> </span> </th> </tr> <tr class=l2> <th class=pp ng-repeat=\"p in ['as', 't', 'co', 'ca']\">{{ p | uppercase }}</th> </tr> <tr class=l3 style=font-weight:700> <td align=center class=pp flex ng-repeat=\"p in ['as', 't', 'co', 'ca']\"> {{ $ctrl.reportOutput[p] | number:2 }} <md-tooltip md-direction=top ng-show=$ctrl.comparisonMode>{{ $ctrl.report['name'] }}</md-tooltip>  </td></tr> <tr class=l3 ng-show=$ctrl.comparisonMode> <td align=center class=pp flex ng-repeat=\"p in ['as', 't', 'co', 'ca']\"> {{ $ctrl.selectedReport[p] | number:2 }} <md-tooltip md-direction=top>{{ $ctrl.selectedReport['name'] }}</md-tooltip>  </td></tr> </table> <table> <tr class=l1> <th class=npg colspan=6> NPG: <span> {{ $ctrl.reportOutput['npg'] | number:2 }} <md-tooltip ng-show=$ctrl.comparisonMode>{{ $ctrl.report['name'] }}</md-tooltip> </span> <span ng-show=$ctrl.comparisonMode style=font-weight:400> / {{ $ctrl.selectedReport['npg'] | number:2 }} <md-tooltip md-direction=top>{{ $ctrl.selectedReport['name'] }}</md-tooltip> </span> </th> </tr> <tr class=l2> <th class=npg ng-repeat=\"p in ['npa', 'rfe', 'p', 'eo', 'ipci', 'ib']\">{{ p | uppercase }}</th> </tr> <tr class=l3 style=font-weight:700> <td align=center class=npg flex ng-repeat=\"p in ['npa', 'rfe', 'p', 'eo', 'ipci', 'ib']\"> {{ $ctrl.reportOutput[p] | number:2 }} <md-tooltip md-direction=top ng-show=$ctrl.comparisonMode>{{ $ctrl.report['name'] }}</md-tooltip>  </td></tr> <tr class=l3 ng-show=$ctrl.comparisonMode> <td align=center class=npg flex ng-repeat=\"p in ['npa', 'rfe', 'p', 'eo', 'ipci', 'ib']\"> {{ $ctrl.selectedReport[p] | number:2 }} <md-tooltip md-direction=top>{{ $ctrl.selectedReport['name'] }}</md-tooltip>  </td></tr> </table> </div> <div layout=column layout-align=\"center center\" ng-if=$ctrl.showCompareSelect> <md-input-container> <label>Comparar proyectos</label> <md-select ng-model=$ctrl.selectedReportRaw ng-change=$ctrl.compareProject()> <md-option value=null>- No comparar -</md-option> <md-option ng-repeat=\"report in $ctrl.reports\" value=\"{{ report }}\">{{ report['name'] }}</md-option> </md-select> </md-input-container> </div> </div></md-card> </div> </div> </div> <form id=redsysForm name=payForm method=post target=_top> <input type=hidden id=Ds_SignatureVersion name=Ds_SignatureVersion> <input type=hidden id=Ds_MerchantParameters name=Ds_MerchantParameters> <input type=hidden id=Ds_Signature name=Ds_Signature> </form> ";

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports = "<md-button class=\"md-fab md-fab-bottom-right docs-scroll-fab\" docs-scroll-class=scrolling ng-click=scrollTop() aria-label=\"Back to Top\" ng-show=$ctrl.atTop1()> <md-tooltip md-direction=top>Back to Top</md-tooltip> <md-icon class=material-icons>keyboard_arrow_up</md-icon> </md-button> ";

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	module.exports = "<md-list id=team-list> <md-subheader class=md-no-sticky>Tu equipo:</md-subheader> <md-list-item ng-repeat=\"u in $ctrl.team\" class=md-2-line> <img ng-src={{::$ctrl.getAvatar($index)}} class=md-avatar /> <div class=md-list-item-text> <h3>{{ u.name }}</h3> <h3> <md-icon aria-label=Email class=material-icons>email</md-icon> {{ u.email }} <span ng-if=\"u.email==$ctrl.email\">(Tú)</span> <span class=phone ng-if=u.phone><md-icon aria-label=Phone class=material-icons>phone</md-icon> {{ u.phone }}</span> </h3> <p>{{ u.state }}</p> </div> <md-button class=\"md-secondary md-icon-button\" ng-if=\"u.state=='INVITED'\" ng-click=$ctrl.resendInvite(u.email) aria-label=\"Reenviar invitación\"> <md-icon aria-label=\"Reenviar invitación\" class=material-icons>send</md-icon> <md-tooltip>Reenviar invitación</md-tooltip> </md-button> </md-list-item> </md-list> ";

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	module.exports = "<md-toast class=tsz-toast-container ng-class=\"{'error': toast.error, 'success': toast.success, 'warning': toast.warning}\"> <div class=md-toast-content> <i class=material-icons ng-if=toast.success>&#xE815;</i> <i class=material-icons ng-if=toast.warning>&#xE811;</i> <i class=material-icons ng-if=toast.error>&#xE814;</i> <span class=tsz-toast-msg role=alert aria-relevant=all aria-atomic=true> {{ ::toast.textContent }} </span> <md-button class=md-action ng-class=\"{'md-highlight': toast.highlightAction}\" ng-if=toast.action ng-click=toast.onButtonClick()>{{ ::toast.action }} </md-button> </div> </md-toast> ";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<md-dialog> <form ng-cloak name=changePasswordForm novalidate ng-submit=changePassword(changePasswordForm)> <md-toolbar class=gray-toolbar> <div class=md-toolbar-tools> <h2>Cambiar contraseña</h2> <span flex></span> <md-icon class=material-icons aria-label=Cerrar ng-click=close() style=cursor:pointer>close</md-icon>  </div> </md-toolbar> <md-dialog-content> <div id=updatePassword class=md-dialog-content> <div layout=column layout-margin> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" flex-offset=10> <label>Contraseña Actual</label> <input required type=password name=currentPassword id=currentPassword ng-model=data.currentPassword minlength=6 maxlength=100 ng-pattern=\"/^(?=.{6})(?=.*[^a-zA-Z])/\"/> <md-icon ng-show=changePasswordForm.currentPassword.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=changePasswordForm.currentPassword.$error class=gc-error-alert role=alert> <div ng-message=required>Debe introducir una contraseña válida</div> <div ng-message=minlength>La contraseña debe tener un mínimo de 6 caracteres</div> <div ng-message=maxlength>La contraseña no puede tener más de 100 caracteres</div> <div ng-message=pattern>Mínimo de 6 caracteres con al menos un número</div> </div> </md-input-container> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" flex-offset=10> <label>Nueva contraseña</label> <input required type=password name=newPassword id=newPassword ng-model=data.newPassword minlength=6 maxlength=100 ng-pattern=\"/^(?=.{6})(?=.*[^a-zA-Z])/\"/> <md-icon ng-show=changePasswordForm.newPassword.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=changePasswordForm.newPassword.$error class=gc-error-alert role=alert> <div ng-message=required>Debe introducir una contraseña válida</div> <div ng-message=minlength>La contraseña debe tener un mínimo de 6 caracteres</div> <div ng-message=maxlength>La contraseña no puede tener más de 100 caracteres</div> <div ng-message=pattern>Mínimo de 6 caracteres con al menos un número</div> </div> </md-input-container> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" flex-offset=10> <label>Confirmar Contraseña</label> <input required type=password name=confirmPassword id=confirmPassword ng-model=data.confirmPassword minlength=6 maxlength=100 ng-pattern=\"{{ data.newPassword }}\"/> <md-icon ng-show=changePasswordForm.confirmPassword.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=changePasswordForm.confirmPassword.$error class=gc-error-alert role=alert> <div ng-message=required>Debe introducir una contraseña válida</div> <div ng-message=minlength>La contraseña debe tener un mínimo de 6 caracteres</div> <div ng-message=maxlength>La contraseña no puede tener más de 100 caracteres</div> <div ng-message=pattern>Mínimo de 6 caracteres con al menos un número</div> </div> </md-input-container> <div layout=row layout-align=center> <md-button id=submit type=submit ng-disabled=changePasswordForm.$invalid class=\"md-raised md-primary\"> <span ng-show=!loading>Cambiar contraseña</span> <md-progress-circular ng-show=loading md-mode=indeterminate md-diameter=20 class=md-accent></md-progress-circular> </md-button> </div> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=close()> Cerrar </md-button> </md-dialog-actions> </form> </md-dialog> ";

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	module.exports = "<form id=userSettings name=form novalidate ng-submit=$ctrl.save(form)> <md-card class=tszCard> <md-card-title> <md-card-title-text> <span class=md-headline>Detalles de usuario</span> </md-card-title-text> </md-card-title> <md-card-content> <div layout-gt-md=row layout-margin> <md-input-container class=md-block flex-gt-md> <label>Nombre</label> <md-icon aria-label=Nombre class=material-icons>person</md-icon> <input ng-model=$ctrl.user.name type=text> </md-input-container> <md-input-container class=md-block flex-gt-md> <md-icon aria-label=Teléfono class=material-icons>phone</md-icon> <input ng-model=$ctrl.user.phone type=text placeholder=Teléfono> </md-input-container> <md-input-container class=md-block flex-gt-md> <md-icon aria-label=Email class=material-icons>email</md-icon> <input ng-model=$ctrl.user.email type=email placeholder=\"Email (required)\" ng-required=true disabled=disabled> </md-input-container> </div> <div layout-gt-md=row layout-margin> <a ng-click=$ctrl.showChangePasswordDialog($event) class=change-password> <i class=material-icons>lock</i> Cambiar contraseña </a> </div> </md-card-content> <md-card-actions layout=row layout-align=\"end center\"> <md-button type=submit>{{'SETTINGS.SAVE' | translate}}</md-button> </md-card-actions> </md-card> </form> ";

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports = "<div layout-margin> <h1 ng-bind=::$ctrl.companyName></h1> <div layout=row layout-align=\"center center\"> <md-content layout=column layout-padding ng-cloak flex> <md-button ng-click=$ctrl.toggleFiltering()> <md-icon aria-label=\"Mostrar filtros\" class=material-icons>search</md-icon> <span ng-hide=$ctrl.gridOptions.enableFiltering>Mostrar filtros</span> <span ng-show=$ctrl.gridOptions.enableFiltering>Ocultar filtros</span> </md-button> <div> <div ui-grid=$ctrl.gridOptions ui-grid-pagination class=myGrid></div> </div> </md-content> </div> <div layout-gt-md=row layout-padding ng-cloak layout-align=\"center top\" flex> <tsz-team company_id=::$ctrl.companyId email=::$ctrl.storage.user.email flex-md flex-gt-md=40></tsz-team> <tsz-company-subscriptions company_id=::$ctrl.companyId flex-md flex-gt-md=40></tsz-company-subscriptions>  </div> </div>";

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports = "<div layout-margin> <h1>Listado de compañías</h1> <div layout=row layout-align=\"center center\"> <md-content layout=column layout-padding ng-cloak flex> <md-button ng-click=$ctrl.toggleFiltering()> <md-icon aria-label=\"Mostrar filtros\" class=material-icons>search</md-icon> <span ng-hide=$ctrl.gridOptions.enableFiltering>Mostrar filtros</span> <span ng-show=$ctrl.gridOptions.enableFiltering>Ocultar filtros</span> </md-button> <div> <div ui-grid=$ctrl.gridOptions ui-grid-pagination class=myGrid></div> </div> </md-content> </div> </div> ";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div layout=column layout-fill> <md-toolbar> <app-header></app-header> </md-toolbar> <md-content flex style=background-color:transparent class=main-content> <ui-view autoscroll> <div layout=row layout-align=\"center center\"> <img src=" + __webpack_require__(23) + " alt=\"Loading app...\"> </div> </ui-view> </md-content> </div> ";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=footer layout=row layout-align=\"center center\"> <div class=footerContent> <div layout=row layout-align=\"center center\" layout-margin> <img src=" + __webpack_require__(323) + " class=logo-thesafezone /> </div> <div class=navigation-links layout=row layout-align=\"space-between center\" layout-margin> <div flex=31 layout=row layout-align=\"start center\"> <a href=thesafezone>{{'FOOTER.OUR_SOLUTION' | translate}}</a> </div> <div flex=31 layout=row layout-align=\"center center\"> <a href=meredicte>{{'FOOTER.WHAT_IS' | translate}}</a> </div> <div flex=31 layout=row layout-align=\"end center\"> <tsz-contact label=Contacto></tsz-contact> </div> </div> <hr> <div layout-gt-xs=row layout-align=\"center center\" layout-margin> <a ng-click=$ctrl.showLegalNoticeDialog($event)>{{'FOOTER.LEGAL_TERMS' | translate}}</a> | <a ng-click=$ctrl.showUsageTermsDialog($event)>{{'FOOTER.USAGE_TERMS' | translate}}</a> | <a ng-click=$ctrl.showPrivacyPolicyDialog($event)>{{'FOOTER.PRIVACY_POLICY' | translate}}</a> | <a ng-click=$ctrl.showCookiesDialog($event)>{{'FOOTER.COOKIES' | translate}}</a> </div> <div class=copyright layout=row layout-align=\"center center\" layout-margin> &copy; 2021 - theSafeZone | Meredicte &copy; | {{'FOOTER.COPYRIGHT' | translate}} </div> <div layout=row layout-align=\"center center\" layout-margin> BY </div> <div layout=row layout-align=\"center center\" layout-margin> <img src=" + __webpack_require__(319) + " class=logo-knowin /> </div> </div> </div> ";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<section class=login-background> <form layout=row layout-align=\"center center\" name=forgotPasswordForm novalidate ng-submit=$ctrl.forgotPassword(forgotPasswordForm)> <div id=forgotPasswordContainer flex md-theme=docs-dark layout=column layout-padding> <div layout=row layout-align=center> <h2 class=\"gc-heading-h5 text-center\">{{'FORGOT_PASSWORD.HEADER' | translate}}</h2> </div> <md-divider></md-divider> <div layout-padding=\"\" layout=column> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" minlength=2 flex-offset=10> <label>{{'LOGIN.EMAIL' | translate}}</label> <input required type=email name=loginEmail id=email ng-model=$ctrl.data.email minlength=6 maxlength=100 ng-pattern=/^.+@.+\\..+$/ > <md-icon ng-show=forgotPasswordForm.loginEmail.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=forgotPasswordForm.loginEmail.$error role=alert class=gc-error-alert> <div ng-message-exp=\"['required', 'minlength', 'maxlength', 'pattern']\"> {{'LOGIN.INVALID_EMAIL' | translate}} </div> </div> </md-input-container> <div layout=row layout-align=center> <md-button type=submit ng-disabled=forgotPasswordForm.$invalid class=\"md-raised md-primary\"> <span ng-show=!$ctrl.loading>{{'FORGOT_PASSWORD.RECOVER_PASSWORD' | translate}}</span> <md-progress-circular ng-show=$ctrl.loading md-mode=indeterminate md-diameter=20 class=md-accent></md-progress-circular> </md-button> </div> </div> </div> </form> </section> <app-footer></app-footer> ";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=tsz-header> <md-nav-bar md-selected-nav-item=$ctrl.currentNavItem nav-bar-aria-label=\"navigation links\" ng-hide=$ctrl.authenticated> <div flex layout=row layout-align=\"space-between center\"> <div class=meredicte-logo layout=row layout-align=\"center center\" ui-sref=landing> <img hide-xs src=" + __webpack_require__(27) + " class=logo-image /> <img hide-gt-xs src=" + __webpack_require__(28) + " class=logo-image /> </div> <a href=#contract class=contract hide-xs hide-sm hide-md ng-show=\"$ctrl.currentNavItem=='thesafezone'\">¿Cómo contratar theSafeZone?</a> <div layout=row> <md-nav-item md-nav-sref=thesafezone name=thesafezone hide-xs hide-sm>{{'MENU.THESAFEZONE' | translate}}</md-nav-item> <md-nav-item md-nav-sref=meredicte name=meredicte hide-xs hide-sm>{{'MENU.MEREDICTE' | translate}}</md-nav-item> <md-nav-item md-nav-href=https://blog.thesafezone.es name=blog hide-xs hide-sm>{{'MENU.BLOG' | translate}}</md-nav-item> <md-nav-item md-nav-sref=signup name=signup class=signup>{{'MENU.SIGN_UP' | translate}}</md-nav-item> <md-nav-item md-nav-sref=login name=login>{{'MENU.LOGIN' | translate}}</md-nav-item> </div> </div> </md-nav-bar> <md-nav-bar md-selected-nav-item=$ctrl.currentNavItem nav-bar-aria-label=\"navigation links\" ng-show=$ctrl.authenticated> <span class=meredicte-logo layout=row layout-align=\"center center\" ui-sref=home> <img hide-xs src=" + __webpack_require__(27) + " class=logo-image /> <img hide-gt-xs src=" + __webpack_require__(28) + " class=logo-image /> </span> <span flex></span> <md-nav-item ng-show=$ctrl.isUser md-nav-sref=home name=home>{{'MENU.REPORTS' | translate}}</md-nav-item> <md-nav-item ng-show=$ctrl.isUser md-nav-sref=subscriptions name=subscriptions>{{'MENU.SUBSCRIPTIONS' | translate}}</md-nav-item> <tsz-contact ng-show=$ctrl.isUser label=Soporte hide-xs class=\"md-button _md-nav-button\"></tsz-contact> <md-nav-item ng-show=$ctrl.isAdmin md-nav-sref=plans name=plans>{{'MENU.PLANS' | translate}}</md-nav-item> <md-nav-item ng-show=$ctrl.isAdmin md-nav-sref=admin_home name=admin_home>{{'MENU.USERS' | translate}}</md-nav-item> <md-menu id=user_menu> <md-button ng-click=$mdOpenMenu($event) aria-label=\"Open sample menu\" class=user-btn ng-class=\"{xs: $mdMedia('xs')}\"> <div layout=row layout-align=\"center center\"> <span class=user-name ng-bind=$ctrl.getUserMenu() hide-xs hide-sm></span> <img ng-show=$ctrl.showCompanyLogo() ng-src=\"{{ $ctrl.logo }}\" class=user-logo /> <md-icon ng-show=!$ctrl.showCompanyLogo() aria-label=\"Opciones de usuario\" class=material-icons style=color:rgba(0,0,0,.54)>person</md-icon> <tsz-notification-badge hide-when-ok=true class=user-bubble total=$ctrl.pendingFields></tsz-notification-badge> </div> </md-button> <md-menu-content> <md-menu-item> <md-button ui-sref=settings> <md-icon aria-label=Menu class=material-icons>settings</md-icon>{{'MENU.PROFILE' | translate}} <tsz-notification-badge hide-when-ok=true class=user-bubble total=$ctrl.pendingFields></tsz-notification-badge> </md-button> </md-menu-item> <md-menu-item><md-button><a class=menu_help target=_blank href=https://s3-eu-west-1.amazonaws.com/cdn.thesafezone.com/docs/es_ES/guia-usuario.pdf><md-icon aria-label=Ayuda class=material-icons>help</md-icon>{{'MENU.HELP' | translate}}</a></md-button></md-menu-item> <md-menu-item><md-button ng-click=$ctrl.logout()><md-icon aria-label=Menu class=material-icons>power</md-icon>{{'MENU.LOGOUT' | translate}}</md-button></md-menu-item> </md-menu-content> </md-menu> </md-nav-bar> </div> ";

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	module.exports = "<div id=home layout-margin> <h1>Proyectos</h1> <md-button class=\"md-warn md-fab md-fab-top-right\" aria-label=\"Crear nuevo proyecto\" ng-click=$ctrl.gotoCreateReport()> <md-tooltip md-direction={{item.direction}} md-visible=tooltipVisible md-autohide=false> Nuevo proyecto </md-tooltip> <md-icon aria-label=\"Crear nuevo\" class=material-icons>add</md-icon> </md-button> <div layout=row layout-align=\"center center\"> <md-content layout=column layout-padding ng-cloak flex> <md-button ng-click=$ctrl.toggleFiltering() id=enableFiltersBtn> <md-icon aria-label=\"Mostrar filtros\" class=material-icons>search</md-icon> <span ng-hide=$ctrl.gridOptions.enableFiltering>Mostrar filtros</span> <span ng-show=$ctrl.gridOptions.enableFiltering>Ocultar filtros</span> </md-button> <md-content class=\"md-no-momentum generalSearch\" ng-show=$ctrl.gridOptions.enableFiltering> <md-input-container class=\"md-icon-float md-block\" id=commentsFilter> <md-icon class=material-icons>search</md-icon> <input type=text ng-model=filterValue ng-change=$ctrl.onCommentsFilterChange(filterValue) placeholder=\"Sector / Objeto del informe / Observaciones\"/> </md-input-container> </md-content> <div> <div ui-grid=$ctrl.gridOptions ui-grid-pagination ng-style=\"{'height':$ctrl.gridheight + 'px'}\" class=myGrid></div> </div> </md-content> </div> </div> ";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"slick-slider js-slick\"> </div> <div layout=row layout-align=\"center center\" class=\"thesafezone band white\"> <div layout=column class=limit-width> <div layout=row layout-align=\"center center\" class=\"title center\"> NUESTRA SOLUCIÓN </div> <div class=\"subtitle center\"> Las soluciones <b>theSafeZone</b> permiten cuantificar el nivel de riesgo de una edificación </div> <div class=landing-band layout-gt-sm=row layout-align=\"space-between start\"> <div class=\"landing-band mt10\" layout=row layout-align=\"center center\"> <img class=full-width src=" + __webpack_require__(314) + " /> </div> <div class=\"band-content mt10\"> <div class=\"features center\"> <span>El <b>nivel de riesgo global</b> se mide en función del peligro potencial y de cómo éste se ve compensado por mecanismos de protección.</span> <p>Ofrecemos herramientas para la emisión de informes basados en <b>MEREDICTE©</b>, servicios profesionales de asesoramiento y servicios de formación.</p> </div> <div layout=row layout-align=\"center center\"> <a href=thesafezone class=read-more>Leer más</a> </div> </div> </div> </div> </div> <div layout=row layout-align=\"center center\" class=\"meredicte band gray\"> <div layout=column class=limit-width> <div layout=row layout-align=\"center center\"> <img class=logo src=" + __webpack_require__(320) + " /> <img class=logo src=" + __webpack_require__(317) + " style=margin-left:15px /> </div> <div class=\"subtitle center\">MEREDICTE© ha sido el primer documento reconocido del CTE dentro del ámbito de la seguridad contra incendios en España</div> <div layout-gt-sm=row layout-align=\"space-between start\" class=\"landing-band gray meredicte\"> <div flex-gt-sm=50 class=\"band-content mt10\"> <div class=\"description center\"> <span>Meredicte© sistematiza la forma de identificar, analizar y evaluar:</span> <ol> <li>El <b>peligro</b>,</li> <li>La <b>protección</b> y</li> <li>El <b>riesgo</b> en caso de incendio en la edificación</li> </ol> <p><b>Meredicte©</b>, en su nueva <b>versión 2.0</b>, se actualiza con el fin de adaptarlo al nuevo estado reglamentario del CTE tras la aprobación del <b>RD 732/2019</b>, incorporando soluciones avanzadas contempladas en los códigos edificatorios y normas internacionales más prestigiosos.</p> <p><a href=https://s3-eu-west-1.amazonaws.com/cdn.thesafezone.com/docs/es_ES/novedades.pdf target=_blank>Descarga las <b>novedades</b> de la nueva versión 2.0</a></p> </div> </div> <div flex-gt-sm=50 class=\"landing-band gray mt10\" layout=row layout-align=\"center center\"> <img class=full-width src=" + __webpack_require__(315) + " /> </div> </div> <div layout=row layout-align=\"center center\"> <a href=meredicte class=read-more>Leer más</a> </div> </div> </div> <div layout=row layout-align=\"center center\" class=\"thesafezone band white\"> <div layout=column class=limit-width> <div class=landing-band layout-gt-sm=row layout-align=\"space-between start\"> <div class=\"band-content mt10\"> <div class=\"features center\"> <p>El proyecto con expediente 45/399388.9/17 y de título “Validación experimental de servicios de la empresa”, ha sido financiado por la Comunidad de Madrid y cofinanciado por la Unión Europea.</p> </div> </div> <div class=\"landing-band mt10\" layout=row layout-align=\"center center\"> <img class=\"full-width cheque\" src=" + __webpack_require__(339) + " ng-click=$ctrl.showChequeInnovacion1Dialog() /> </div> </div> <div class=landing-band layout-xs=column layout-sm=column layout-gt-sm=row layout-align=\"space-between start\"> <div class=\"landing-band mt10 center\" layout=row layout-align=\"center center\" flex flex-order=1 flex-order-gt-sm=-1> <img class=\"full-width cheque\" src=" + __webpack_require__(340) + " ng-click=$ctrl.showChequeInnovacion2Dialog() /> </div> <div class=\"band-content mt10\" flex flex-order=-1 flex-order-gt-sm=1> <div class=\"features center\"> <p>El proyecto con expediente 45/399774.9/17 y de título “Generación de nuevos servicios de la empresa y visión de procesos de negocio”, ha sido financiado por la Comunidad de Madrid y cofinanciado por la Unión Europea.</p> </div> </div> </div> </div> </div> <app-footer></app-footer> ";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<section class=login-background> <form layout=row layout-align=\"center center\" name=loginForm novalidate ng-submit=$ctrl.login(loginForm)> <div id=loginContainer flex md-theme=docs-dark layout=column layout-padding> <div layout=row layout-align=center> <h2 class=\"gc-heading-h5 text-center\">{{'LOGIN.HEADER' | translate}}</h2> </div> <md-divider></md-divider> <div layout-padding=\"\" layout=column> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" minlength=2 flex-offset=10> <label>{{'LOGIN.EMAIL' | translate}}</label> <input required type=email name=loginEmail id=email ng-model=$ctrl.data.email minlength=6 maxlength=100 ng-pattern=/^.+@.+\\..+$/ > <md-icon ng-show=loginForm.loginEmail.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=loginForm.loginEmail.$error role=alert class=gc-error-alert> <div ng-message-exp=\"['required', 'minlength', 'maxlength', 'pattern']\"> {{'LOGIN.INVALID_EMAIL' | translate}} </div> </div> </md-input-container> <md-input-container md-no-float class=\"md-block md-icon-right md-icon-nospace\" flex-offset=10> <label>{{'LOGIN.PASSWORD' | translate}}</label> <input required type=password name=loginPassword id=password ng-model=$ctrl.data.password ng-pattern=\"/^(?=.{6})(?=.*[^a-zA-Z])/\"/> <md-icon ng-show=loginForm.loginPassword.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=loginForm.loginPassword.$error class=gc-error-alert role=alert> <div ng-message-exp=\"['required', 'minlength', 'maxlength', 'pattern']\"> {{'LOGIN.INVALID_PASSWORD' | translate}} </div> </div> </md-input-container> <div layout=row layout-align=center> <md-button id=submit type=submit ng-disabled=loginForm.$invalid class=\"md-raised md-primary\"> <span ng-show=!$ctrl.loading>{{'LOGIN.LOGIN' | translate}}</span> <md-progress-circular ng-show=$ctrl.loading md-mode=indeterminate md-diameter=20 class=md-accent></md-progress-circular> </md-button> </div> <div> <a href=forgot-password class=.md-body-1>{{'LOGIN.FORGOT_PASSWORD' | translate}}</a> </div> <div> ¿No tienes una cuenta? <a href=signup>{{'LOGIN.SIGN_UP' | translate}}</a> </div> </div> </div> </form> </section> <app-footer></app-footer> ";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=landing-meredite> <div layout-gt-sm=row layout-align=\"space-between center\" class=menu> <a ng-click=\"$ctrl.scrollTo('section-usages')\" layout=row layout-align=\"center center\" class=\"applications selected\" flex flex-gt-sm=35>¿QUÉ APLICACIONES TIENE?</a> <a ng-click=\"$ctrl.scrollTo('section-who')\" layout=row layout-align=\"center center\" flex flex-gt-sm=30 class=who>¿PARA QUIÉN?</a> <a ng-click=\"$ctrl.scrollTo('section-cte')\" layout=row layout-align=\"center center\" flex flex-gt-sm=35 class=cte>DOCUMENTO RECONOCIDO CTE</a> </div> <section layout=row layout-align=\"center center\" class=\"section section-1\"> <div layout-gt-sm=row class=limit-width> <div flex-gt-sm=33 class=overview layout=row layout-align=\"center center\"> <img class=logo-meredicte src=" + __webpack_require__(321) + " /> </div> <div flex-gt-sm layout=row layout-align=\"center center\"> <div class=overview-content> <h1> ¿Qué es MEREDICTE&copy;? </h1> <hr/> <div class=\"description lh30\"> MEREDICTE© es un método que responde a las siglas de “Método de Evaluación del Riesgo en caso de Incendio en el Marco del Código Técnico de la Edificación”. </div> <p><a href=https://s3-eu-west-1.amazonaws.com/cdn.thesafezone.com/docs/es_ES/meredicte-2.pdf target=_blank>Descarga el <b>documento</b> de la nueva versión 2.0</a></p> </div> </div> </div> </section> <section class=\"section section-2 lh30\" layout=row layout-align=\"center center\"> <div layout=row layout-align=\"center center\" class=limit-width> <div> <div>La nueva versión del método <b>Meredicte© 2.0</b> se adapta al nuevo estado reglamentario del CTE tras la aprobación del <b>RD 732/2019</b>, incorporando soluciones avanzadas contempladas en los códigos edificatorios y normas internacionales más prestigiosos, contemplando también mejoras que se han producido en el estado de la técnica en materia de seguridad contra incendios.</div> <p><a href=https://s3-eu-west-1.amazonaws.com/cdn.thesafezone.com/docs/es_ES/novedades.pdf target=_blank>Descarga las <b>novedades</b> de la nueva versión 2.0</a></p> Con MEREDICTE© es posible: <ul> <li>Cuantificar de forma analítica y objetiva <b>el nivel de peligro, protección y el nivel de riesgo</b> en caso de incendios de los edificios</li> <li>Evaluar <b>Proyectos Basados en Prestaciones</b></li> <li><b>Identificar protecciones</b> contra incendios eficientes</li> <li>Evaluar <b>edificios existentes</b></li> <li>Evidenciar edificios que entrañan <b>riesgo inadmisible</b></li> </ul> </div> </div> </section> <section class=\"section section-3 lh30\" layout=row layout-align=\"center center\"> <div layout-gt-sm=row layout-align=\"center center\" class=limit-width> <div flex flex-gt-sm=50> En términos analíticos, se puede afirmar que <b>riesgo=peligro/protección</b>. En función del valor numérico calculado por MEREDICTE©, se obtiene un <b>Nivel de Riesgo Global (NRG)</b> determinado. </div> <div layout=row layout-align=\"center center\" flex> <img src=" + __webpack_require__(333) + " /> </div> </div> </section> <section layout=row layout-align=\"center center\" class=\"section section-4\"> <div layout-gt-sm=row layout-align=\"start center\" class=limit-width> <div class=\"description lh30\" flex-xs flex-sm> <div class=title>Aplicable a edificios de uso:</div> <div layout-gt-sm=row layout-align=\"space-between center\"> <div flex> <ul> <li>Administrativo</li> <li>Residencial público</li> <li>Residencial vivienda</li> <li>Hospitalario</li> </ul> </div> <div flex> <ul> <li>Aparcamiento</li> <li>Docente</li> <li>Pública concurrencia</li> <li>Comercial</li> </ul> </div> </div> </div> </div> </section> <section id=section-usages layout=row layout-align=\"center center\" class=\"section section-usages\"> <div class=limit-width> <div layout-gt-sm=row layout-align=\"center start\"> <div flex flex-gt-sm=60> <h1>¿Qué aplicaciones tiene?</h1> <hr/> <div> <h3>1. Herramienta de gran utilidad en la concesión de licencias urbanísticas</h3> </div> <p class=lh30>MEREDICTE© permite a los Proyectistas contar con un referente objetivo para justificar que sus diseños cumplen el nivel de seguridad normativo. Así mismo, las autoridades de control de la edificación contarán con una herramienta para verificar que los diseños prestacionales alcanzan el nivel de seguridad reglamentario, facilitando la coordinación del proyectista y la autoridad de control edificatorio, necesaria siempre en el proceso prestacional.</p> </div> <div flex layout=row layout-align=\"center center\"> <img src=" + __webpack_require__(326) + " class=padding-left /> </div> </div> <div layout-xs=column layout-sm=column layout-gt-sm=row layout-align=\"center center\" class=usage> <div flex flex-order=1 flex-order-gt-sm=-1 layout-align=\"center center\"> <img src=" + __webpack_require__(327) + " class=padding-right /> </div> <div flex flex-gt-sm=60 flex-order=-1 flex-order-gt-sm=1> <div> <h3>2. Negociación de pólizas de seguros</h3> </div> <p class=lh30>MEREDICTE© puede detectar edificios que presentan niveles de riesgo que hacen inasumible una póliza (a menos que se tomen medidas correctoras), o por el contrario, pueden llegar a determinar que una póliza está sobreestimada, pudiendo realizar una reducción proporcionada de la misma.</p> <p class=lh30>Con la utilización del MEREDICTE©, una compañía aseguradora puede ser más competitiva, ganar cuota de mercado y fidelizar a sus clientes, al evitar asumir pólizas con riesgos de incendios excesivos, orientar a los clientes sobre las medidas de seguridad a tomar para poderles asegurar y proporcionar la póliza al riesgo realmente asumido.</p> </div> </div> <div layout-gt-sm=row layout-align=\"center center\"> <div flex flex-gt-sm=50> <div class=usage> <h3>3. Protección eficaz contra incendios</h3> <p class=lh30>Durante la fase de diseño, tanto en edificios nuevos como en intervenciones en edificios existentes, el proyectista puede comprobar el Nivel de Riesgo alcanzado con sus diferentes diseños, y contar con orientación sobre qué aspectos tienen más impacto sobre el peligro y la protección, lo que le permite seleccionar el diseño óptimo.</p> </div> <div class=usage> <h3>4.Detección de situaciones de alto riesgo</h3> <p class=lh30>En el caso de edificios existentes, especialmente aquellos construidos en épocas previas a la aparición de la normativa de protección contra incendios (por ejemplo, edificios históricos, protegidos, etc.), e incluso en los construidos en épocas recientes pero que hayan sufrido modificaciones o cambios de uso, mediante la evaluación del riesgo de incendio a través del MEREDICTE© se pueden detectar situaciones de alto riesgo incluso catastróficas que de otra forma podrían pasar inadvertidas. Una vez detectada una situación de alto riesgo, la utilización del MEREDICTE© orienta sobre con qué diseños se obtienen mejores resultados.</p> </div> </div> <div flex layout=row layout-align=\"center center\"> <img src=" + __webpack_require__(330) + " class=padding-left class=padding-left /> </div> </div> <div class=usage> <h3>5. Informes periciales</h3> <p class=lh30>En el caso de que un perito tuviese que aportar un informe pericial referente a un siniestro causado por un incendio, el MEREDICTE© le permitiría determinar qué nivel de riesgo tenía el local siniestrado, contando con una evaluación objetiva, analítica y fácilmente comprensible.</p> </div> <div layout-xs=column layout-sm=column layout-gt-sm=row layout-align=\"center center\" class=usage> <div flex-order=1 flex-order-gt-sm=-1 flex layout=row layout-align=\"center center\"> <img src=" + __webpack_require__(331) + " class=padding-right /> </div> <div flex-order=-1 flex-order-gt-sm=1 flex flex-gt-sm=60> <h3>6. Creación de mapas de riesgo de incendio de núcleos urbanos</h3> <p class=lh30>De forma similar a los mapas acústicos, los mapas de riesgo de incendio pueden ser de especial interés para ayuntamientos y servicios de protección civil al contar con una representación gráfica de los núcleos urbanos sobre los que tienen responsabilidad, que les muestre las zonas de la población en función del nivel de riesgo, de tal manera que pueden prever los riesgos existentes y realizar una asignación óptima de sus recursos, fundamentalmente los relativos a extinción y salvamento.</p> <p class=lh30>Con un mapa de estas características, además, se pueden detectar claramente situaciones que orienten a los responsables a la hora de emprender medidas de mejora, tales como ampliar accesos, implantar o extender redes de hidrantes, implantar parques de bomberos adicionales, prescribir elevar el nivel de seguridad de los edificios existentes con un nivel de riesgo inasumible, elaborar Planes de Autoprotección, etc.</p> </div> </div> </div> </section> <section id=section-who layout=row layout-align=\"center center\" class=\"section section-who\"> <div layout-gt-sm=row layout-align=\"center center\" class=limit-width> <div flex flex-gt-sm=60> <h1>¿Para quién?</h1> <hr/> <p class=lh30>Entre los colectivos que pueden encontrar mayor interés en la utilización del MEREDICTE© se encuentran:</p> <ul class=lh30> <li>Autoridades de control municipal </li> <li>Ingenieros, arquitectos y técnicos encargados de proyectos de edificación</li> <li>Compañías aseguradoras </li> <li>Ingenieros de seguridad </li> <li>Peritos</li> <li>Responsables de Protección Civil </li> <li>Directores de Seguridad</li> </ul> <p class=lh30>En cualquier caso, para la adecuada utilización e interpretación del MEREDICTE© se requiere su aplicación por técnicos cualificados en el campo de la evaluación de riesgos de incendios en la edificación.</p> </div> <div flex layout=column layout-align=\"center center\"> <img src=" + __webpack_require__(332) + " class=padding-left /> </div> </div> </section> <section id=section-cte layout=row layout-align=\"center center\" class=\"section section-cte\"> <div layout-gt-sm=row layout-align=\"center center\" class=limit-width> <div flex flex-gt-sm=60> <h1>Documento reconocido del Código Técnico de Edificación</h1> <hr/> <p class=lh30><b>MEREDICTE© es un método de reconocido prestigio, cuya versión 1.0 ha sido el primer documento reconocido del CTE dentro del ámbito de la seguridad contra incendios en España.</b></p> <p class=lh30>Tal y como propugna el CTE, el MEREDICTE © responde a los principios de innovación, progreso tecnológico, mejora de la calidad de la edificación y sostenibilidad. Por ello, el 15 de marzo del 2012 se solicitó al Ministerio de Fomento que fuera inscrito Documento Reconocido del CTE, conforme a lo previsto en la ORDEN VIV/1744/2008 por la que se regula el Registro General del CTE. Tras emitirse los informes técnicos favorables por parte de la administración, el 1 de diciembre de 2014 se aprobó la Resolución del Ministerio de Fomento por la que el MEREDICTE© 1.0 es inscrito como Documento Reconocido del Código Técnico de la Edificación.</p> <p class=lh30>El 25 de septiembre de 2020 el Ministerio de Transportes, Movilidad y Agenda Urbana emitió una NOTA SOBRE EL DOCUMENTO RECONOCIDO CTE-DR/048/14 MEREDICTE, indicando que no puede considerarse aplicable respecto a la versión actualmente vigente del DBSI, modificada mediante el Real Decreto 732/2019, puesto que toma como marco de referencia la versión anterior del DBSI.</p> <p class=lh30>Como consecuencia de lo anterior, se ha procedido a la <b>actualización del Método dando lugar a la versión 2.0</b>, que adopta como marco de referencia el Real Decreto 314/2006 de 17 de marzo, por el que se aprueba el Código Técnico de la Edificación (BOE 28-marzo-2006) y sus modificaciones posteriores hasta la versión vigente derivada de la aprobación del Real Decreto 732/2019, de 20 de diciembre.</p> <a href=https://www.codigotecnico.org/RegistroCTE/DocumentosReconocidos.html target=_blank>Pulse aquí para obtener toda la información de Documentos Reconocidos del CTE.</a> </div> <div layout=row layout-align=\"center center\" flex> <div layout=column layout-align=\"center center\" class=padding-left> <img src=" + __webpack_require__(324) + " /> <img src=" + __webpack_require__(325) + " /> </div> </div> </div> </section> </div> <app-footer></app-footer> ";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<section class=login-background> <form layout=row layout-align=\"center center\" name=passwordRecoveryForm novalidate ng-submit=$ctrl.changePassword(passwordRecoveryForm)> <div id=passwordRecoveryContainer flex md-theme=docs-dark layout=column layout-padding> <div layout=row layout-align=center> <h2 class=\"gc-heading-h5 text-center\">{{'PASSWORD_RECOVERY.HEADER' | translate}}</h2> </div> <md-divider></md-divider> <div layout-padding=\"\" layout=column> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" flex-offset=10> <label>{{'SIGNUP.PASSWORD' | translate}}</label> <input required type=password name=loginPassword id=password ng-model=$ctrl.data.password minlength=6 maxlength=100 ng-pattern=\"/^(?=.{6})(?=.*[^a-zA-Z])/\"/> <md-icon ng-show=passwordRecoveryForm.loginPassword.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=passwordRecoveryForm.loginPassword.$error class=gc-error-alert role=alert> <div ng-message=required>Debe introducir una contraseña válida</div> <div ng-message=minlength>La contraseña debe tener un mínimo de 6 caracteres</div> <div ng-message=maxlength>La contraseña no puede tener más de 100 caracteres</div> <div ng-message=pattern>Debe introducir una contraseña válida</div> </div> </md-input-container> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" flex-offset=10> <label>{{'SIGNUP.CONFIRM_PASSWORD' | translate}}</label> <input required type=password name=loginPassword id=confirmPassword ng-model=$ctrl.data.confirmPassword minlength=6 maxlength=100 ng-pattern=\"{{ $ctrl.data.password }}\"/> <md-icon ng-show=passwordRecoveryForm.loginPassword.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=passwordRecoveryForm.loginPassword.$error class=gc-error-alert role=alert> <div ng-message=required>Debe introducir una contraseña válida</div> <div ng-message=minlength>La contraseña debe tener un mínimo de 6 caracteres</div> <div ng-message=maxlength>La contraseña no puede tener más de 100 caracteres</div> <div ng-message=pattern>Las contraseñas no coinciden</div> </div> </md-input-container> <div layout=row layout-align=center> <md-button id=submit type=submit ng-disabled=passwordRecoveryForm.$invalid class=\"md-raised md-primary\"> <span ng-show=!$ctrl.loading>{{'PASSWORD_RECOVERY.CHANGE_PASSWORD' | translate}}</span> <md-progress-circular ng-show=$ctrl.loading md-mode=indeterminate md-diameter=20 class=md-accent></md-progress-circular> </md-button> </div> </div> </div> </form> </section> <app-footer></app-footer> ";

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	module.exports = "<div layout-margin> <h1>Planes</h1> <div layout-gt-md=row layout-align=\"center top\"> <md-card ng-repeat=\"plan in $ctrl.plans\"> <md-card-title> <md-card-title-text> {{ plan.code }} </md-card-title-text> </md-card-title> <md-card-content> <form name=projectForm> <div layout=row> <md-input-container flex=50> <label>Nombre</label> <input required ng-model=plan.name> </md-input-container> <md-input-container flex=50> <label># Informes</label> <input type=number step=any required ng-model=plan.maxReports> </md-input-container> </div> <div layout=row> <md-input-container flex=50> <label>Precio mensual</label> <input type=number step=any min=0 required ng-model=plan.monthlyPrice> </md-input-container> <md-input-container flex=50> <label>Precio anual</label> <input type=number step=any min=0 required ng-model=plan.yearlyPrice> </md-input-container> </div> <div layout=row> <md-input-container flex=50> <label>Area maxima (m2)</label> <input type=number step=any min=0 required ng-model=plan.maxArea> </md-input-container> </div> <div layout=row> <md-input-container flex> <label>Descripción</label> <textarea ng-model=plan.description md-maxlength=300 rows=3 md-select-on-focus></textarea> </md-input-container> </div> </form> </md-card-content> <md-card-actions layout=row layout-align=\"end center\"> <md-button ng-click=$ctrl.save(plan)>Guardar</md-button> </md-card-actions> </md-card> </div> <div layout-gt-md=row layout-align=\"center top\"> <md-card flex-sm flex-gt-sm=50> <md-card-title> <md-card-title-text> MENSAJE PROMOCIONAL </md-card-title-text> </md-card-title> <md-card-content> <form name=projectForm> <div layout=row> <md-input-container flex> <label>Mensaje</label> <textarea ng-model=$ctrl.promotionalMessage md-maxlength=300 rows=1 md-select-on-focus></textarea> </md-input-container> </div> </form> </md-card-content> <md-card-actions layout=row layout-align=\"end center\"> <md-button ng-click=$ctrl.savePromotionalMessage($ctrl.promotionalMessage)>Guardar</md-button> </md-card-actions> </md-card> </div> </div> ";

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = "<div layout-margin layout-fill> <tsz-report report-id=$ctrl.reportId layout-fill></tsz-report> </div> ";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div layout-padding> <div layout=column> <div layout=row layout-align=center> <tsz-user-settings flex-md flex-gt-md=50 layout-fill></tsz-user-settings> </div> <div layout=row layout-align=center ng-if=$ctrl.showCompanySettings()> <tsz-company-settings company-id=$ctrl.companyId flex-md flex-gt-md=50 layout-fill></tsz-company-settings> </div> <div layout=row layout-align=center ng-if=$ctrl.showTeamSettings()> <div flex-md flex-gt-md=50 layout-fill> <form name=invite_form novalidate ng-submit=$ctrl.invite(inviteEmail)> <md-card class=tszCard> <md-card-title> <md-card-title-text> <span class=md-headline>Miembros de tu equipo</span> </md-card-title-text> </md-card-title> <md-card-content> <div layout-gt-xs=row layout-margin> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" minlength=2 flex> <label>{{'LOGIN.EMAIL' | translate}}</label> <input required type=email name=inviteEmail id=inviteEmail ng-model=inviteEmail minlength=6 maxlength=100 ng-pattern=/^.+@.+\\..+$/ flex> <md-icon ng-show=invite_form.inviteEmail.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=invite_form.inviteEmail.$error role=alert class=gc-error-alert> <div ng-message-exp=\"['required', 'minlength', 'maxlength', 'pattern']\"> {{'LOGIN.INVALID_EMAIL' | translate}} </div> </div> </md-input-container> <md-button type=submit ng-disabled=invite_form.$invalid class=\"md-raised md-primary\"> <md-icon aria-label=Invitar class=material-icons>person_add</md-icon> <md-tooltip>Invitar</md-tooltip> </md-button> </div> <div layout=row layout-align=center> <div layout=row layout-padding ng-cloak flex-xs flex-gt-xs=50 layout-align=center> <tsz-team company-id=$ctrl.user.companyId email=$ctrl.user.email></tsz-team> </div> </div> </md-card-content> </md-card> </form> </div> </div> </div> </div>";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<section class=login-background> <form layout=row layout-align=\"center center\" name=signUpForm novalidate ng-submit=$ctrl.signup(signUpForm)> <div id=signUpContainer flex md-theme=docs-dark layout=column layout-padding> <div layout=row layout-align=center> <h2 class=\"gc-heading-h5 text-center\">{{ 'SIGNUP.HEADER' | translate }}</h2> </div> <md-divider></md-divider> <div layout-padding=\"\" layout=column> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" minlength=2 flex-offset=10> <label>{{'SIGNUP.COMPANY' | translate}}</label> <input type=text name=companyName id=companyName ng-model=$ctrl.data.companyName> </md-input-container> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" minlength=2 flex-offset=10> <label>{{'SIGNUP.EMAIL' | translate}}</label> <input required type=email name=loginEmail id=email ng-model=$ctrl.data.email minlength=6 maxlength=100 ng-pattern=/^.+@.+\\..+$/ > <md-icon ng-show=signUpForm.loginEmail.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=signUpForm.loginEmail.$error role=alert class=gc-error-alert> <div ng-message-exp=\"['required', 'minlength', 'maxlength', 'pattern']\"> {{'LOGIN.INVALID_EMAIL' | translate}} </div> </div> </md-input-container> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" flex-offset=10> <label>{{'SIGNUP.PASSWORD' | translate}}</label> <input required type=password name=loginPassword id=password ng-model=$ctrl.data.password minlength=6 maxlength=100 ng-pattern=\"/^(?=.{6})(?=.*[^a-zA-Z])/\"/> <md-icon ng-show=signUpForm.loginPassword.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=signUpForm.loginPassword.$error class=gc-error-alert role=alert> <div ng-message=required>Debe introducir una contraseña válida</div> <div ng-message=minlength>La contraseña debe tener un mínimo de 6 caracteres</div> <div ng-message=maxlength>La contraseña no puede tener más de 100 caracteres</div> <div ng-message=pattern>Debe introducir una contraseña válida</div> </div> </md-input-container> <md-input-container class=\"md-block md-icon-right md-icon-nospace\" flex-offset=10> <label>{{'SIGNUP.CONFIRM_PASSWORD' | translate}}</label> <input required type=password name=confirmPassword id=confirmPassword ng-model=$ctrl.data.confirmPassword minlength=6 maxlength=100 ng-pattern=\"{{ $ctrl.data.password }}\"/> <md-icon ng-show=signUpForm.confirmPassword.$valid md-svg-src=" + __webpack_require__(5) + "></md-icon> <div ng-messages=signUpForm.confirmPassword.$error class=gc-error-alert role=alert> <div ng-message=required>Debe introducir una contraseña válida</div> <div ng-message=minlength>La contraseña debe tener un mínimo de 6 caracteres</div> <div ng-message=maxlength>La contraseña no puede tener más de 100 caracteres</div> <div ng-message=pattern>Las contraseñas no coinciden</div> </div> </md-input-container> <div layout=row layout-align=center> <md-checkbox required name=acceptTerms ng-model=$ctrl.acceptTerms> Al registrarte, aceptas los <a class=link target=_blank ng-click=$ctrl.showUsageTermsDialog($event)>Términos de Uso</a> y la <a class=link ng-click=$ctrl.showPrivacyPolicyDialog($event)>Política de Privacidad</a>, incluyendo el <a class=link ng-click=$ctrl.showCookiesDialog($event)>Uso de Cookies</a>. <div ng-messages=signUpForm.acceptTerms.$error role=alert class=gc-error-alert> <div ng-message-exp=\"['required']\" style=color:red;font-size:13px;margin-top:3px> Es necesario aceptar las condiciones del servicio </div> </div> </md-checkbox> </div> <div layout=row layout-align=center> <md-button id=submit type=submit ng-disabled=signUpForm.$invalid class=\"md-raised md-primary\"> <span ng-show=!$ctrl.loading>{{'SIGNUP.SIGN_UP' | translate}}</span> <md-progress-circular ng-show=$ctrl.loading md-mode=indeterminate md-diameter=20 class=md-accent></md-progress-circular> </md-button> </div> <div> {{ 'SIGNUP.ALREADY_REGISTERED' | translate }} <a href=login>{{'LOGIN.LOGIN' | translate}}</a> </div> </div> </div> </form> </section> <app-footer></app-footer> ";

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	module.exports = "<div layout=row layout-align=\"center center\"> <tsz-pricing company-id=$ctrl.companyId public=false class=limit-width></tsz-pricing> </div> <form id=redsysForm name=payForm method=post target=_top> <input type=hidden id=Ds_SignatureVersion name=Ds_SignatureVersion> <input type=hidden id=Ds_MerchantParameters name=Ds_MerchantParameters> <input type=hidden id=Ds_Signature name=Ds_Signature> </form> ";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=landing-thesafezone> <div layout-gt-xs=row layout-align=\"space-between center\" class=menu> <a ng-click=\"$ctrl.scrollTo('section-reports')\" layout=row layout-align=\"center center\" class=selected flex>Generación de informes</a> <a ng-click=\"$ctrl.scrollTo('section-services')\" layout=row layout-align=\"center center\" flex>Servicios profesionales</a> <a ng-click=\"$ctrl.scrollTo('section-training')\" layout=row layout-align=\"center center\" class=training flex>Formación Meredicte©</a> </div> <section layout=row layout-align=\"center center\" class=\"section section-1\"> <div layout-gt-xs=row layout-align=\"start center\" class=limit-width> <div class=description> Las soluciones <b>theSafeZone</b> permiten <b>cuantificar</b> el <b>nivel de riesgo</b> de una edificación en función de su <b>peligro potencial</b> y de cómo éste se ve compensado por mecanismos de <b>protección</b>. </div> </div> </section> <section id=section-reports layout=row layout-align=\"center center\" class=\"section section-reports\"> <div class=limit-width> <h1> Generación de informes </h1> <hr align=left /> <div class=overview-content flex-gt-sm layout-gt-sm=row layout-align=\"space-between start\"> <div flex-gt-sm=60 class=\"description lh30\" layout=row layout-align=\"center center\"> <ul flex> <li>A través de un servicio on-line, theSafeZone permite <b>automatizar</b> la generación de informes basados en el método <b>MEREDICTE&copy;</b></li> <li>Es una herramienta de apoyo que ofrece luz en el diseño y en la evaluación de escenarios complejos en materia de <b>seguridad contra incendios</b></li> <li><b>Cuantificación</b> del nivel de riesgo a través de más de 70 parámetros que miden el peligro potencial y el grado de protección de una edificación</li> </ul> <div class=login layout=row layout-align=\"center center\"> <a href=login>Iniciar sesión</a> </div> </div> <div flex-gt-sm=40 class=overview layout=column layout-align=\"center center\"> <img src=" + __webpack_require__(336) + " /> </div> </div> </div> </section> <section id=section-services layout=row layout-align=\"center center\" class=\"section section-services\"> <div class=limit-width> <h1> Servicios profesionales </h1> <hr align=left /> <div class=overview-content flex-gt-sm layout-xs=column layout-sm=column layout=row layout-align=\"center start\"> <div flex-gt-sm=50 class=overview layout=row flex-order-gt-sm=-1 flex-order=1 layout-align=\"center center\" style=display:table> <img class=\"logo-meredicte padding-bottom\" src=" + __webpack_require__(335) + " /> <div class=contact-with-us style=display:table-row;text-align:center> <tsz-contact label=\"Contacta con nosotros\"></tsz-contact> </div> </div> <div flex-gt-sm=50 class=\"description lh30\" flex-order-gt-sm=1 flex-order=-1 layout=column layout-align=\"start center\"> <ul> <li>Asesoramiento en la evaluación del nivel de riesgo en edificaciones</li> <li>Análisis de proyectos alternativos basados en enfoque prestacional</li> <li>Detección de situaciones de riesgo, diseños eficientes en edificios nuevos o existentes, informes periciales, mapas de riesgo de incendios, ...</li> </ul> </div> </div> </div> </section> <section id=section-training layout=row layout-align=\"center center\" class=\"section section-training\"> <div class=limit-width> <h1> Formación MEREDICTE&copy; </h1> <hr align=left /> <div class=overview-content flex-gt-sm layout-gt-sm=row layout-align=\"center center\"> <div flex-gt-sm=60 class=\"description lh30\" layout=column layout-align=\"center center\"> <ul> <li>Entendemos que la formación para nuestros clientes es esencial para sus proyectos.</li> <li>Formamos expertos en la utilización de Meredicte&copy;</li> </ul> <tsz-contact label=\"¿Necesitas formación personalizada?\"></tsz-contact> <tsz-contact class=\"padding-top padding-bottom\" label=\"Contacta con nosotros para próximos eventos de formación\"></tsz-contact> </div> <div flex-gt-sm=40 class=overview layout=row layout-align=\"center center\"> <img class=logo-meredicte src=" + __webpack_require__(334) + " /> </div> </div> </div> </section> <section layout=row layout-align=\"center center\" id=contract name=contract class=\"section section-5\"> <div class=limit-width> <h1> ¿Cómo contratar theSafeZone? </h1> <hr align=left /> <tsz-pricing public=true flex></tsz-pricing> </div> </section> </div> <app-footer></app-footer> ";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<md-content flex style=background-color:transparent> <div layout=row layout-align=\"center center\"> <img src=" + __webpack_require__(23) + " alt=\"Loading app...\"> </div> </md-content> ";

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 170 */,
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszCompanyActions = __webpack_require__(173);
	
	var _tszCompanyActions2 = _interopRequireDefault(_tszCompanyActions);
	
	var _tszCompanySettings = __webpack_require__(175);
	
	var _tszCompanySettings2 = _interopRequireDefault(_tszCompanySettings);
	
	var _tszCompanySubscriptions = __webpack_require__(177);
	
	var _tszCompanySubscriptions2 = _interopRequireDefault(_tszCompanySubscriptions);
	
	var _tszContact = __webpack_require__(179);
	
	var _tszContact2 = _interopRequireDefault(_tszContact);
	
	var _tszLoading = __webpack_require__(183);
	
	var _tszLoading2 = _interopRequireDefault(_tszLoading);
	
	var _tszNotificationBadge = __webpack_require__(185);
	
	var _tszNotificationBadge2 = _interopRequireDefault(_tszNotificationBadge);
	
	var _tszPriceCalculator = __webpack_require__(187);
	
	var _tszPriceCalculator2 = _interopRequireDefault(_tszPriceCalculator);
	
	var _tszPricing = __webpack_require__(189);
	
	var _tszPricing2 = _interopRequireDefault(_tszPricing);
	
	var _tszProgressBar = __webpack_require__(191);
	
	var _tszProgressBar2 = _interopRequireDefault(_tszProgressBar);
	
	var _tszReport = __webpack_require__(199);
	
	var _tszReport2 = _interopRequireDefault(_tszReport);
	
	var _tszReportActions = __webpack_require__(193);
	
	var _tszReportActions2 = _interopRequireDefault(_tszReportActions);
	
	var _tszReportMenuActions = __webpack_require__(195);
	
	var _tszReportMenuActions2 = _interopRequireDefault(_tszReportMenuActions);
	
	var _tszReportParam = __webpack_require__(197);
	
	var _tszReportParam2 = _interopRequireDefault(_tszReportParam);
	
	var _tszScrollTop = __webpack_require__(201);
	
	var _tszScrollTop2 = _interopRequireDefault(_tszScrollTop);
	
	var _tszToast = __webpack_require__(204);
	
	var _tszToast2 = _interopRequireDefault(_tszToast);
	
	var _tszTeam = __webpack_require__(203);
	
	var _tszTeam2 = _interopRequireDefault(_tszTeam);
	
	var _tszUserSettings = __webpack_require__(207);
	
	var _tszUserSettings2 = _interopRequireDefault(_tszUserSettings);
	
	var _tszImportCsv = __webpack_require__(181);
	
	var _tszImportCsv2 = _interopRequireDefault(_tszImportCsv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentsModule = _angular2.default.module('meredicte.components', [_tszCompanyActions2.default.name, _tszCompanySettings2.default.name, _tszCompanySubscriptions2.default.name, _tszContact2.default.name, _tszLoading2.default.name, _tszNotificationBadge2.default.name, _tszPriceCalculator2.default.name, _tszPricing2.default.name, _tszProgressBar2.default.name, _tszReport2.default.name, _tszReportActions2.default.name, _tszReportMenuActions2.default.name, _tszReportParam2.default.name, _tszScrollTop2.default.name, _tszToast2.default.name, _tszTeam2.default.name, _tszUserSettings2.default.name, _tszImportCsv2.default.name]);
	
	exports.default = componentsModule;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$scope", "$state", "$mdDialog", "$tszToast", "CompanyService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tszCompanyActions = __webpack_require__(127);
	
	var _tszCompanyActions2 = _interopRequireDefault(_tszCompanyActions);
	
	__webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($scope, $state, $mdDialog, $tszToast, CompanyService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.delete = function (ev) {
	    CompanyService.deleteAction(_this.company, ev, function () {
	      $scope.$emit('company_deleted', _this.company.id);
	    });
	  };
	
	  this.edit = function () {
	    $state.go('admin_company', { id: _this.company.id, name: _this.company.name });
	  };
	}
	
	exports.default = {
	  template: _tszCompanyActions2.default,
	  bindings: {
	    company: '<'
	  },
	  controller: controller
	};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszCompanyActions = __webpack_require__(172);
	
	var _tszCompanyActions2 = _interopRequireDefault(_tszCompanyActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszCompanyActionsModule = _angular2.default.module('tsz.components.tszCompanyActions', []).component('tszCompanyActions', _tszCompanyActions2.default);
	
	exports.default = tszCompanyActionsModule;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$localStorage", "$tszToast", "CompanyService", "AuthService", "Upload"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tszCompanySettings = __webpack_require__(128);
	
	var _tszCompanySettings2 = _interopRequireDefault(_tszCompanySettings);
	
	__webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($localStorage, $tszToast, CompanyService, AuthService, Upload) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.company = {};
	
	  this.loadCompanySettings = function () {
	    CompanyService.get(_this.companyId).then(function (response) {
	      _this.company = response.toJSON();
	    }).catch(function () {
	      $tszToast.showError('Se ha producido un error al cargar los detalles de la compañía');
	    });
	  };
	
	  this.updateCompanySettings = function () {
	    var c = {
	      name: _this.company.name,
	      cif: _this.company.cif
	    };
	    CompanyService.update(_this.companyId, c).then(function (response) {
	      _this.company = response.toJSON();
	      AuthService.mergeCredentials({
	        companyId: _this.company.id,
	        companyName: _this.company.name,
	        cif: _this.company.cif
	      });
	      $tszToast.showSuccess('Perfil guardado');
	    }).catch(function () {
	      $tszToast.showError('Se ha producido un error al guardar los detalles de la compañía');
	    });
	  };
	
	  this.uploadFile = function (file) {
	    Upload.upload({
	      url: '/api/companies/' + _this.company.id + '/logo',
	      file: file
	    }).success(function (data, status, headers, config) {
	      console.log('file ' + config.file.name + ' uploaded. Response: ' + data);
	      _this.company.logo = data;
	      $localStorage.user.logo = data;
	      AuthService.setCredentials($localStorage.user);
	      $tszToast.showSuccess('Logo atualizado correctamente');
	    });
	  };
	
	  //
	  // INIT
	  //
	
	  this.loadCompanySettings();
	}
	
	exports.default = {
	  template: _tszCompanySettings2.default,
	  bindings: {
	    companyId: '<'
	  },
	  controller: controller
	};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszCompanySettings = __webpack_require__(174);
	
	var _tszCompanySettings2 = _interopRequireDefault(_tszCompanySettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszCompanySettingsModule = _angular2.default.module('tsz.components.tszCompanySettings', []).component('tszCompanySettings', _tszCompanySettings2.default);
	
	exports.default = tszCompanySettingsModule;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$tszToast", "$mdDialog", "AdminService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _config = __webpack_require__(2);
	
	var _tszCompanySubscriptions = __webpack_require__(130);
	
	var _tszCompanySubscriptions2 = _interopRequireDefault(_tszCompanySubscriptions);
	
	__webpack_require__(110);
	
	var _editSubscription = __webpack_require__(129);
	
	var _editSubscription2 = _interopRequireDefault(_editSubscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($tszToast, $mdDialog, AdminService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.subscriptions = [];
	
	  this.loadCompanySubscriptions = function () {
	    AdminService.getSubscriptions(_this.companyId).then(function (response) {
	      _this.subscriptions = response;
	    }).catch(function () {
	      $tszToast.showError('Se ha producido un error al cargar las suscripciones de la compañía');
	    });
	  };
	
	  this.create = function () {
	    _this.edit({
	      startDate: new Date(),
	      endDate: new Date(),
	      paymentDueDate: new Date()
	    });
	  };
	
	  this.edit = function (subscription) {
	
	    $mdDialog.show({
	      controller: ["$scope", function controller($scope) {
	
	        $scope.subscription = {
	          id: subscription.id,
	          plan: subscription.plan,
	          startDate: new Date(subscription.startDate),
	          endDate: new Date(subscription.endDate),
	          paymentDueDate: new Date(subscription.paymentDueDate),
	          paymentDue: subscription.paymentDue
	        };
	
	        $scope.plans = _config.PLANS;
	
	        $scope.save = function () {
	
	          var s = {
	            plan: $scope.subscription.plan,
	            startDate: new Date($scope.subscription.startDate).getTime(),
	            endDate: new Date($scope.subscription.endDate).getTime(),
	            paymentDueDate: new Date($scope.subscription.paymentDueDate).getTime(),
	            paymentDue: $scope.subscription.paymentDue
	          };
	
	          if ($scope.subscription.id) {
	            AdminService.updateSubscription(_this.companyId, $scope.subscription.id, s).then(function () {
	              $mdDialog.hide();
	              $tszToast.showSuccess('Guardado');
	              _this.loadCompanySubscriptions();
	            }).catch(function () {
	              $tszToast.showError('Se ha producido un error al actualizar la suscripción');
	            });
	          } else {
	            AdminService.createSubscription(_this.companyId, s).then(function () {
	              $tszToast.showSuccess('La suscripción se ha creado correctamente');
	              _this.loadCompanySubscriptions();
	              $mdDialog.hide();
	            }).catch(function () {
	              $tszToast.showError('Se ha producido un error al crear la suscripción');
	            });
	          }
	        };
	
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: _editSubscription2.default,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	
	  this.showDeleteConfirm = function (subscription, ev) {
	    // Appending dialog to document.body to cover sidenav in docs app
	    var confirm = $mdDialog.confirm().title('¿Eliminar suscripción?').textContent('Esta operación eliminará de forma irreversible la suscripción seleccionada.').ariaLabel('Eliminar suscripción').targetEvent(ev).ok('Aceptar').cancel('Cancelar');
	
	    $mdDialog.show(confirm).then(function () {
	      _this.delete(subscription);
	    });
	  };
	
	  this.delete = function (subscription) {
	    AdminService.deleteSubscription(_this.companyId, subscription.id).then(function () {
	      $tszToast.showSuccess('Suscripción eliminada correctamente');
	      _this.loadCompanySubscriptions();
	    }).catch(function () {
	      $tszToast.showError('Se ha producido un error al eliminar la suscripción');
	    });
	  };
	
	  //
	  // INIT
	  //
	
	  this.loadCompanySubscriptions();
	}
	
	exports.default = {
	  template: _tszCompanySubscriptions2.default,
	  bindings: {
	    companyId: '<'
	  },
	  controller: controller
	};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszCompanySubscriptions = __webpack_require__(176);
	
	var _tszCompanySubscriptions2 = _interopRequireDefault(_tszCompanySubscriptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszCompanySubscriptionsModule = _angular2.default.module('tsz.components.tszCompanySubscriptions', []).component('tszCompanySubscriptions', _tszCompanySubscriptions2.default);
	
	exports.default = tszCompanySubscriptionsModule;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszContact = __webpack_require__(132);
	
	var _tszContact2 = _interopRequireDefault(_tszContact);
	
	__webpack_require__(111);
	
	var _contact = __webpack_require__(131);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($mdDialog) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.showContactForm = function (ev) {
	
	    $mdDialog.show({
	      controller: ["$scope", "AuthService", "ContactService", "$tszToast", function controller($scope, AuthService, ContactService, $tszToast) {
	
	        $scope.message = {};
	
	        var user = AuthService.getAuthenticatedUser();
	        if (user) {
	          $scope.message.name = user.name;
	          $scope.message.phone = user.phone;
	          $scope.message.email = user.email;
	        }
	
	        $scope.send = function () {
	          _this.loading = true;
	          console.log(JSON.stringify($scope.message));
	          ContactService.send($scope.message).then(function () {
	            $tszToast.showSuccess('Mensaje enviado');
	            $mdDialog.hide();
	          }).catch(function () {
	            $tszToast.showError('Error al intentar enviar el mensaje');
	          }).finally(function () {
	            _this.loading = false;
	          });
	        };
	
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: _contact2.default,
	      parent: _angular2.default.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose: true,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	
	  this.showPrivacyPolicyDialog = function (ev) {
	    $mdDialog.show({
	      controller: ["$scope", function controller($scope) {
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      controllerAs: 'ctrl',
	      templateUrl: '/static/modals/privacy_policy.html',
	      parent: _angular2.default.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose: true,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	}
	
	exports.default = {
	  template: _tszContact2.default,
	  bindings: {
	    companyId: '<',
	    label: '@'
	  },
	  controller: controller
	};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszContact = __webpack_require__(178);
	
	var _tszContact2 = _interopRequireDefault(_tszContact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszContactModule = _angular2.default.module('tsz.components.tszContact', []).component('tszContact', _tszContact2.default);
	
	exports.default = tszContactModule;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszImportCsv = __webpack_require__(134);
	
	var _tszImportCsv2 = _interopRequireDefault(_tszImportCsv);
	
	__webpack_require__(112);
	
	var _modal = __webpack_require__(133);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($mdDialog) {
	
	  'ngInject';
	
	  this.showModal = function (ev) {
	
	    $mdDialog.show({
	      controller: ["$scope", "$rootScope", "ReportService", function controller($scope, $rootScope, ReportService) {
	
	        $scope.loading = false;
	
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	
	        $scope.importCsv = function (csv) {
	          ReportService.download_csv(csv).then(function (report) {
	            $scope.close();
	            $rootScope.$broadcast('import_report', report);
	          }).catch(function () {
	            $scope.serverError = 'No se ha encontrado ningún proyecto con el CSV especificado';
	          });
	        };
	      }],
	      template: _modal2.default,
	      parent: _angular2.default.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose: true,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	}
	
	exports.default = {
	  template: _tszImportCsv2.default,
	  controller: controller
	};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszImportCsv = __webpack_require__(180);
	
	var _tszImportCsv2 = _interopRequireDefault(_tszImportCsv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszImportCsvModule = _angular2.default.module('tsz.components.tszImportCsv', []).component('tszImportCsv', _tszImportCsv2.default);
	
	exports.default = tszImportCsvModule;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tszLoading = __webpack_require__(135);
	
	var _tszLoading2 = _interopRequireDefault(_tszLoading);
	
	__webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  template: _tszLoading2.default
	};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszLoading = __webpack_require__(182);
	
	var _tszLoading2 = _interopRequireDefault(_tszLoading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszLoadingModule = _angular2.default.module('tsz.components.tszLoading', []).component('tszLoading', _tszLoading2.default);
	
	exports.default = tszLoadingModule;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tszNotificationBadge = __webpack_require__(136);
	
	var _tszNotificationBadge2 = _interopRequireDefault(_tszNotificationBadge);
	
	__webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  template: _tszNotificationBadge2.default,
	  bindings: {
	    total: '<',
	    hideWhenOk: '<'
	  }
	};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszNotificationBadge = __webpack_require__(184);
	
	var _tszNotificationBadge2 = _interopRequireDefault(_tszNotificationBadge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszNotificationBadgeModule = _angular2.default.module('tsz.components.tszNotificationBadge', []).component('tszNotificationBadge', _tszNotificationBadge2.default);
	
	exports.default = tszNotificationBadgeModule;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _config = __webpack_require__(2);
	
	var _tszPriceCalculator = __webpack_require__(138);
	
	var _tszPriceCalculator2 = _interopRequireDefault(_tszPriceCalculator);
	
	__webpack_require__(115);
	
	var _calculator = __webpack_require__(137);
	
	var _calculator2 = _interopRequireDefault(_calculator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($mdDialog) {
	
	  'ngInject';
	
	  this.showCalculator = function (ev) {
	
	    $mdDialog.show({
	      controller: ["$scope", "ReportService", function controller($scope, ReportService) {
	
	        $scope.loading = false;
	
	        $scope.BUILDING_USAGE = _config.CONSTANTS.BUILDING_USAGE;
	        $scope.PROJECT_TYPE = _config.CONSTANTS.PROJECT_TYPE;
	
	        $scope.report = {};
	        $scope.price = 0;
	
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	
	        $scope.refreshPricing = function () {
	          if ($scope.report.building_usage && $scope.report.design_type && $scope.report.area) {
	            $scope.loading = true;
	            ReportService.getBasePrice($scope.report).then(function (response) {
	              $scope.price = response.price.toFixed(2);
	            }).catch(function () {
	              console.log('Error calculating report price');
	            }).finally(function () {
	              $scope.loading = false;
	            });
	          }
	        };
	      }],
	      template: _calculator2.default,
	      parent: _angular2.default.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose: true,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	}
	
	exports.default = {
	  template: _tszPriceCalculator2.default,
	  bindings: {
	    companyId: '<'
	  },
	  controller: controller
	};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszPriceCalculator = __webpack_require__(186);
	
	var _tszPriceCalculator2 = _interopRequireDefault(_tszPriceCalculator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszPriceCalculatorModule = _angular2.default.module('tsz.components.tszPriceCalculator', []).component('tszPriceCalculator', _tszPriceCalculator2.default);
	
	exports.default = tszPriceCalculatorModule;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$rootScope", "$tszToast", "$sce", "AuthService", "SubscriptionService", "PlanService", "PropertyService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(6);
	
	var _tszPricing = __webpack_require__(139);
	
	var _tszPricing2 = _interopRequireDefault(_tszPricing);
	
	__webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($rootScope, $tszToast, $sce, AuthService, SubscriptionService, PlanService, PropertyService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.roles = _config.ROLES;
	
	  this.plans = {};
	
	  this.monthly = true;
	
	  this.showEnterpriseButton = function () {
	    return !_this.public && _this.activeSubscription.plan === 'ENTERPRISE';
	  };
	  this.showProfessionalButton = function () {
	    return !_this.public && _this.activeSubscription.plan === 'PROFESSIONAL';
	  };
	
	  this.showPurchaseButton = function () {
	    return !_this.public && !(_this.activeSubscription && _this.activeSubscription.plan);
	  };
	
	  this.showCancelButton = function () {
	    return !_this.public && _this.activeSubscription.status === 'COMPLETED' && _this.activeSubscription.endDate && _this.activeSubscription.monthly;
	  };
	
	  this.setMonthly = function (monthly) {
	    _this.monthly = monthly;
	  };
	
	  this.activeSubscription = {};
	
	  this.loadPlans = function () {
	    PlanService.list().then(function (result) {
	      _this.plans = (0, _lodash.keyBy)(result, 'code');
	      console.log(JSON.stringify(_this.plans));
	    }).catch(function () {
	      $tszToast.showError('Error al cargar la lista de planes');
	    });
	  };
	
	  this.loadCompanySubscription = function (companyId) {
	    SubscriptionService.get(companyId).then(function (data) {
	      _this.activeSubscription = data;
	      if ((0, _lodash.has)(data, 'monthly')) {
	        _this.monthly = data.monthly;
	      }
	    }).catch(function () {
	      $tszToast.showError('Se ha producido un error al intentar cargar las suscripciones');
	    });
	  };
	
	  this.subscribe = function (plan) {
	
	    console.log('subscribe: plan ' + plan + ' ' + _this.companyId);
	
	    SubscriptionService.create(_this.companyId, plan, _this.monthly).then(function (data) {
	      document.getElementById('Ds_SignatureVersion').value = data.dsSignatureVersion;
	      document.getElementById('Ds_MerchantParameters').value = data.dsMerchantParameters;
	      document.getElementById('Ds_Signature').value = data.dsSignature;
	      var redsysForm = document.getElementById('redsysForm');
	      redsysForm.action = data.redsysUrl;
	      redsysForm.submit();
	    }).catch(function () {
	      $tszToast.showError('Se ha producido un error al intentar crear la suscripción');
	    });
	  };
	
	  this.save = function ($form) {
	    if ($form.$valid) {
	      $form.commit();
	    }
	  };
	
	  this.cancelSubscription = function () {
	    _this.cancellingSubscription = true;
	    SubscriptionService.cancel(_this.companyId, _this.activeSubscription.id).then(function (data) {
	      _this.activeSubscription = data;
	      $tszToast.showSuccess('La suscripción ha sido cancelada satisfactoriamente');
	    }).catch(function () {
	      $tszToast.showError('Se ha producido un error al intentar cancelar la suscripción');
	    }).finally(function () {
	      _this.cancellingSubscription = false;
	    });
	  };
	
	  this.loadPromotionalMessage = function () {
	    PropertyService.get(_config.CONSTANTS.PROPERTY.PROMOTIONAL_MSG).then(function (result) {
	      _this.promotionalMessage = result.value;
	    }).catch(function () {
	      $tszToast.showError('Error al cargar la lista de planes');
	    });
	  };
	
	  this.init = function () {
	    _this.loadPromotionalMessage();
	    _this.loadPlans();
	    if (_this.companyId) {
	      _this.loadCompanySubscription(_this.companyId);
	    }
	  };
	
	  this.init();
	}
	
	exports.default = {
	  template: _tszPricing2.default,
	  bindings: {
	    companyId: '<',
	    public: '<'
	  },
	  controller: controller
	};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszPricing = __webpack_require__(188);
	
	var _tszPricing2 = _interopRequireDefault(_tszPricing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszPricingModule = _angular2.default.module('tsz.components.tszPricing', []).component('tszPricing', _tszPricing2.default);
	
	exports.default = tszPricingModule;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tszProgressBar = __webpack_require__(140);
	
	var _tszProgressBar2 = _interopRequireDefault(_tszProgressBar);
	
	__webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  template: _tszProgressBar2.default,
	  bindings: {
	    max: '<',
	    value: '<'
	  }
	};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszProgressBar = __webpack_require__(190);
	
	var _tszProgressBar2 = _interopRequireDefault(_tszProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszProgressBarModule = _angular2.default.module('tsz.components.tszProgressBar', []).component('tszProgressBar', _tszProgressBar2.default);
	
	exports.default = tszProgressBarModule;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$state", "$scope", "$mdDialog", "$tszToast", "ReportService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tszReportActions = __webpack_require__(141);
	
	var _tszReportActions2 = _interopRequireDefault(_tszReportActions);
	
	__webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($state, $scope, $mdDialog, $tszToast, ReportService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.delete = function (ev) {
	    ReportService.deleteAction(_this.report, ev, function () {
	      $scope.$emit('report_deleted', _this.report.id);
	    });
	  };
	
	  this.download = function () {
	    ReportService.download(_this.report);
	  };
	
	  this.export = function () {
	    ReportService.export(_this.report);
	  };
	
	  this.duplicate = function () {
	    ReportService.duplicate(_this.report.id).then(function (response) {
	      $scope.$emit('report_duplicated', response);
	    });
	  };
	
	  this.edit = function () {
	    $state.go('report', { id: _this.report.id });
	  };
	}
	
	exports.default = {
	  template: _tszReportActions2.default,
	  bindings: {
	    report: '<'
	  },
	  controller: controller
	};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszReportActions = __webpack_require__(192);
	
	var _tszReportActions2 = _interopRequireDefault(_tszReportActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszReportActionsModule = _angular2.default.module('tsz.components.tszReportActions', []).component('tszReportActions', _tszReportActions2.default);
	
	exports.default = tszReportActionsModule;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$state", "$scope", "$mdDialog", "$tszToast", "$mdBottomSheet", "ReportService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tszReportMenuActions = __webpack_require__(143);
	
	var _tszReportMenuActions2 = _interopRequireDefault(_tszReportMenuActions);
	
	__webpack_require__(119);
	
	var _reportActionsTpl = __webpack_require__(142);
	
	var _reportActionsTpl2 = _interopRequireDefault(_reportActionsTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($state, $scope, $mdDialog, $tszToast, $mdBottomSheet, ReportService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.delete = function (ev) {
	    $mdBottomSheet.hide();
	    ReportService.deleteAction(_this.report, ev, function () {
	      $scope.$emit('report_deleted', _this.report.id);
	    });
	  };
	
	  this.download = function () {
	    $mdBottomSheet.hide();
	    ReportService.download(_this.report);
	  };
	
	  this.export = function () {
	    $mdBottomSheet.hide();
	    ReportService.export(_this.report);
	  };
	
	  this.edit = function () {
	    $mdBottomSheet.hide('edit');
	  };
	
	  this.duplicate = function () {
	    $mdBottomSheet.hide();
	    ReportService.duplicate(_this.report.id).then(function (response) {
	      $scope.$emit('report_duplicated', response);
	    });
	  };
	
	  this.openBottomSheet = function () {
	    $mdBottomSheet.show({
	      template: _reportActionsTpl2.default,
	      clickOutsideToClose: true,
	      scope: $scope,
	      preserveScope: true
	    })
	
	    // Fires when the hide() method is used
	    .then(function (action) {
	      if (action === 'edit') {
	        $state.go('report', { id: _this.report.id });
	      }
	    });
	  };
	}
	
	exports.default = {
	  template: _tszReportMenuActions2.default,
	  bindings: {
	    report: '<'
	  },
	  controller: controller
	};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszReportMenuActions = __webpack_require__(194);
	
	var _tszReportMenuActions2 = _interopRequireDefault(_tszReportMenuActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszReportMenuActionsModule = _angular2.default.module('tsz.components.tszReportMenuActions', []).component('tszReportMenuActions', _tszReportMenuActions2.default);
	
	exports.default = tszReportMenuActionsModule;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(6);
	
	var _tszReportParam = __webpack_require__(144);
	
	var _tszReportParam2 = _interopRequireDefault(_tszReportParam);
	
	__webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($rootScope, $mdDialog) {
	  var _this = this;
	
	  var SECTOR_USAGES = ['c1', 'c3', 'c4', 'c5', 'c6', 'ea1'];
	
	  this.onParamChange = function (parameter) {
	
	    // Update all params of sector usages
	    if ((0, _lodash.includes)(SECTOR_USAGES, parameter)) {
	      var val = _this.report[parameter];
	      var n = val.substring(val.lastIndexOf('.') + 1);
	      (0, _lodash.forEach)(SECTOR_USAGES, function (u) {
	        _this.report[u] = u + '.' + n;
	      });
	    }
	
	    _this.callback();
	  };
	
	  // this.showInfoDialog = (parameter) => {
	  //   console.log(`clickReportParamInfo event sent: ${parameter}`);
	  //   $rootScope.$broadcast('clickReportParamInfo', parameter);
	  // };
	
	  this.showInfoDialog = function (param) {
	
	    $mdDialog.show({
	      controller: function controller($scope) {
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      },
	      controllerAs: 'ctrl',
	      templateUrl: '/static/modals/' + param + '_' + _this.version + '.html',
	      clickOutsideToClose: true,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	
	  this.showTextDialog = function (title, text) {
	    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title(title).textContent('' + text).ariaLabel(title).ok('Ok'));
	  };
	
	  this.showDivider = function (parameter, last) {
	    return !parameter.type && !last;
	  };
	}
	
	exports.default = {
	  template: _tszReportParam2.default,
	  controller: controller,
	  bindings: {
	    param: '<',
	    version: '<',
	    section: '<',
	    callback: '&',
	    report: '=',
	    editable: '='
	  }
	};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszReportParam = __webpack_require__(196);
	
	var _tszReportParam2 = _interopRequireDefault(_tszReportParam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszReportParamModule = _angular2.default.module('tsz.components.tszReportParam', []).component('tszReportParam', _tszReportParam2.default);
	
	exports.default = tszReportParamModule;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$filter", "$scope", "$rootScope", "$state", "$stateParams", "$tszToast", "$mdDialog", "$mdMedia", "$base64", "AuthService", "CatalogService", "ReportService", "CompanyService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(6);
	
	var _tszReport = __webpack_require__(145);
	
	var _tszReport2 = _interopRequireDefault(_tszReport);
	
	__webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($filter, $scope, $rootScope, $state, $stateParams, $tszToast, $mdDialog, $mdMedia, $base64, AuthService, CatalogService, ReportService, CompanyService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  var PROJECT = 'PROJECT';
	
	  var PROJECT_KEYS = ['name', 'province', 'address', 'postal_code', 'code', 'evaluator', 'design_type', 'building_usage', 'area'];
	
	  this.PROJECT_ID = PROJECT;
	
	  this.parameters = ['AS', 'T', 'CO', 'CA', 'NPA', 'RFE', 'P', 'EO', 'IPCI', 'IB'];
	
	  this.meredicteVersion = $stateParams.v ? _config.CONSTANTS.VERSION[$stateParams.v] : _config.CONSTANTS.VERSION.V2;
	
	  this.BUILDING_USAGE = _config.CONSTANTS.BUILDING_USAGE;
	  this.PROJECT_TYPE = _config.CONSTANTS.PROJECT_TYPE;
	
	  this.emptyCounter = {};
	  this.totals = {};
	
	  this.refreshTotal = function () {
	    _this.total = _this.meredicteVersion.nParams + PROJECT_KEYS.length;
	    console.log(_this.total);
	  };
	
	  this.report = {};
	  this.savedReport = {};
	
	  this.changed = false;
	
	  this.loading = false;
	
	  this.generatingReport = false;
	  this.downloadingReport = false;
	
	  this.completion = 0;
	
	  this.completed = false; // all params
	
	  this.provinces = _config.PROVINCES;
	
	  this.companyId = AuthService.getCompanyId();
	
	  this.canGenerateReports = AuthService.canGenerateReports();
	  this.canEditParameters = AuthService.canEditParameters();
	  this.canSeeCuantitativeResults = AuthService.canSeeCuantitativeResults();
	  this.canCompareProjects = AuthService.canCompareProjects();
	
	  this.bigScreen = $mdMedia('gt-md');
	
	  var BAR_COLORS = ['#C55A11', '#2E75B5', '#7CB653'];
	
	  this.chartOptions = {
	    tooltips: { enabled: this.canSeeCuantitativeResults },
	    legend: { display: false }
	  };
	
	  this.mainChart = {
	    labels: ['PP', 'NPG', 'NRG'],
	    datasetOverride: { backgroundColor: BAR_COLORS, borderColor: BAR_COLORS }
	  };
	
	  //
	  // REPORT ACTIONS
	  //
	
	  this.isSaveBtnEnabled = function () {
	    return _this.changed && !_this.report.downloadable;
	  };
	
	  this.showGenerateReportBtn = function () {
	    return _this.completed && !_this.report.downloadable;
	  };
	
	  this.showGenerateReportBox = function () {
	    return _this.canGenerateReports && !_this.report.downloadable && (_this.completed || _this.price > 0);
	  };
	
	  this.refresh = function () {
	    _this.refreshTotal();
	    _this.refreshAllCounters();
	    _this.refreshPricing();
	    _this.checkChanges();
	  };
	
	  this.isBase64 = function (str) {
	    var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
	    return base64regex.test(str);
	  };
	
	  // compatibility: json or base64
	  this.importReport = function ($fileContent) {
	    var reportId = _this.report.id;
	
	    var report = $fileContent;
	
	    if ((0, _lodash.isString)($fileContent)) {
	      var content = _this.isBase64($fileContent) ? $base64.decode($fileContent) : $fileContent;
	      report = JSON.parse(content);
	    }
	
	    // if the imported file doesn't contain the version, assume V1
	    if (!report.meredicteVersion) {
	      report.meredicteVersion = _config.CONSTANTS.VERSION.V1.name;
	    }
	
	    if (report.meredicteVersion !== $stateParams.v) {
	      $state.transitionTo('report', { v: report.meredicteVersion }, { notify: false });
	    }
	
	    _this.meredicteVersion = _config.CONSTANTS.VERSION[report.meredicteVersion];
	    _this.loadReportSchema();
	
	    report.id = reportId;
	    _this.report = report;
	    _this.savedReport = (0, _lodash.clone)(report);
	    _this.report.generated = false;
	    _this.report.downloadable = false;
	    _this.refresh();
	    _this.calculate(_this.report);
	
	    _this.changed = true; // to enable save without updating any field
	  };
	
	  var importEventListener = $scope.$on('import_report', function (event, report) {
	    _this.importReport(report);
	    $tszToast.showSuccess('Proyecto "' + report.name + '" importado correctamente');
	  });
	
	  $scope.$on('$destroy', function () {
	    importEventListener();
	  });
	
	  this.delete = function (ev) {
	    ReportService.deleteAction(_this.report, ev, function () {
	      $state.go('home');
	    });
	  };
	
	  this.export = function () {
	    ReportService.export(_this.report);
	  };
	
	  //
	  // Report rendering
	  //
	
	  this.showCategory = function (category) {
	    return category.subcategories && category.subcategories.length > 1 || category.parameters && category.parameters.length > 1;
	  };
	
	  this.calculate = function (report) {
	    ReportService.calculate(report).then(function (response) {
	      _this.reportOutput = response;
	      _this.refreshMainChart();
	    }).catch(function () {
	      $tszToast.showError('Se ha producido un error al calcular el informe');
	    });
	  };
	
	  this.refreshMainChart = function () {
	    if (_this.selectedReport) {
	      _this.mainChart.data = [[$filter('number')(_this.reportOutput.pp, 2), $filter('number')(_this.reportOutput.npg, 2), $filter('number')(_this.reportOutput.nrg, 2)], [$filter('number')(_this.selectedReport.pp, 2), $filter('number')(_this.selectedReport.npg, 2), $filter('number')(_this.selectedReport.nrg, 2)]];
	      _this.mainChart.series = [$filter('limitTo')(_this.report.name, 30), $filter('limitTo')(_this.selectedReport.name, 30)];
	      _this.chartOptions.legend.display = true;
	    } else {
	      _this.mainChart.data = [$filter('number')(_this.reportOutput.pp, 2), $filter('number')(_this.reportOutput.npg, 2), $filter('number')(_this.reportOutput.nrg, 2)];
	      _this.mainChart.series = null;
	      _this.chartOptions.legend.display = false;
	    }
	
	    _this.mainChart.datasetOverride.backgroundColor[2] = $filter('nrgColor')(_this.reportOutput.nrg);
	    _this.nrgStyle = { color: $filter('nrgColor')(_this.reportOutput.nrg) };
	  };
	
	  this.download = function () {
	    ReportService.download(_this.report);
	  };
	
	  this.generateFreeReport = function () {
	    ReportService.generate(_this.reportId).then(function () {
	      $tszToast.showSuccess('Informe generado correctamente');
	      _this.report.generated = true;
	      _this.report.downloadable = true;
	    }).catch(function () {
	      $tszToast.showError('Se ha producido un error al generar el informe');
	    }).finally(function () {
	      _this.generatingReport = false;
	    });
	  };
	
	  this.generateAndRedirectToTPV = function () {
	    CompanyService.getPaymentDetails(_this.companyId, _this.reportId).then(function (data) {
	      document.getElementById('Ds_SignatureVersion').value = data.dsSignatureVersion;
	      document.getElementById('Ds_MerchantParameters').value = data.dsMerchantParameters;
	      document.getElementById('Ds_Signature').value = data.dsSignature;
	      var redsysForm = document.getElementById('redsysForm');
	      redsysForm.action = data.redsysUrl;
	      redsysForm.submit();
	    }).catch(function () {
	      $tszToast.showError('Se ha producido un error durante la generación del informe');
	    }).finally(function () {
	      _this.generatingReport = false;
	    });
	  };
	
	  this.generate = function () {
	    _this.generatingReport = true;
	    if (AuthService.isAdmin()) {
	      _this.generateFreeReport();
	    } else if (_this.price > 0) {
	      _this.generateAndRedirectToTPV();
	    } else {
	      _this.generateFreeReport();
	    }
	  };
	
	  this.save = function () {
	    _this.loading = true;
	
	    if (_this.reportId) {
	      // UPDATE REPORT
	      ReportService.update(_this.report).then(function (response) {
	        _this.report = response.toJSON();
	        _this.savedReport = (0, _lodash.clone)(_this.report);
	        $tszToast.showSuccess('Informe guardado');
	      }).catch(function (err) {
	        if (err.data && err.data.code) {
	          $tszToast.showErrorI18n(err.data.code, 'Se ha producido un error al actualizar el informe');
	        } else {
	          $tszToast.showError('Se ha producido un error al actualizar el informe');
	        }
	      }).finally(function () {
	        _this.loading = false;
	        _this.checkChanges();
	      });
	    } else {
	      // CREATE REPORT
	      ReportService.create(_this.report).then(function (response) {
	        _this.report = response.toJSON();
	        _this.savedReport = (0, _lodash.clone)(_this.report);
	        var extras = {
	          toast: {
	            message: 'Informe guardado satisfactoriamente.',
	            opts: { success: true }
	          }
	        };
	        $state.go('report', { id: _this.report.id, extras: extras });
	      }).catch(function (err) {
	        if (err.data && err.data.code) {
	          $tszToast.showErrorI18n(err.data.code, 'Se ha producido un error al crear el informe');
	        } else {
	          $tszToast.showError('Se ha producido un error al crear el informe');
	        }
	      }).finally(function () {
	        _this.loading = false;
	        _this.checkChanges();
	      });
	    }
	  };
	
	  this.refreshPricing = function () {
	    if (_this.report.building_usage && _this.report.design_type && _this.report.area) {
	      ReportService.getPrice(_this.companyId, _this.report).then(function (response) {
	        _this.price = Math.round(response.price);
	      }).catch(function (err) {
	        _this.error = err.message;
	      });
	    } else {
	      _this.price = '---';
	    }
	  };
	
	  this.refreshAllCounters = function () {
	    _this.refreshProjectCounters();
	    (0, _lodash.forEach)(_this.reportSchema, function (p) {
	      _this.refreshCounters(p);
	    });
	  };
	
	  this.refreshProgress = function () {
	    _this.completion = (0, _lodash.reduce)(_this.emptyCounter, function (p, c) {
	      return p - c;
	    }, _this.total);
	    _this.completed = _this.completion === _this.total;
	  };
	
	  this.refreshProjectCounters = function () {
	    _this.refreshCounters(PROJECT);
	  };
	
	  this.checkChanges = function () {
	    _this.changed = !(0, _lodash.isEqual)(_this.report, _this.savedReport);
	  };
	
	  this.onParamChange = function (p) {
	    _this.checkChanges();
	    _this.refreshCounters(p);
	    _this.refreshProgress();
	    _this.calculate(_this.report);
	  };
	
	  this.refreshCounters = function (p) {
	
	    var keys = [];
	
	    if (p === PROJECT) {
	      keys = PROJECT_KEYS;
	    } else {
	      if (p.parameters) {
	        keys = (0, _lodash.concat)(keys, (0, _lodash.map)((0, _lodash.filter)(p.parameters, function (o) {
	          return o.type !== 'title';
	        }), 'name'));
	      }
	      (0, _lodash.forEach)(p.categories, function (category) {
	        keys = (0, _lodash.concat)(keys, (0, _lodash.map)(category.parameters, 'name'));
	        (0, _lodash.forEach)(category.subcategories, function (subcategory) {
	          keys = (0, _lodash.concat)(keys, (0, _lodash.map)(subcategory.parameters, 'name'));
	        });
	      });
	    }
	
	    var total = keys.length;
	    var empty = 0;
	
	    (0, _lodash.each)(keys, function (key) {
	      if (_this.report[key] !== 0 && !_this.report[key]) {
	        empty += 1;
	      }
	    });
	
	    if (p.name) {
	      _this.emptyCounter[p.name] = empty;
	      _this.totals[p.name] = total;
	    } else {
	      _this.emptyCounter[p] = empty;
	      _this.totals[p] = total;
	    }
	
	    _this.refreshProgress();
	  };
	
	  this.loadCalculatedReports = function (id) {
	    ReportService.get_calculated_reports(id).then(function (result) {
	      _this.reports = (0, _lodash.remove)(result, function (o) {
	        return o.id != _this.reportId;
	      }); // eslint-disable-line
	      if (_this.reports) {
	        _this.showCompareSelect = true;
	      }
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  this.compareProject = function () {
	    _this.selectedReport = JSON.parse(_this.selectedReportRaw);
	    if (_this.selectedReport) {
	      _this.comparisonMode = true;
	    } else {
	      _this.comparisonMode = false;
	    }
	
	    console.log('comparisonMode: ' + _this.comparisonMode);
	
	    _this.refreshMainChart();
	  };
	
	  this.loadReport = function (reportId) {
	
	    _this.loading = true;
	    ReportService.get(reportId).then(function (response) {
	      _this.report = response.toJSON();
	      _this.meredicteVersion = _config.CONSTANTS.VERSION[_this.report.meredicteVersion];
	      _this.savedReport = (0, _lodash.clone)(_this.report);
	
	      _this.loadReportSchema();
	      _this.calculate(_this.report);
	      _this.refresh();
	    }).catch(function (err) {
	      _this.error = err.message;
	    }).finally(function () {
	      _this.loading = false;
	    });
	  };
	
	  this.loadReportSchema = function () {
	    CatalogService.getReportSchema(_this.meredicteVersion.name).then(function (response) {
	      _this.reportSchema = response.data;
	      _this.refresh();
	    }).catch(function (err) {
	      console.error('Error getting report schema: ' + err);
	    }).finally(function () {
	      // something
	    });
	  };
	
	  this.showOptionInfoDialog = function (param) {
	
	    $mdDialog.show({
	      controller: function controller() {
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      },
	      controllerAs: 'ctrl',
	      templateUrl: '/static/modals/' + param + '.html',
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	
	  this.loadReportSchema();
	
	  if (this.canCompareProjects) {
	    this.loadCalculatedReports(this.companyId);
	  }
	
	  if (this.reportId) {
	    // update
	    this.loadReport(this.reportId);
	  } else {
	    // create
	    this.report = {
	      meredicteVersion: this.meredicteVersion.name
	    };
	    this.calculate(this.report);
	  }
	
	  if ($state.params.extras) {
	    var params = $state.params.extras;
	    if (params.toast) {
	      var toast = params.toast;
	      $tszToast.show(toast.message, toast.opts);
	    }
	  }
	
	  $rootScope.$on('clickReportParamInfo', function (event, parameter) {
	    console.log('clickReportParamInfo event received: ' + parameter);
	    _this.showOptionInfoDialog(parameter);
	  });
	}
	
	exports.default = {
	  template: _tszReport2.default,
	  bindings: {
	    companyId: '<',
	    reportId: '<'
	  },
	  controller: controller
	};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszReport = __webpack_require__(198);
	
	var _tszReport2 = _interopRequireDefault(_tszReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszReportModule = _angular2.default.module('tsz.components.tszReport', []).component('tszReport', _tszReport2.default);
	
	exports.default = tszReportModule;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszScrollTop = __webpack_require__(146);
	
	var _tszScrollTop2 = _interopRequireDefault(_tszScrollTop);
	
	__webpack_require__(122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($window) {
	
	  'ngInject';
	
	  this.atTop = function () {
	    return $window.pageYOffset < 50;
	  };
	
	  this.atTop1 = function () {
	    var t = $window.pageYOffset < 50;
	    console.log('At top: ' + t + '.  offset: ' + $window.pageYOffset);
	    return t;
	  };
	}
	
	function link($window, element) {
	  var _this = this;
	
	  _angular2.default.element($window).bind('scroll', function () {
	
	    console.log('pageyOffset: ' + element.pageYOffset);
	
	    if (element.pageYOffset > 0) {
	      _this.scrollClass = true;
	      _this.atTop = false;
	    }
	    _this.$apply();
	  });
	}
	
	exports.default = {
	  template: _tszScrollTop2.default,
	  link: link,
	  controller: controller
	};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszScrollTop = __webpack_require__(200);
	
	var _tszScrollTop2 = _interopRequireDefault(_tszScrollTop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszScrollTopModule = _angular2.default.module('tsz.components.tszScrollTop', []).component('tszScrollTop', _tszScrollTop2.default);
	
	exports.default = tszScrollTopModule;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$rootScope", "$tszToast", "CompanyService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tszTeam = __webpack_require__(147);
	
	var _tszTeam2 = _interopRequireDefault(_tszTeam);
	
	__webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($rootScope, $tszToast, CompanyService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.team = [];
	
	  /* eslint-disable global-require, import/no-dynamic-require */
	  this.getAvatar = function (i) {
	    return __webpack_require__(30)("./avatar-" + (i % 10 + 1) + '.png');
	  };
	
	  this.getRandomAvatar = function () {
	    var n = 1 + Math.floor(9 * Math.random());
	    console.log(n);
	    return __webpack_require__(30)("./avatar-" + n + '.png');
	  };
	  /* eslint-enable global-require import/no-dynamic-require */
	
	  this.loadCompanyUsers = function (id) {
	    CompanyService.users(id).then(function (response) {
	      _this.team = response;
	    }).catch(function (err) {
	      console.log(err);
	    });
	  };
	
	  $rootScope.$on('reloadCompanyUsers', function (event, companyId) {
	    console.log('reloadCompanyUsers event received');
	    _this.loadCompanyUsers(companyId);
	  });
	
	  this.resendInvite = function (userEmail) {
	    var invitation = {
	      email: userEmail,
	      companyId: _this.companyId
	    };
	    CompanyService.invite(_this.companyId, invitation).then(function () {
	      $tszToast.showSuccess('Se enviado una invitaci\xF3n al correo electr\xF3nico ' + userEmail);
	    }).catch(function () {
	      $tszToast.showError('No se ha podido enviar la invitaci\xF3n a ' + userEmail);
	    });
	  };
	
	  this.loadCompanyUsers(this.companyId);
	}
	
	exports.default = {
	  template: _tszTeam2.default,
	  bindings: {
	    companyId: '<',
	    email: '<'
	  },
	  controller: controller
	};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszTeam = __webpack_require__(202);
	
	var _tszTeam2 = _interopRequireDefault(_tszTeam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszTeamModule = _angular2.default.module('tsz.components.tszTeam', []).component('tszTeam', _tszTeam2.default);
	
	exports.default = tszTeamModule;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszToast = __webpack_require__(205);
	
	var _tszToast2 = _interopRequireDefault(_tszToast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszToastModule = _angular2.default.module('tsz.components.tszToast', []).service('$tszToast', _tszToast2.default);
	
	exports.default = tszToastModule;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	tszToastService.$inject = ["$mdToast", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _tszToast = __webpack_require__(148);
	
	var _tszToast2 = _interopRequireDefault(_tszToast);
	
	__webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Wrapper of $mdToast
	 * @param message - the toast text
	 * @param object - the rest of toast options
	 */
	function tszToastService($mdToast, $translate) {
	
	  'ngInject';
	
	  var getHideDelay = function getHideDelay(str) {
	    var avgWordsPerMinute = 250; // words average read per minute
	    var defaultDelay = 3000; // ms
	    var wordsCount = str.split(' ').length;
	
	    var averageTime = wordsCount * 60000 / avgWordsPerMinute;
	    return averageTime > defaultDelay ? averageTime : defaultDelay;
	  };
	
	  function defaultController() {
	    this.onButtonClick = function () {
	      return $mdToast.hide();
	    };
	  }
	
	  function show(textContent) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    var defaults = {
	      textContent: textContent,
	      hideDelay: getHideDelay(textContent),
	      template: _tszToast2.default,
	      controller: defaultController,
	      position: 'top right'
	    };
	    var toastPreset = _extends({}, defaults, options);
	
	    return $mdToast.show($mdToast.simple(toastPreset));
	  }
	
	  return {
	
	    show: show,
	
	    // Shows a black toast with a generic message
	    showInfo: function showInfo(message, params) {
	      return show(message, params);
	    },
	
	
	    // Shows a green toast with a success message
	    showSuccess: function showSuccess(message, params) {
	      return show(message, _extends({ success: true }, params));
	    },
	
	
	    // Shows a red toast with an error message
	    showError: function showError(message, params) {
	      return show(message, _extends({ error: true }, params));
	    },
	    showErrorI18n: function showErrorI18n(message, defaultMsg, params) {
	      $translate('ERROR.' + message).then(function (errorMsg) {
	        return show(errorMsg, _extends({ error: true }, params));
	      }, function () {
	        return show(defaultMsg, _extends({ error: true }, params));
	      });
	    },
	
	
	    // Shows a yellow toast with a warning message
	    showWarning: function showWarning(message, params) {
	      return show(message, _extends({ warning: true }, params));
	    },
	
	
	    // Hides the toast
	    hide: function hide() {
	      return $mdToast.hide();
	    }
	  };
	}
	
	exports.default = tszToastService;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	controller.$inject = ["$tszToast", "AuthService", "UserService", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tszUserSettings = __webpack_require__(150);
	
	var _tszUserSettings2 = _interopRequireDefault(_tszUserSettings);
	
	__webpack_require__(125);
	
	var _changePassword = __webpack_require__(149);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function controller($tszToast, AuthService, UserService, $mdDialog) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.user = AuthService.getAuthenticatedUser();
	
	  this.save = function (form) {
	    if (form.$valid) {
	
	      var user = {
	        id: _this.user.id,
	        name: _this.user.name,
	        phone: _this.user.phone,
	        email: _this.user.email
	      };
	
	      UserService.update(user).then(function (userData) {
	        AuthService.setCredentials(userData.data);
	        $tszToast.showSuccess('Tu perfil ha sido actualizado');
	      }).catch(function () {
	        $tszToast.showError('Error al guardar tu perfil');
	      });
	    }
	  };
	
	  this.showChangePasswordDialog = function (ev) {
	
	    $mdDialog.show({
	      controller: ["$scope", function controller($scope) {
	
	        $scope.data = {};
	
	        $scope.changePassword = function (form) {
	
	          if (form.$valid) {
	            _this.loading = true;
	          }
	
	          AuthService.updatePassword($scope.data.currentPassword, $scope.data.newPassword).then(function () {
	            $tszToast.showSuccess('Contraseña actualizada');
	            $mdDialog.hide();
	          }).catch(function (err) {
	            if (err.data && err.data.code) {
	              $tszToast.showErrorI18n(err.data.code, 'Error al intentar actualizar la contaseña');
	            } else {
	              $tszToast.showError('Error al intentar actualizar la contaseña');
	            }
	          }).finally(function () {
	            _this.loading = false;
	          });
	        };
	
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: _changePassword2.default,
	      targetEvent: ev,
	      clickOutsideToClose: false,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	}
	
	exports.default = {
	  template: _tszUserSettings2.default,
	  controller: controller
	};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tszUserSettings = __webpack_require__(206);
	
	var _tszUserSettings2 = _interopRequireDefault(_tszUserSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tszUserSettingsModule = _angular2.default.module('tsz.components.tszUserSettings', []).component('tszUserSettings', _tszUserSettings2.default);
	
	exports.default = tszUserSettingsModule;

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BASE_API = '/api';
	
	var AUTH = {
	  LOGIN: BASE_API + '/login',
	  LOGOUT: BASE_API + '/logout',
	  SIGNUP: BASE_API + '/user/register',
	  VERIFY_ACCOUNT: BASE_API + '/user/validate',
	  FORGOT_PASSWORD: BASE_API + '/user/recover_password',
	  CHANGE_PASSWORD: BASE_API + '/user/change_password',
	  UPDATE_PASSWORD: BASE_API + '/user/update_password' // user settings
	};
	
	var PING = BASE_API + '/health/ping';
	
	// USERS
	var USER = BASE_API + '/user';
	
	// REPORTS
	var REPORTS = BASE_API + '/reports/:report_id';
	
	var REPORT = {
	  CALCULATE: BASE_API + '/reports/calculate',
	  DOWNLOAD_CSV: BASE_API + '/reports/csv/:csv',
	  VERIFY_CSV: BASE_API + '/reports/csv/:csv/verify',
	  GENERATE: BASE_API + '/reports/:report_id/pdf',
	  DUPLICATE: BASE_API + '/reports/:report_id/duplicate',
	  PRICE: BASE_API + '/reports/price'
	};
	
	var CONFIG = BASE_API + '/config/:id';
	
	var BASE_ADMIN = BASE_API + '/admin';
	
	var ADMIN = {
	  SUBSCRIPTIONS: BASE_ADMIN + '/companies/:companyId/subscriptions/:subscriptionId'
	};
	
	var PLAN = BASE_API + '/plans/:id';
	
	var COMPANIES = BASE_API + '/companies/:id';
	
	var COMPANY = {
	  USERS: BASE_API + '/companies/:id/users',
	  REPORT: BASE_API + '/companies/:companyId/reports/:reportId',
	  REPORTS: BASE_API + '/companies/:id/reports',
	  CALCULATED_REPORTS: BASE_API + '/companies/:id/reports/calculated',
	  SUBSCRIPTIONS: BASE_API + '/companies/:companyId/subscriptions'
	};
	
	var BASE_CATALOG = BASE_API + '/catalog';
	
	var CATALOG = {
	  REPORT_SCHEMA: BASE_CATALOG + '/report_schema_{version}.json'
	};
	
	var CONTACT = BASE_API + '/contact';
	
	var API = {
	  ADMIN: ADMIN,
	  AUTH: AUTH,
	  BASE_CATALOG: BASE_CATALOG,
	  CATALOG: CATALOG,
	  COMPANIES: COMPANIES,
	  COMPANY: COMPANY,
	  CONFIG: CONFIG,
	  CONTACT: CONTACT,
	  PING: PING,
	  PLAN: PLAN,
	  REPORT: REPORT,
	  REPORTS: REPORTS,
	  USER: USER
	};
	
	exports.API = API; // eslint-disable-line import/prefer-default-export

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONSTANTS = {
	
	  BUILDING_USAGE: {
	    bu1: {
	      name: 'Comercial',
	      value: 1.2
	    },
	    bu2: {
	      name: 'Residencial Vivienda',
	      value: 0.75
	    },
	    bu3: {
	      name: 'Hospitalario',
	      value: 1.1
	    },
	    bu4: {
	      name: 'Residencial Público',
	      value: 1.15
	    },
	    bu5: {
	      name: 'Administrativo',
	      value: 1
	    },
	    bu6: {
	      name: 'Docente',
	      value: 1
	    },
	    bu7: {
	      name: 'Pública Concurrencia',
	      value: 1.25
	    },
	    bu8: {
	      name: 'Garaje Aparcamiento',
	      value: 1
	    }
	  },
	
	  PROJECT_TYPE: {
	    pt1: {
	      name: 'Prestacional',
	      value: 0.40,
	      min_price: 300
	    },
	    pt2: {
	      name: 'Prescriptivo',
	      value: 0.15,
	      min_price: 150
	    }
	  },
	
	  PROPERTY: {
	    PROMOTIONAL_MSG: 'PROMOTIONAL_MSG'
	  },
	
	  PAGE_SIZE: 'paginationPageSize',
	
	  COOKIES_ACCEPTED: 'cookies_accepted',
	
	  VERSION: {
	    V1: {
	      name: 'V1',
	      title: 'MEREDICTE© versión 1.0',
	      nParams: 76
	    },
	    V2: {
	      name: 'V2',
	      title: 'MEREDICTE© versión 2.0',
	      nParams: 82 // 79 - 1 (ca7) + 4 (av, af, ah, H)
	    }
	  },
	
	  VERSIONS: ['V1', 'V2']
	
	};
	
	exports.CONSTANTS = CONSTANTS; // eslint-disable-line import/prefer-default-export

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PLANS = {
	  PROFESSIONAL: 'PROFESSIONAL',
	  ENTERPRISE: 'ENTERPRISE',
	  EXPERTO: 'EXPERTO', // Ayuntamiento
	  VALIDACION: 'VALIDACION'
	};
	
	exports.PLANS = PLANS; // eslint-disable-line import/prefer-default-export

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PROVINCES = ['A Coruña', 'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz', 'Baleares', 'Barcelona', 'Burgos', 'Cáceres', 'Cádiz', 'Cantabria', 'Castellón', 'Ciudad Real', 'Córdoba', 'Cuenca', 'Girona', 'Granada', 'Guadalajara', 'Gipuzkoa', 'Huelva', 'Huesca', 'Jaén', 'La Rioja', 'Las Palmas', 'León', 'Lérida', 'Lugo', 'Madrid', 'Málaga', 'Murcia', 'Navarra', 'Orense', 'Palencia', 'Pontevedra', 'Salamanca', 'Segovia', 'Sevilla', 'Soria', 'Tarragona', 'Santa Cruz de Tenerife', 'Teruel', 'Toledo', 'Valencia', 'Valladolid', 'Vizcaya', 'Zamora', 'Zaragoza'];
	
	exports.PROVINCES = PROVINCES; // eslint-disable-line import/prefer-default-export

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ROLES = {
	  USER: 'ROLE_USER',
	  ADMIN: 'ROLE_ADMIN'
	};
	
	exports.ROLES = ROLES; // eslint-disable-line import/prefer-default-export

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	adminCompanyComponent.$inject = ["$scope", "$state", "$stateParams", "uiGridConstants", "AuthService", "ReportService", "ConfigService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(6);
	
	var _adminCompanyDetail = __webpack_require__(151);
	
	var _adminCompanyDetail2 = _interopRequireDefault(_adminCompanyDetail);
	
	__webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function adminCompanyComponent($scope, $state, $stateParams, uiGridConstants, AuthService, ReportService, ConfigService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.companyId = $stateParams.id;
	  this.companyName = $stateParams.name;
	
	  this.state = $state.current;
	  this.params = $stateParams;
	
	  this.roles = _config.ROLES;
	
	  this.getOpts = function (c) {
	    var opts = [];
	    (0, _lodash.forIn)(c, function (value, key) {
	      opts.push({
	        value: key,
	        label: value.name
	      });
	    });
	    return opts;
	  };
	
	  this.getVersionOpts = function () {
	    return _this.getOpts(_config.CONSTANTS.VERSION);
	  };
	  this.getDesignTypeOpts = function () {
	    return _this.getOpts(_config.CONSTANTS.PROJECT_TYPE);
	  };
	  this.getBuildingUsageOpts = function () {
	    return _this.getOpts(_config.CONSTANTS.BUILDING_USAGE);
	  };
	
	  var correctTotalPaginationTemplate = "<div role=\"contentinfo\" class=\"ui-grid-pager-panel\" ui-grid-pager ng-show=\"grid.options.enablePaginationControls\"><div role=\"navigation\" class=\"ui-grid-pager-container\"><div role=\"menubar\" class=\"ui-grid-pager-control\"><button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-first\" ui-grid-one-bind-title=\"aria.pageToFirst\" ui-grid-one-bind-aria-label=\"aria.pageToFirst\" ng-click=\"pageFirstPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle\"><div class=\"first-bar\"></div></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-previous\" ui-grid-one-bind-title=\"aria.pageBack\" ui-grid-one-bind-aria-label=\"aria.pageBack\" ng-click=\"pagePreviousPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle prev-triangle\"></div></button> <input type=\"number\" ui-grid-one-bind-title=\"aria.pageSelected\" ui-grid-one-bind-aria-label=\"aria.pageSelected\" class=\"ui-grid-pager-control-input\" ng-model=\"grid.options.paginationCurrentPage\" min=\"1\" max=\"{{ paginationApi.getTotalPages() }}\" required> <span class=\"ui-grid-pager-max-pages-number\" ng-show=\"paginationApi.getTotalPages() > 0\"><abbr ui-grid-one-bind-title=\"paginationOf\">/</abbr> {{ paginationApi.getTotalPages() }}</span> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-next\" ui-grid-one-bind-title=\"aria.pageForward\" ui-grid-one-bind-aria-label=\"aria.pageForward\" ng-click=\"pageNextPageClick()\" ng-disabled=\"cantPageForward()\"><div class=\"last-triangle next-triangle\"></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-last\" ui-grid-one-bind-title=\"aria.pageToLast\" ui-grid-one-bind-aria-label=\"aria.pageToLast\" ng-click=\"pageLastPageClick()\" ng-disabled=\"cantPageToLast()\"><div class=\"last-triangle\"><div class=\"last-bar\"></div></div></button></div><div class=\"ui-grid-pager-row-count-picker\" ng-if=\"grid.options.paginationPageSizes.length > 1\"><select ui-grid-one-bind-aria-labelledby-grid=\"'items-per-page-label'\" ng-model=\"grid.options.paginationPageSize\" ng-options=\"o as o for o in grid.options.paginationPageSizes\"></select><span ui-grid-one-bind-id-grid=\"'items-per-page-label'\" class=\"ui-grid-pager-row-count-label\">&nbsp;{{sizesLabel}}</span></div><span ng-if=\"grid.options.paginationPageSizes.length <= 1\" class=\"ui-grid-pager-row-count-label\">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class=\"ui-grid-pager-count-container\"><div class=\"ui-grid-pager-count\"><span ng-show=\"grid.options.totalItems > 0\">{{(((grid.options.paginationCurrentPage-1)*grid.options.paginationPageSize)+1)}} <abbr ui-grid-one-bind-title=\"paginationThrough\">-</abbr> {{(grid.options.paginationCurrentPage*grid.options.paginationPageSize>grid.options.totalItems?grid.options.totalItems:grid.options.paginationCurrentPage*grid.options.paginationPageSize)}} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>";
	
	  this.gridOptions = {
	    language: 'es',
	    onRegisterApi: function onRegisterApi(gridApi) {
	      _this.gridApi = gridApi;
	
	      gridApi.pagination.on.paginationChanged($scope, function (pageNumber, pageSize) {
	        ConfigService.set(_config.CONSTANTS.PAGE_SIZE, pageSize);
	      });
	    },
	    columnDefs: [{ field: 'name', displayName: 'Sector', cellTooltip: true, cellTemplate: '<div class="ui-grid-cell-contents"><a ng-href="report/{{row.entity.id}}" class="report-link">{{row.entity.name}}</a><md-tooltip>{{row.entity.name}}</md-tooltip></div>' }, { field: 'meredicteVersion', displayName: 'Versión', cellFilter: 'version', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getVersionOpts() }, width: 100 }, { field: 'code', displayName: 'Código' }, { field: 'evaluator', displayName: 'Evaluador' }, { field: 'province', displayName: 'Provincia' }, { field: 'postal_code', displayName: 'C.P.' }, { field: 'design_type', displayName: 'Diseño', cellFilter: 'designType', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getDesignTypeOpts() } }, { field: 'building_usage', displayName: 'Uso', cellFilter: 'buildingUsage', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getBuildingUsageOpts() } }, { field: 'createdAt', displayName: 'Creado', type: 'date', cellFilter: 'date:\'yyyy-MM-dd\'', cellClass: 'grid-align-center' }, { field: 'updatedAt', displayName: 'Actualizado', type: 'date', cellFilter: 'date:\'yyyy-MM-dd\'', cellClass: 'grid-align-center' }, { field: 'nrg', displayName: 'NRG', enableFiltering: false, cellFilter: 'number: 2' }, { field: 'actions', displayName: 'Acciones', enableColumnMenu: false, enableFiltering: false, cellClass: 'grid-align-center', cellTemplate: '<div><tsz-report-actions report=row.entity></tsz-report-actions> <!--{{row.entity.id}}--></div>' }],
	    enableFiltering: false,
	    enableHorizontalScrollbar: 0,
	    enableVerticalScrollbar: 0,
	    paginationPageSizes: [5, 10, 25, 50],
	    paginationPageSize: ConfigService.get(_config.CONSTANTS.PAGE_SIZE, 10),
	    paginationTemplate: correctTotalPaginationTemplate
	  };
	
	  this.toggleFiltering = function () {
	    console.log('Toggle filtering');
	    _this.gridOptions.enableFiltering = !_this.gridOptions.enableFiltering;
	    _this.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
	  };
	
	  this.loadReports = function (id) {
	    ReportService.company_reports(id).then(function (result) {
	      _this.gridOptions.data = result;
	    }).catch(function (err) {
	      console.error(err);
	    });
	  };
	
	  this.gotoCreateReport = function () {
	    $state.go('report');
	  };
	
	  $scope.$on('report_deleted', function () {
	    _this.loadReports();
	  });
	
	  //
	  // INIT
	  //
	
	  this.loadReports(this.companyId);
	}
	
	exports.default = {
	  template: _adminCompanyDetail2.default,
	  controller: adminCompanyComponent
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	homeComponent.$inject = ["$scope", "AuthService", "CompanyService", "ReportService", "ConfigService", "uiGridConstants"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _home = __webpack_require__(152);
	
	var _home2 = _interopRequireDefault(_home);
	
	__webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function homeComponent($scope, AuthService, CompanyService, ReportService, ConfigService, uiGridConstants) {
	
	  'ngInject';
	
	  var _this = this;
	
	  var correctTotalPaginationTemplate = "<div role=\"contentinfo\" class=\"ui-grid-pager-panel\" ui-grid-pager ng-show=\"grid.options.enablePaginationControls\"><div role=\"navigation\" class=\"ui-grid-pager-container\"><div role=\"menubar\" class=\"ui-grid-pager-control\"><button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-first\" ui-grid-one-bind-title=\"aria.pageToFirst\" ui-grid-one-bind-aria-label=\"aria.pageToFirst\" ng-click=\"pageFirstPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle\"><div class=\"first-bar\"></div></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-previous\" ui-grid-one-bind-title=\"aria.pageBack\" ui-grid-one-bind-aria-label=\"aria.pageBack\" ng-click=\"pagePreviousPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle prev-triangle\"></div></button> <input type=\"number\" ui-grid-one-bind-title=\"aria.pageSelected\" ui-grid-one-bind-aria-label=\"aria.pageSelected\" class=\"ui-grid-pager-control-input\" ng-model=\"grid.options.paginationCurrentPage\" min=\"1\" max=\"{{ paginationApi.getTotalPages() }}\" required> <span class=\"ui-grid-pager-max-pages-number\" ng-show=\"paginationApi.getTotalPages() > 0\"><abbr ui-grid-one-bind-title=\"paginationOf\">/</abbr> {{ paginationApi.getTotalPages() }}</span> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-next\" ui-grid-one-bind-title=\"aria.pageForward\" ui-grid-one-bind-aria-label=\"aria.pageForward\" ng-click=\"pageNextPageClick()\" ng-disabled=\"cantPageForward()\"><div class=\"last-triangle next-triangle\"></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-last\" ui-grid-one-bind-title=\"aria.pageToLast\" ui-grid-one-bind-aria-label=\"aria.pageToLast\" ng-click=\"pageLastPageClick()\" ng-disabled=\"cantPageToLast()\"><div class=\"last-triangle\"><div class=\"last-bar\"></div></div></button></div><div class=\"ui-grid-pager-row-count-picker\" ng-if=\"grid.options.paginationPageSizes.length > 1\"><select ui-grid-one-bind-aria-labelledby-grid=\"'items-per-page-label'\" ng-model=\"grid.options.paginationPageSize\" ng-options=\"o as o for o in grid.options.paginationPageSizes\"></select><span ui-grid-one-bind-id-grid=\"'items-per-page-label'\" class=\"ui-grid-pager-row-count-label\">&nbsp;{{sizesLabel}}</span></div><span ng-if=\"grid.options.paginationPageSizes.length <= 1\" class=\"ui-grid-pager-row-count-label\">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class=\"ui-grid-pager-count-container\"><div class=\"ui-grid-pager-count\"><span ng-show=\"grid.options.totalItems > 0\">{{(((grid.options.paginationCurrentPage-1)*grid.options.paginationPageSize)+1)}} <abbr ui-grid-one-bind-title=\"paginationThrough\">-</abbr> {{(grid.options.paginationCurrentPage*grid.options.paginationPageSize>grid.options.totalItems?grid.options.totalItems:grid.options.paginationCurrentPage*grid.options.paginationPageSize)}} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>";
	
	  this.gridOptions = {
	    language: 'es',
	    onRegisterApi: function onRegisterApi(gridApi) {
	      _this.gridApi = gridApi;
	
	      gridApi.pagination.on.paginationChanged($scope, function (pageNumber, pageSize) {
	        ConfigService.set(_config.CONSTANTS.PAGE_SIZE, pageSize);
	      });
	    },
	    columnDefs: [
	    // { field: 'id', displayName: 'Id' },
	    { field: 'name', displayName: 'Nombre', cellTooltip: true, cellTemplate: '<div class="ui-grid-cell-contents"><a ng-href="admin/companies/{{row.entity.id}}" class="report-link">{{row.entity.name | na}}</a><md-tooltip>{{row.entity.name}}</md-tooltip></div>' }, { field: 'cif', displayName: 'CIF', width: 100 }, { field: 'plan', displayName: 'Licencia', width: 110 }, // , cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.plan}} ({{row.entity.monthly | planType}})</div>' },
	    { field: 'monthly', displayName: 'Modalidad', cellFilter: 'planType', width: 110 }, { field: 'numProjects', displayName: '# Proyectos', headerCellTemplate: '<div class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"><span class="ui-grid-header-cell-label ng-binding" title="# Proyectos registrados">Proy</span></div>', width: 50 }, { field: 'numReports', displayName: '# Informes disponibles', headerCellTemplate: '<div class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"><span class="ui-grid-header-cell-label ng-binding" title="# Informes generados">Inf</span></div>', width: 50 }, { field: 'monthlyReports', displayName: '# Informes mensuales', headerCellTemplate: '<div class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"><span class="ui-grid-header-cell-label ng-binding" title="# Informes mensuales disponibles">Disp</span></div>', width: 50 }, { field: 'createdAt', displayName: 'Creada', type: 'date', cellFilter: 'date:\'yyyy-MM-dd\'', cellClass: 'grid-align-center', sort: { direction: uiGridConstants.DESC, priority: 1 }, width: 110 }, { field: 'emails', displayName: 'Usuarios', cellTooltip: true, cellFilter: 'emailsFilter' }],
	    enableFiltering: false,
	    enableHorizontalScrollbar: 0,
	    enableVerticalScrollbar: 0,
	    paginationPageSizes: [5, 10, 25, 50],
	    paginationPageSize: ConfigService.get(_config.CONSTANTS.PAGE_SIZE, 10),
	    paginationTemplate: correctTotalPaginationTemplate,
	    virtualizationThreshold: 50
	  };
	
	  this.toggleFiltering = function () {
	    console.log('Toggle filtering');
	    _this.gridOptions.enableFiltering = !_this.gridOptions.enableFiltering;
	    _this.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
	  };
	
	  this.loadCompanies = function () {
	    CompanyService.list().then(function (result) {
	      _this.gridOptions.data = result;
	    }).catch(function (err) {
	      console.log(err);
	    });
	  };
	
	  $scope.$on('company_deleted', function () {
	    _this.loadCompanies();
	  });
	
	  //
	  // INIT
	  //
	
	  this.loadCompanies();
	}
	
	exports.default = {
	  template: _home2.default,
	  controller: homeComponent
	};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(153);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(288);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  restrict: 'E'
	};
	
	exports.default = appComponent;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	footerComponent.$inject = ["$mdDialog", "$localStorage", "$analytics"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _config = __webpack_require__(2);
	
	var _footer = __webpack_require__(154);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function footerComponent($mdDialog, $localStorage, $analytics) {
	
	  'ngInject';
	
	  var _this = this;
	
	  $analytics.setOptOut(false);
	
	  this.showCookiesDialog = function (ev) {
	    _this.showDialog(ev, 'cookies');
	  };
	
	  this.showLegalNoticeDialog = function (ev) {
	    _this.showDialog(ev, 'legal_notice');
	  };
	
	  this.showPrivacyPolicyDialog = function (ev) {
	    _this.showDialog(ev, 'privacy_policy');
	  };
	
	  this.showUsageTermsDialog = function (ev) {
	    _this.showDialog(ev, 'usage_terms');
	  };
	
	  this.showDialog = function (ev, modal) {
	    var clickOutsideToClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    var escapeToClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	    $mdDialog.show({
	      controller: ["$scope", function controller($scope) {
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	        $scope.accept = function () {
	          $localStorage[_config.CONSTANTS.COOKIES_ACCEPTED] = true;
	          $analytics.setOptOut(false);
	          $mdDialog.hide();
	        };
	        $scope.showCookieDetail = function () {
	          console.log('clicked');
	          $scope.isCookieDetailVisible = true;
	        };
	      }],
	      controllerAs: 'ctrl',
	      templateUrl: '/static/modals/' + modal + '.html',
	      parent: _angular2.default.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose: clickOutsideToClose,
	      escapeToClose: escapeToClose,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	
	  this.checkCookies = function (ev) {
	
	    if (!$localStorage[_config.CONSTANTS.COOKIES_ACCEPTED]) {
	      _this.showDialog(ev, 'accept_cookies', false, false);
	    }
	
	    $analytics.setOptOut(!$localStorage[_config.CONSTANTS.COOKIES_ACCEPTED]);
	  };
	
	  this.init = function () {
	    _this.checkCookies();
	  };
	
	  this.init();
	}
	
	exports.default = {
	  template: _footer2.default,
	  controller: footerComponent
	};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	forgotPasswordComponent.$inject = ["$tszToast", "$translate", "AuthService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _forgotPassword = __webpack_require__(155);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	__webpack_require__(290);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function forgotPasswordComponent($tszToast, $translate, AuthService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.loading = false;
	
	  this.forgotPassword = function (form) {
	
	    if (form.$valid) {
	      _this.loading = true;
	    }
	
	    AuthService.forgotPassword(_this.data.email).then(function () {
	      $tszToast.showSuccess('Se ha enviado un email con instrucciones para cambiar su contraseña');
	    }).catch(function (err) {
	      if (err.data && err.data.code) {
	        $translate('ERROR.' + err.data.code).then(function (errorMsg) {
	          $tszToast.showError(errorMsg);
	          _this.error = errorMsg;
	        });
	      }
	    }).finally(function () {
	      // regardless of the response, change the loading state
	      _this.loading = false;
	    });
	  };
	}
	
	exports.default = {
	  template: _forgotPassword2.default,
	  controller: forgotPasswordComponent
	};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	headerComponent.$inject = ["$scope", "$rootScope", "$localStorage", "$mdMedia", "$state", "AuthService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(6);
	
	var _header = __webpack_require__(156);
	
	var _header2 = _interopRequireDefault(_header);
	
	__webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function headerComponent($scope, $rootScope, $localStorage, $mdMedia, $state, AuthService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.user = {};
	
	  this.currentNavItem = 'login';
	
	  this.authenticated = AuthService.isAuthenticated();
	
	  this.storage = $localStorage;
	
	  this.pendingFields = 0;
	
	  $scope.$mdMedia = $mdMedia;
	
	  this.showCompanyLogo = function () {
	    return _this.user && _this.user.logo && $mdMedia('gt-xs');
	  };
	
	  this.hasRole = function (role) {
	    var result = false;
	    var user = AuthService.getAuthenticatedUser();
	    if (user && user.roles) {
	      result = (0, _lodash.includes)(user.roles, role);
	    }
	    return result;
	  };
	
	  this.hasUserRole = function () {
	    return _this.hasRole(_config.ROLES.USER);
	  };
	
	  this.hasAdminRole = function () {
	    return _this.hasRole(_config.ROLES.ADMIN);
	  };
	
	  this.initRoles = function () {
	    _this.isUser = _this.hasUserRole();
	    _this.isAdmin = _this.hasAdminRole();
	  };
	
	  this.getUserMenu = function () {
	    if (_this.user) {
	      if (_this.user.name) {
	        return _this.user.name;
	      }
	      return _this.user.email;
	    }
	    return '';
	  };
	
	  this.loadUser = function () {
	    if (AuthService.isAuthenticated()) {
	      _this.user = AuthService.getAuthenticatedUser();
	      _this.email = _this.user.email;
	      _this.logo = _this.user.logo;
	      console.log(JSON.stringify(_this.user));
	    }
	  };
	
	  this.refreshPendingFields = function () {
	    var user = AuthService.getAuthenticatedUser();
	    _this.pendingFields = 0;
	    if (user) {
	      if (!user.cif) {
	        _this.pendingFields += 1;
	      }
	      if (!user.companyName) {
	        _this.pendingFields += 1;
	      }
	    }
	  };
	
	  $scope.$watch('$localStorage.user', function () {
	    console.log('USER UPDATED. RELOADING ROLES...');
	    _this.initRoles();
	    _this.refreshPendingFields();
	    _this.loadUser();
	  });
	
	  $rootScope.$on('authenticated', function (event, data) {
	    console.log('Authenticated event received');
	    _this.authenticated = data;
	    _this.initRoles();
	    _this.refreshPendingFields();
	    _this.loadUser();
	  });
	
	  this.openMenu = function ($mdOpenMenu, ev) {
	    $mdOpenMenu(ev);
	  };
	
	  this.logout = function () {
	    console.log('Logout!');
	
	    AuthService.logout().then(function () {
	      // $rootScope.$broadcast('authenticated', false);
	      // AuthService.clearCredentials();
	      $state.go('login');
	    }).catch(function (err) {
	      // logout error
	      console.error('Logout error: ' + err);
	    }).finally(function () {
	      // regardless of the response, change the loading state
	      _this.loading = false;
	    });
	  };
	
	  this.goto = function (page) {
	    _this.currentNavItem = page;
	  };
	
	  function getCurrentLinkFromRoute(state) {
	    console.log('State changed to ' + state.name);
	    return state.name;
	  }
	
	  $rootScope.$on('$stateChangeSuccess', function (event, next) {
	    _this.currentNavItem = getCurrentLinkFromRoute(next);
	  });
	
	  if (AuthService.isAuthenticated()) {
	    this.initRoles();
	    this.loadUser();
	  }
	}
	
	exports.default = {
	  template: _header2.default,
	  controller: headerComponent
	};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	homeComponent.$inject = ["$scope", "$state", "$filter", "$mdDialog", "$tszToast", "uiGridConstants", "AuthService", "ReportService", "ConfigService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(6);
	
	var _home = __webpack_require__(157);
	
	var _home2 = _interopRequireDefault(_home);
	
	__webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function homeComponent($scope, $state, $filter, $mdDialog, $tszToast, uiGridConstants, AuthService, ReportService, ConfigService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.roles = _config.ROLES;
	
	  this.canSeeCuantitativeResults = AuthService.canSeeCuantitativeResults();
	
	  this.getOpts = function (c) {
	    var opts = [];
	    (0, _lodash.forIn)(c, function (value, key) {
	      opts.push({
	        value: key,
	        label: value.name
	      });
	    });
	    return opts;
	  };
	
	  this.getVersionOpts = function () {
	    return _this.getOpts(_config.CONSTANTS.VERSION);
	  };
	  this.getDesignTypeOpts = function () {
	    return _this.getOpts(_config.CONSTANTS.PROJECT_TYPE);
	  };
	  this.getBuildingUsageOpts = function () {
	    return _this.getOpts(_config.CONSTANTS.BUILDING_USAGE);
	  };
	
	  var correctTotalPaginationTemplate = "<div role=\"contentinfo\" class=\"ui-grid-pager-panel\" ui-grid-pager ng-show=\"grid.options.enablePaginationControls\"><div role=\"navigation\" class=\"ui-grid-pager-container\"><div role=\"menubar\" class=\"ui-grid-pager-control\"><button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-first\" ui-grid-one-bind-title=\"aria.pageToFirst\" ui-grid-one-bind-aria-label=\"aria.pageToFirst\" ng-click=\"pageFirstPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle\"><div class=\"first-bar\"></div></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-previous\" ui-grid-one-bind-title=\"aria.pageBack\" ui-grid-one-bind-aria-label=\"aria.pageBack\" ng-click=\"pagePreviousPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle prev-triangle\"></div></button> <input type=\"number\" ui-grid-one-bind-title=\"aria.pageSelected\" ui-grid-one-bind-aria-label=\"aria.pageSelected\" class=\"ui-grid-pager-control-input\" ng-model=\"grid.options.paginationCurrentPage\" min=\"1\" max=\"{{ paginationApi.getTotalPages() }}\" required> <span class=\"ui-grid-pager-max-pages-number\" ng-show=\"paginationApi.getTotalPages() > 0\"><abbr ui-grid-one-bind-title=\"paginationOf\">/</abbr> {{ paginationApi.getTotalPages() }}</span> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-next\" ui-grid-one-bind-title=\"aria.pageForward\" ui-grid-one-bind-aria-label=\"aria.pageForward\" ng-click=\"pageNextPageClick()\" ng-disabled=\"cantPageForward()\"><div class=\"last-triangle next-triangle\"></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-last\" ui-grid-one-bind-title=\"aria.pageToLast\" ui-grid-one-bind-aria-label=\"aria.pageToLast\" ng-click=\"pageLastPageClick()\" ng-disabled=\"cantPageToLast()\"><div class=\"last-triangle\"><div class=\"last-bar\"></div></div></button></div><div class=\"ui-grid-pager-row-count-picker\" ng-if=\"grid.options.paginationPageSizes.length > 1\"><select ui-grid-one-bind-aria-labelledby-grid=\"'items-per-page-label'\" ng-model=\"grid.options.paginationPageSize\" ng-options=\"o as o for o in grid.options.paginationPageSizes\"></select><span ui-grid-one-bind-id-grid=\"'items-per-page-label'\" class=\"ui-grid-pager-row-count-label\">&nbsp;{{sizesLabel}}</span></div><span ng-if=\"grid.options.paginationPageSizes.length <= 1\" class=\"ui-grid-pager-row-count-label\">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class=\"ui-grid-pager-count-container\"><div class=\"ui-grid-pager-count\"><span ng-show=\"grid.options.totalItems > 0\">{{(((grid.options.paginationCurrentPage-1)*grid.options.paginationPageSize)+1)}} <abbr ui-grid-one-bind-title=\"paginationThrough\">-</abbr> {{(grid.options.paginationCurrentPage*grid.options.paginationPageSize>grid.options.totalItems?grid.options.totalItems:grid.options.paginationCurrentPage*grid.options.paginationPageSize)}} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>";
	
	  this.gridOptions = {
	    language: 'es',
	    // i18n: 'es',
	    onRegisterApi: function onRegisterApi(gridApi) {
	      _this.gridApi = gridApi;
	
	      _this.gridApi.grid.registerRowsProcessor(_this.commentsFilter, 200);
	
	      gridApi.pagination.on.paginationChanged($scope, function (pageNumber, pageSize) {
	        ConfigService.set(_config.CONSTANTS.PAGE_SIZE, pageSize);
	      });
	    },
	    enableSorting: true,
	    enableColumnMenus: false,
	    columnDefs: [{ field: 'actions', displayName: '', enableColumnMenu: false, enableFiltering: false, enableSorting: false, cellClass: 'grid-align-center', cellTemplate: '<div><tsz-report-menu-actions report=row.entity></tsz-report-menu-actions> <!--{{row.entity.id}}--></div>', width: 30 }, { field: 'name', displayName: 'Sector', cellTooltip: true, cellTemplate: '<div class="ui-grid-cell-contents"><a ng-href="report/{{row.entity.id}}" class="report-link">{{row.entity.name}} <md-icon ng-show="row.entity.downloadable" class="material-icons" style="margin-left: 5px;">picture_as_pdf</md-icon></a><md-tooltip>{{row.entity.name}}</md-tooltip></div>' }, { field: 'meredicteVersion', displayName: 'Versión', cellFilter: 'version', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getVersionOpts() }, width: 100 }, { field: 'design_type', displayName: 'Diseño', cellFilter: 'designType', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getDesignTypeOpts() }, width: 130 }, { field: 'building_usage', displayName: 'Uso', cellFilter: 'buildingUsage', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getBuildingUsageOpts() }, width: 170 }, { field: 'code', displayName: 'Código', width: 160 }, { field: 'province', displayName: 'Provincia', width: 120 }, { field: 'createdAt', displayName: 'Creado', type: 'date', cellFilter: 'date:\'yyyy-MM-dd\'', cellClass: 'grid-align-center', width: 100 }, { field: 'updatedAt', displayName: 'Actualizado', type: 'date', cellFilter: 'date:\'yyyy-MM-dd\'', cellClass: 'grid-align-center', width: 125, sort: { direction: uiGridConstants.DESC } }, { field: 'nrg', displayName: 'NRG', visible: this.canSeeCuantitativeResults, enableFiltering: false, cellFilter: 'number:2', width: 72, cellClass: 'grid-align-right' }],
	    enableFiltering: false,
	    enableHorizontalScrollbar: 0,
	    enableVerticalScrollbar: 0,
	    paginationPageSizes: [5, 10, 25, 50],
	    paginationPageSize: ConfigService.get(_config.CONSTANTS.PAGE_SIZE, 10),
	    paginationTemplate: correctTotalPaginationTemplate
	  };
	
	  this.setMinRowsToShow = function () {
	    _this.gridApi.grid.options.minRowsToShow = Math.min(_this.gridOptions.data.length, $scope.maxRowToShow);
	    _this.gridApi.grid.options.virtualizationThreshold = _this.gridApi.grid.options.minRowsToShow;
	  };
	
	  this.getVisibleRows = function () {
	    return Math.min(_this.gridOptions.data.length, _this.gridApi.grid.options.paginationPageSizes[0]);
	  };
	
	  this.toggleFiltering = function () {
	    console.log('Toggle filtering');
	    _this.gridOptions.enableFiltering = !_this.gridOptions.enableFiltering;
	    _this.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
	  };
	
	  this.onCommentsFilterChange = function (filterValue) {
	    _this.filterValue = filterValue;
	    _this.gridApi.grid.refresh();
	  };
	
	  this.commentsFilter = function (renderableRows) {
	    if (_this.filterValue) {
	      var matcher = new RegExp(_this.removeAccents(_this.filterValue), 'i');
	      renderableRows.forEach(function (row) {
	        var match = false;
	        ['name', 'comments'].forEach(function (field) {
	          if (row.entity[field] && _this.removeAccents(row.entity[field]).match(matcher)) {
	            match = true;
	          }
	        });
	        if (!match) {
	          row.visible = false;
	        }
	      });
	    }
	    return renderableRows;
	  };
	
	  this.removeAccents = function (s) {
	    return s !== null ? s.toLowerCase().replace(new RegExp(/[àáâãäå]/g), 'a').replace(new RegExp(/[èéêë]/g), 'e').replace(new RegExp(/[ìíîï]/g), 'i').replace(new RegExp(/ñ/g), 'n').replace(new RegExp(/[òóôõö]/g), 'o').replace(new RegExp(/[ùúûü]/g), 'u') : s;
	  };
	
	  this.loadReports = function () {
	    ReportService.list().then(function (result) {
	      _this.gridOptions.data = result;
	      _this.gridheight = (result.lenght + 1) * 30;
	    }).catch(function (err) {
	      console.log(err);
	    });
	  };
	
	  this.gotoCreateReport = function (ev) {
	    var confirm = $mdDialog.confirm().title('Nuevo proyecto').textContent('Seleccione la versión de MEREDICTE© que desea utilizar (la versión 2.0 es la actualización según el Real Decreto 732/2019 que se adapta a la versión actualmente vigente del DBSI).').ariaLabel('Selecciona la versión de MEREDICTE© a utilizar.').targetEvent(ev).ok('MEREDICTE© 2.0').cancel('MEREDICTE© 1.0');
	
	    $mdDialog.show(confirm).then(function () {
	      $state.go('report', { v: 'V2' });
	    }, function () {
	      $state.go('report', { v: 'V1' });
	    });
	  };
	
	  this.verifyCsv = function (csv) {
	    ReportService.verify_csv(csv).then(function (response) {
	
	      var creationDate = $filter('date')(response.creationDate, 'yyyy-MM-dd');
	
	      $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title(response.name).textContent('Creado el: ' + creationDate).ariaLabel('Alert Dialog Demo').ok('Ok!'));
	    }).catch(function () {
	      $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('CSV erróneo').textContent('No se ha encontrado ningún proyecto con el CSV especificado').ok('Ok!'));
	    });
	  };
	
	  $scope.$on('report_deleted', function () {
	    _this.loadReports();
	  });
	
	  $scope.$on('report_duplicated', function (event, data) {
	    $tszToast.showSuccess('Proyecto "' + data.name + '" generado correctamente');
	    _this.loadReports();
	  });
	
	  this.loadReports();
	}
	
	exports.default = {
	  template: _home2.default,
	  controller: homeComponent
	};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	landingComponent.$inject = ["$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(7);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(6);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(285);
	
	__webpack_require__(107);
	
	__webpack_require__(106);
	
	var _landing = __webpack_require__(158);
	
	var _landing2 = _interopRequireDefault(_landing);
	
	__webpack_require__(293);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function landingComponent($mdDialog) {
	
	  'ngInject';
	
	  var _this = this;
	
	  (0, _jquery2.default)(document).ready(function () {
	
	    _jquery2.default.get('/carrousel/config.json', function () {}).done(function (data) {
	      (0, _lodash.forEach)(data, function (img) {
	        (0, _jquery2.default)('.js-slick').append('<div><img src="' + img + '"></div>');
	      });
	    }).fail(function () {
	      var carrouselImages = ['/static/img/carrousel/carrousel1.jpg', '/static/img/carrousel/carrousel2.jpg', '/static/img/carrousel/carrousel3.jpg', '/static/img/carrousel/carrousel4.jpg', '/static/img/carrousel/carrousel5.jpg'];
	
	      (0, _lodash.forEach)(carrouselImages, function (img) {
	        (0, _jquery2.default)('.js-slick').append('<div><img src="' + img + '"></div>');
	      });
	    }).always(function () {
	      (0, _jquery2.default)('.js-slick').slick({
	        autoplay: true,
	        autoplaySpeed: 5000,
	        infinite: true,
	        dots: false,
	        draggable: false,
	        arrows: true,
	        speed: 1000,
	        mobileFirst: true
	      });
	
	      (0, _jquery2.default)('.js-slick').on('beforeChange', function (event, slick) {
	        (0, _jquery2.default)(slick.$slides).removeClass('is-animating');
	      });
	
	      (0, _jquery2.default)('.js-slick').on('afterChange', function (event, slick, currentSlide) {
	        (0, _jquery2.default)(slick.$slides.get(currentSlide)).addClass('is-animating');
	      });
	    });
	  });
	
	  this.showChequeInnovacion1Dialog = function (ev) {
	    _this.showDialog(ev, 'cheque_innovacion1');
	  };
	
	  this.showChequeInnovacion2Dialog = function (ev) {
	    _this.showDialog(ev, 'cheque_innovacion2');
	  };
	
	  this.showDialog = function (ev, modal) {
	    $mdDialog.show({
	      controller: ["$scope", function controller($scope) {
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      controllerAs: 'ctrl',
	      templateUrl: '/static/modals/' + modal + '.html',
	      parent: _angular2.default.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose: true,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	}
	
	exports.default = {
	  template: _landing2.default,
	  controller: landingComponent
	};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	loginController.$inject = ["$rootScope", "$state", "$timeout", "$tszToast", "AuthService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(159);
	
	var _login2 = _interopRequireDefault(_login);
	
	__webpack_require__(294);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function loginController($rootScope, $state, $timeout, $tszToast, AuthService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.makeYourMagic = 'This is the login container';
	
	  this.loading = false;
	  this.error = '';
	  this.data = {
	    email: '',
	    password: ''
	  };
	
	  if ($state.params.obj) {
	    var params = $state.params.obj;
	    if (params.email) {
	      this.data.email = params.email;
	    }
	
	    if (params.toast) {
	      var toast = params.toast;
	      $tszToast.show(toast.message, toast.opts);
	    }
	  }
	
	  this.login = function (form) {
	    _this.loading = true;
	
	    if (form.$valid) {
	      _this.loading = true;
	    }
	
	    AuthService.login(_this.data.email, _this.data.password).then(function (userData) {
	
	      console.log('Successful login!');
	
	      var user = userData.data;
	
	      // Store user data into the user service
	      AuthService.setCredentials(user);
	
	      $rootScope.$broadcast('authenticated', true);
	
	      // login succeeded: redirect to the default page
	      if (AuthService.isAdmin()) {
	        $state.go('admin_home');
	      } else {
	        $state.go('home');
	      }
	    }).catch(function (err) {
	      // login error
	      if (err.data && err.data.code) {
	        $tszToast.showErrorI18n(err.data.code, 'El email o contraseña introducidos no son válidos');
	      } else {
	        $tszToast.showError('El email o contraseña introducidos no son válidos');
	      }
	    }).finally(function () {
	      // regardless of the response, change the loading state
	      _this.loading = false;
	    });
	  };
	}
	
	exports.default = {
	  template: _login2.default,
	  controller: loginController
	};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	meredicteComponent.$inject = ["$location", "$anchorScroll"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _meredicte = __webpack_require__(160);
	
	var _meredicte2 = _interopRequireDefault(_meredicte);
	
	__webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function meredicteComponent($location, $anchorScroll) {
	
	  'ngInject';
	
	  this.scrollTo = function (id) {
	    // set the location.hash to the id of
	    // the element you wish to scroll to.
	    $location.hash(id);
	
	    // call $anchorScroll()
	    $anchorScroll();
	  };
	}
	
	exports.default = {
	  template: _meredicte2.default,
	  controller: meredicteComponent
	};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	passwordRecoveryComponent.$inject = ["$stateParams", "$tszToast", "$translate", "AuthService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _passwordRecovery = __webpack_require__(161);
	
	var _passwordRecovery2 = _interopRequireDefault(_passwordRecovery);
	
	__webpack_require__(296);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function passwordRecoveryComponent($stateParams, $tszToast, $translate, AuthService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.loading = false;
	
	  this.data = {
	    email: $stateParams.e,
	    token: $stateParams.t
	  };
	
	  this.changePassword = function (form) {
	
	    if (form.$valid) {
	      _this.loading = true;
	    }
	
	    AuthService.changePassword(_this.data.email, _this.data.token, _this.data.password).then(function () {
	      $tszToast.showSuccess('La contraseña ha sido cambiada satisfactoriamente');
	    }).catch(function (err) {
	      if (err.data && err.data.code) {
	        $translate('ERROR.' + err.data.code).then(function (errorMsg) {
	          $tszToast.showError(errorMsg);
	          _this.error = errorMsg;
	        });
	      }
	    }).finally(function () {
	      // regardless of the response, change the loading state
	      _this.loading = false;
	    });
	  };
	}
	
	exports.default = {
	  template: _passwordRecovery2.default,
	  controller: passwordRecoveryComponent
	};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	plansComponent.$inject = ["$tszToast", "PlanService", "PropertyService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _plans = __webpack_require__(162);
	
	var _plans2 = _interopRequireDefault(_plans);
	
	__webpack_require__(297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function plansComponent($tszToast, PlanService, PropertyService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.loadPlans = function () {
	    PlanService.list().then(function (result) {
	      _this.plans = result;
	    }).catch(function () {
	      $tszToast.showError('Error al cargar la lista de planes');
	    });
	  };
	
	  this.save = function (plan) {
	    PlanService.save(plan).then(function () {
	      $tszToast.showSuccess('Plan actualizado correctamente');
	    }).catch(function () {
	      $tszToast.showError('Error al intentar actualizar el plan');
	    });
	  };
	
	  this.loadPromotionalMessage = function () {
	    PropertyService.get(_config.CONSTANTS.PROPERTY.PROMOTIONAL_MSG).then(function (result) {
	      _this.promotionalMessage = result.value;
	    }).catch(function () {
	      $tszToast.showError('Error al cargar la lista de planes');
	    });
	  };
	
	  this.savePromotionalMessage = function (promotionalMessage) {
	    console.log(promotionalMessage);
	    PropertyService.save({
	      name: _config.CONSTANTS.PROPERTY.PROMOTIONAL_MSG,
	      value: promotionalMessage
	    }).then(function () {
	      $tszToast.showSuccess('Propiedad actualizada correctamente');
	    }).catch(function () {
	      $tszToast.showError('Error al intentar guardar la propiedad');
	    });
	  };
	
	  //
	  // INIT
	  //
	
	  this.loadPlans();
	  this.loadPromotionalMessage();
	}
	
	exports.default = {
	  template: _plans2.default,
	  controller: plansComponent
	};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	reportEditComponent.$inject = ["$state", "$stateParams"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reportEdit = __webpack_require__(163);
	
	var _reportEdit2 = _interopRequireDefault(_reportEdit);
	
	__webpack_require__(298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reportEditComponent($state, $stateParams) {
	
	  'ngInject';
	
	  this.reportId = $stateParams.id;
	}
	
	exports.default = {
	  template: _reportEdit2.default,
	  controller: reportEditComponent
	};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	settingsComponent.$inject = ["$rootScope", "$tszToast", "AuthService", "UserService", "CompanyService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _settings = __webpack_require__(164);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	__webpack_require__(299);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function settingsComponent($rootScope, $tszToast, AuthService, UserService, CompanyService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.roles = _config.ROLES;
	
	  this.companyId = AuthService.getCompanyId();
	
	  this.user = AuthService.getAuthenticatedUser();
	
	  this.invite = function (userEmail) {
	    var invitation = {
	      email: userEmail,
	      companyId: _this.companyId
	    };
	    CompanyService.invite(_this.companyId, invitation).then(function () {
	      $tszToast.showSuccess('Se enviado una invitaci\xF3n al correo electr\xF3nico ' + userEmail);
	      $rootScope.$broadcast('reloadCompanyUsers', _this.user.companyId);
	    }).catch(function () {
	      $tszToast.showError('No se ha podido enviar la invitaci\xF3n a ' + userEmail);
	    });
	  };
	
	  this.showCompanySettings = function () {
	    return AuthService.isUser();
	  };
	  this.showTeamSettings = function () {
	    return AuthService.isUser() && AuthService.hasEnterprisePlan();
	  };
	}
	
	exports.default = {
	  template: _settings2.default,
	  controller: settingsComponent
	};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	signupComponent.$inject = ["$state", "$mdDialog", "$translate", "$tszToast", "AuthService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(165);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	__webpack_require__(300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function signupComponent($state, $mdDialog, $translate, $tszToast, AuthService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.loading = false;
	  this.error = '';
	
	  this.data = {
	    email: '',
	    password: '',
	    confirmPassword: '',
	    companyName: ''
	  };
	
	  this.signup = function (form) {
	
	    if (form.$valid) {
	
	      _this.loading = true;
	
	      AuthService.signup(_this.data.email, _this.data.password, _this.data.companyName).then(function (response) {
	        if (response.status === 200) {
	          // signup succeeded
	          var toastOpts = {
	            hideDelay: 300000
	          };
	          $tszToast.showSuccess('Registro realizado. Le hemos enviado un correo electrónico para validar su cuenta.', toastOpts);
	          console.log('Successful signup!');
	        } else {
	          console.log(response);
	          if (response.data && response.data.code) {
	            $translate('ERROR.' + response.data.code).then(function (errorMsg) {
	              $tszToast.showError(errorMsg);
	              _this.error = errorMsg;
	            });
	          }
	        }
	      }).catch(function (err) {
	        // signup error
	        if (err.data && err.data.code) {
	          $translate('ERROR.' + err.data.code).then(function (errorMsg) {
	            $tszToast.showError(errorMsg);
	            _this.error = errorMsg;
	          });
	        }
	      }).finally(function () {
	        // regardless of the response, change the loading state
	        _this.loading = false;
	      });
	    }
	  };
	
	  this.showCookiesDialog = function (ev) {
	    ev.stopPropagation();
	    _this.showDialog(ev, 'cookies');
	  };
	
	  this.showLegalNoticeDialog = function (ev) {
	    ev.stopPropagation();
	    _this.showDialog(ev, 'legal_notice');
	  };
	
	  this.showPrivacyPolicyDialog = function (ev) {
	    ev.stopPropagation();
	    _this.showDialog(ev, 'privacy_policy');
	  };
	
	  this.showUsageTermsDialog = function (ev) {
	    ev.stopPropagation();
	    _this.showDialog(ev, 'usage_terms');
	  };
	
	  this.showDialog = function (ev, modal) {
	    $mdDialog.show({
	      controller: ["$scope", function controller($scope) {
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      controllerAs: 'ctrl',
	      templateUrl: '/static/modals/' + modal + '.html',
	      parent: _angular2.default.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose: true,
	      fullscreen: false // Only for -xs, -sm breakpoints.
	    });
	  };
	}
	
	exports.default = {
	  template: _signup2.default,
	  controller: signupComponent
	};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	subscriptionsComponent.$inject = ["AuthService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _subscriptions = __webpack_require__(166);
	
	var _subscriptions2 = _interopRequireDefault(_subscriptions);
	
	__webpack_require__(301);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function subscriptionsComponent(AuthService) {
	
	  'ngInject';
	
	  this.companyId = AuthService.getCompanyId();
	}
	
	exports.default = {
	  template: _subscriptions2.default,
	  controller: subscriptionsComponent
	};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	thesafezoneComponent.$inject = ["$location", "$anchorScroll"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _thesafezone = __webpack_require__(167);
	
	var _thesafezone2 = _interopRequireDefault(_thesafezone);
	
	__webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function thesafezoneComponent($location, $anchorScroll) {
	
	  'ngInject';
	
	  this.scrollTo = function (id) {
	    // set the location.hash to the id of
	    // the element you wish to scroll to.
	    $location.hash(id);
	
	    // call $anchorScroll()
	    $anchorScroll();
	  };
	}
	
	exports.default = {
	  template: _thesafezone2.default,
	  controller: thesafezoneComponent
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	verifyAccountController.$inject = ["$state", "$stateParams", "$tszToast", "AuthService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _verifyAccount = __webpack_require__(168);
	
	var _verifyAccount2 = _interopRequireDefault(_verifyAccount);
	
	__webpack_require__(303);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyAccountController($state, $stateParams, $tszToast, AuthService) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.loading = true;
	
	  var email = $stateParams.e;
	  var token = $stateParams.t;
	
	  AuthService.verifyAccount(email, token).then(function () {
	    // validation succeeded: redirect to the default page
	    console.log('Email validated!');
	    // $tszToast.showSuccess('Su correo electrónico ha sido validado. Ya puede iniciar sesión.');
	    var params = {
	      obj: {
	        status: 'EMAIL_VALIDATED',
	        toast: {
	          message: 'Su correo electrónico ha sido validado. Ya puede iniciar sesión.',
	          opts: { success: true }
	        },
	        email: email
	      }
	    };
	    $state.go('login', params);
	  }).catch(function (err) {
	    // login error
	    $tszToast.showError('Lo sentimos. Su cuenta no ha podido ser validada: ' + err);
	  }).finally(function () {
	    // regardless of the response, change the loading state
	    _this.loading = false;
	  });
	}
	
	exports.default = {
	  template: _verifyAccount2.default,
	  controller: verifyAccountController
	};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	
	  return function buildingUsage() {
	    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    if (_config.CONSTANTS.BUILDING_USAGE[type]) {
	      return _config.CONSTANTS.BUILDING_USAGE[type].name;
	    }
	    return '';
	  };
	};
	
	var _config = __webpack_require__(2);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	
	  return function designType() {
	    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    if (_config.CONSTANTS.PROJECT_TYPE[type]) {
	      return _config.CONSTANTS.PROJECT_TYPE[type].name;
	    }
	    return '';
	  };
	};
	
	var _config = __webpack_require__(2);

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	
	  return function emailsFilter() {
	    var emails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    return emails.join(', ');
	  };
	};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _designType = __webpack_require__(232);
	
	var _designType2 = _interopRequireDefault(_designType);
	
	var _version = __webpack_require__(239);
	
	var _version2 = _interopRequireDefault(_version);
	
	var _emailsFilter = __webpack_require__(233);
	
	var _emailsFilter2 = _interopRequireDefault(_emailsFilter);
	
	var _buildingUsage = __webpack_require__(231);
	
	var _buildingUsage2 = _interopRequireDefault(_buildingUsage);
	
	var _nrg = __webpack_require__(236);
	
	var _nrg2 = _interopRequireDefault(_nrg);
	
	var _na = __webpack_require__(235);
	
	var _na2 = _interopRequireDefault(_na);
	
	var _nrgColor = __webpack_require__(237);
	
	var _nrgColor2 = _interopRequireDefault(_nrgColor);
	
	var _planType = __webpack_require__(238);
	
	var _planType2 = _interopRequireDefault(_planType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filtersModule = _angular2.default.module('meredicte.filters', []).filter({ designType: _designType2.default }).filter({ emailsFilter: _emailsFilter2.default }).filter({ buildingUsage: _buildingUsage2.default }).filter({ version: _version2.default }).filter({ nrg: _nrg2.default }).filter({ na: _na2.default }).filter({ nrgColor: _nrgColor2.default }).filter({ planType: _planType2.default });
	
	exports.default = filtersModule;

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	
	  return function na() {
	    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    return val || 'N/A';
	  };
	};

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	
	  return function nrg() {
	    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    if (val > 0.0 && val <= 0.5) {
	      return 'Muy reducido';
	    } else if (val > 0.5 && val <= 1.0) {
	      return 'Reducido';
	    } else if (val > 1.0 && val <= 1.5) {
	      return 'Elevado';
	    } else if (val > 1.5 && val <= 2.0) {
	      return 'Muy elevado';
	    } else if (val > 2.0 && val <= 5.0) {
	      return 'Grave';
	    } else if (val > 5.0 && val <= 10.0) {
	      return 'Muy grave';
	    } else if (val > 10.0) {
	      return 'Catastrófico';
	    }
	    return '--';
	  };
	};

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	
	  return function nrgColor() {
	    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    if (val > 0.0 && val <= 0.5) {
	      return '#64d268';
	    } else if (val > 0.5 && val <= 1.0) {
	      return '#439029';
	    } else if (val > 1.0 && val <= 1.5) {
	      return '#e6ec75';
	    } else if (val > 1.5 && val <= 2.0) {
	      return '#ecd32f';
	    } else if (val > 2.0 && val <= 5.0) {
	      return '#ebb134';
	    } else if (val > 5.0 && val <= 10.0) {
	      return '#ec7538';
	    } else if (val > 10.0) {
	      return '#ec4630';
	    }
	    return '#000000';
	  };
	};

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return function planType() {
	    var monthly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    if (monthly === true) {
	      return 'Mensual';
	    } else if (monthly === false) {
	      return 'Anual';
	    }
	    return '-';
	  };
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	
	  return function version() {
	    var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    if (_config.CONSTANTS.VERSION[v]) {
	      return _config.CONSTANTS.VERSION[v].name;
	    }
	    return '';
	  };
	};
	
	var _config = __webpack_require__(2);

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularChart = __webpack_require__(11);
	
	var _angularChart2 = _interopRequireDefault(_angularChart);
	
	var _angularUiRouter = __webpack_require__(21);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _angularCookies = __webpack_require__(12);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularFileSaver = __webpack_require__(13);
	
	var _angularFileSaver2 = _interopRequireDefault(_angularFileSaver);
	
	var _ngFileUpload = __webpack_require__(25);
	
	var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);
	
	var _angularMarked = __webpack_require__(14);
	
	var _angularMarked2 = _interopRequireDefault(_angularMarked);
	
	var _angularMaterial = __webpack_require__(15);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularMessages = __webpack_require__(16);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _angularResource = __webpack_require__(17);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	__webpack_require__(10);
	
	__webpack_require__(18);
	
	__webpack_require__(19);
	
	__webpack_require__(20);
	
	__webpack_require__(22);
	
	__webpack_require__(43);
	
	__webpack_require__(41);
	
	__webpack_require__(26);
	
	__webpack_require__(7);
	
	var _app = __webpack_require__(215);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _header = __webpack_require__(218);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(216);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _components = __webpack_require__(171);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _filters = __webpack_require__(234);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _models = __webpack_require__(241);
	
	var _models2 = _interopRequireDefault(_models);
	
	var _services = __webpack_require__(282);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _translations = __webpack_require__(283);
	
	var _translations2 = _interopRequireDefault(_translations);
	
	__webpack_require__(126);
	
	var _landing = __webpack_require__(254);
	
	var _landing2 = _interopRequireDefault(_landing);
	
	var _home = __webpack_require__(252);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(245);
	
	var _home4 = _interopRequireDefault(_home3);
	
	var _module = __webpack_require__(243);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _plans = __webpack_require__(260);
	
	var _plans2 = _interopRequireDefault(_plans);
	
	var _settings = __webpack_require__(264);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _reportEdit = __webpack_require__(262);
	
	var _reportEdit2 = _interopRequireDefault(_reportEdit);
	
	var _login = __webpack_require__(256);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _signup = __webpack_require__(266);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _subscriptions = __webpack_require__(268);
	
	var _subscriptions2 = _interopRequireDefault(_subscriptions);
	
	var _forgotPassword = __webpack_require__(250);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	var _passwordRecovery = __webpack_require__(258);
	
	var _passwordRecovery2 = _interopRequireDefault(_passwordRecovery);
	
	var _verifyAccount = __webpack_require__(270);
	
	var _verifyAccount2 = _interopRequireDefault(_verifyAccount);
	
	var _auth = __webpack_require__(247);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _chromeAutofillFix = __webpack_require__(248);
	
	var _chromeAutofillFix2 = _interopRequireDefault(_chromeAutofillFix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// app main module definition
	
	
	// app styles
	
	
	// app components/directives
	// ----------------------------------
	// App main module (entry point):
	// the app will be bootstrapped here
	// ----------------------------------
	
	// vendor dependencies
	var meredicte = _angular2.default.module('meredicte', ['angulartics', 'angulartics.google.analytics', _angularChart2.default, _angularUiRouter2.default, _angularCookies2.default, _angularFileSaver2.default, _ngFileUpload2.default, _angularMarked2.default, _angularMaterial2.default, _angularMessages2.default, _angularResource2.default, 'ngStorage', 'pascalprecht.translate', 'base64', 'Tek.progressBar', 'ui.grid', 'ui.grid.pagination', _components2.default.name, _filters2.default.name, _models2.default.name, _services2.default.name, _auth2.default.name, _landing2.default.name, _home2.default.name, _home4.default.name, _module2.default.name, _plans2.default.name, _settings2.default.name, _reportEdit2.default.name, _login2.default.name, _signup2.default.name, _subscriptions2.default.name, _forgotPassword2.default.name, _passwordRecovery2.default.name, _verifyAccount2.default.name, _chromeAutofillFix2.default.name]);
	
	// register app component and models
	
	
	// import ngStorage from 'ng-storage';
	
	meredicte.component('angularApp', _app2.default).component('appHeader', _header2.default).component('appFooter', _footer2.default).config(["$logProvider", "$compileProvider", "$urlRouterProvider", "$analyticsProvider", "$locationProvider", "$translateProvider", "$httpProvider", "$mdThemingProvider", "$mdDateLocaleProvider", "ChartJsProvider", function ($logProvider, $compileProvider, $urlRouterProvider, $analyticsProvider, $locationProvider, $translateProvider, $httpProvider, $mdThemingProvider, $mdDateLocaleProvider, ChartJsProvider) {
	
	  'ngInject';
	
	  // ui-router config
	
	  $urlRouterProvider.otherwise('/404');
	  $locationProvider.html5Mode(true);
	
	  $httpProvider.defaults.withCredentials = true;
	
	  // __DEV__ is a "magic" environment var, see webpack/config.js
	  /* eslint-disable no-undef */
	  $compileProvider.debugInfoEnabled((false));
	  $logProvider.debugEnabled((false));
	  /* eslint-enable no-undef */
	
	  // turn on/off automatic tracking
	  $analyticsProvider.settings.optOut = true;
	
	  $translateProvider.translations('es', _translations2.default).preferredLanguage('es').useSanitizeValueStrategy('escape');
	
	  $mdThemingProvider.theme('docs-dark');
	
	  ChartJsProvider.setOptions({ responsive: true });
	
	  _moment2.default.locale('es-ES');
	
	  $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
	  $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
	  $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
	  $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
	
	  // Can change week display to start on Monday.
	  $mdDateLocaleProvider.firstDayOfWeek = 1;
	
	  $mdDateLocaleProvider.parseDate = function (dateString) {
	    var m = (0, _moment2.default)(dateString, 'DD/MM/YYYY', true);
	    return m.isValid() ? m.toDate() : new Date(NaN);
	  };
	
	  $mdDateLocaleProvider.formatDate = function (date) {
	    var m = (0, _moment2.default)(date);
	    return m.isValid() ? m.format('DD/MM/YYYY') : '';
	  };
	}]).run(["i18nService", function (i18nService) {
	  i18nService.setCurrentLang('es');
	}]);
	
	meredicte.directive('tszFileUpload', ["$parse", function ($parse) {
	
	  function link(scope, element, attrs) {
	    var fn = $parse(attrs.tszFileUpload);
	
	    element.on('change', function (onChangeEvent) {
	      var reader = new FileReader();
	
	      reader.onload = function (onLoadEvent) {
	        scope.$apply(function () {
	          fn(scope, { $fileContent: onLoadEvent.target.result });
	        });
	      };
	      reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0]);
	    });
	  }
	
	  return {
	    restrict: 'A',
	    scope: false,
	    link: link
	  };
	}]);
	
	meredicte.directive('bgScroll', function () {
	
	  function link(scope) {
	    _angular2.default.element(window).bind('scroll', function () {
	      scope.scroll = window.pageYOffset;
	      console.log('scroll: ' + scope.scroll);
	    });
	    scope.$on('$destroy', function () {
	      _angular2.default.element(window).unbind('scroll');
	    });
	  }
	
	  return {
	    restrict: 'A',
	    link: link
	  };
	});
	
	exports.default = meredicte;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modelsModule = _angular2.default.module('meredicte.models', []);
	
	exports.default = modelsModule;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var adminCompanyConfig = function adminCompanyConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('admin_company', {
	    url: '/admin/companies/:id',
	    template: '<app-admin-company></app-admin-company>',
	    access: {
	      loginRequired: true,
	      roles: [_config.ROLES.ADMIN]
	    },
	    params: {
	      name: null // hides name param
	    }
	  });
	};
	adminCompanyConfig.$inject = ["$stateProvider"];
	
	exports.default = adminCompanyConfig;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _config = __webpack_require__(242);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _adminCompanyDetail = __webpack_require__(213);
	
	var _adminCompanyDetail2 = _interopRequireDefault(_adminCompanyDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminCompanyModule = _angular2.default.module('meredicte.admin_company', []).component('appAdminCompany', _adminCompanyDetail2.default).config(_config2.default);
	
	exports.default = adminCompanyModule;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var homeConfig = function homeConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('admin_home', {
	    url: '/admin/home',
	    template: '<app-admin-home></app-admin-home>',
	    access: {
	      loginRequired: true,
	      roles: [_config.ROLES.ADMIN]
	    }
	  });
	};
	homeConfig.$inject = ["$stateProvider"];
	
	exports.default = homeConfig;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(244);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _adminHome = __webpack_require__(214);
	
	var _adminHome2 = _interopRequireDefault(_adminHome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeModule = _angular2.default.module('meredicte.admin_home', []).component('appAdminHome', _adminHome2.default).config(_home2.default);
	
	exports.default = homeModule;

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ["$rootScope", "$q", "$injector"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function authInterceptor($rootScope, $q, $injector) {
	
	  'ngInject';
	
	  var state = void 0;
	
	  return {
	
	    // intercept HTTP 401s
	    responseError: function responseError(response) {
	      // manual 'inject' due to circular dependency hell
	      var AuthService = $injector.get('AuthService');
	
	      if (response.status === 401) {
	        // remove any stale token
	        AuthService.logout();
	        // redirect to login
	        (state || (state = $injector.get('$state'))).go('login');
	      }
	
	      return $q.reject(response);
	    }
	  };
	}
	
	exports.default = authInterceptor;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(6);
	
	var _auth = __webpack_require__(246);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authModule = _angular2.default.module('meredicte.auth', []);
	
	authModule.factory('authInterceptor', _auth2.default).config(["$httpProvider", function ($httpProvider) {
	  $httpProvider.interceptors.push('authInterceptor');
	}]).run(["$rootScope", "$state", "AuthService", function ($rootScope, $state, AuthService) {
	
	  'ngInject';
	
	  var currentState = null;
	
	  // check user roles/permissions in order to know if it can go to the specified state:
	  // default to "forbidden" state when conditions aren't met
	  var checkRolesAndGo = function checkRolesAndGo(next, nextParams) {
	    var roles = next.access.roles && next.access.roles.length ? next.access.roles : false;
	
	    currentState = next.name;
	    if (roles) {
	      if (AuthService.hasRoles(roles)) {
	        currentState = next.name;
	      } else {
	        currentState = 'forbidden';
	      }
	    }
	
	    $state.go(currentState, nextParams);
	  };
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams) {
	
	    var needAuth = (0, _lodash.isUndefined)(next.access) || (0, _lodash.isUndefined)(next.access.loginRequired) ? true : next.access.loginRequired;
	    var isUserLogged = AuthService.isAuthenticated();
	
	    if (next.name === currentState) {
	      return;
	    }
	
	    if (needAuth) {
	
	      // Make a ping request to see if the user is logged in
	      // AuthService.ping();
	
	      event.preventDefault();
	
	      if (!isUserLogged) {
	        // navigate to the login state
	        $state.go('login');
	      } else if (!AuthService.isAuthenticated()) {
	        // check if we already have a user
	        AuthService.fetch().then(function (response) {
	          AuthService.setCredentials(response.data);
	          checkRolesAndGo(next, nextParams);
	        }).catch(function (err) {
	          throw err;
	        });
	      } else {
	        checkRolesAndGo(next, nextParams);
	      }
	    } else {
	      checkRolesAndGo(next, nextParams);
	    }
	  });
	
	  $rootScope.$on('$stateChangeSuccess', function (event, next, nextParams) {
	    // change the page title
	    var title = $state.$current.locals.globals.$title;
	
	    /* eslint-disable no-param-reassign */
	    $rootScope.$title = (0, _lodash.isFunction)(title) ? title() : title;
	    /* eslint-enable no-param-reassign */
	    if (next.redirectTo) {
	      event.preventDefault();
	      var options = next.redirectTo.options || {};
	      options.relative = next;
	      $state.transitionTo(next.redirectTo.sref, nextParams, options);
	    }
	  });
	
	  // that's what execute when the $state.resolve promise is rejected
	  $rootScope.$on('$stateChangeError', function (event, next, nextParams, prev, prevParams, error) {
	    console.log('$stateChangeError', { event: event, next: next, nextParams: nextParams, prev: prev, prevParams: prevParams, error: error });
	
	    if ((0, _lodash.isFunction)(error.onError)) {
	      // onError should be a function with the redirect purpose
	      error.onError();
	    }
	  });
	}]);
	
	exports.default = authModule;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_TRIES = 5;
	var TRY_INTERVAL = 100;
	
	function isChrome() {
	  return navigator.userAgent.match(/chrome/i) && !navigator.userAgent.match(/edge/i);
	}
	
	function requiredDirective($interval, $log) {
	
	  function linkFn(scope, elem, attrs, ngModel) {
	    if (!ngModel) {
	      // no ngModel, nothing to do!
	      return;
	    }
	    var originalValidator = ngModel.$validators.required;
	
	    // try validating until
	    var tries = 0;
	    var timer = $interval(function () {
	      tries += 1;
	      if (tries > MAX_TRIES) {
	        $interval.cancel(timer);
	      }
	      ngModel.$validate();
	    }, TRY_INTERVAL);
	
	    function validator(modelValue, viewValue) {
	
	      if (isChrome() && elem[0].matches('input[type=password]:-webkit-autofill')) {
	        $log.info('bypassing required validator because of Chrome auto-filling');
	        $interval.cancel(timer);
	        return true;
	      }
	      return originalValidator(modelValue, viewValue);
	    }
	
	    ngModel.$validators.required = validator;
	  }
	
	  return {
	    priority: 100,
	    require: '?ngModel',
	    link: linkFn
	  };
	}
	
	function mdInputContainerDirective($interval) {
	
	  function linkFn($scope, elem) {
	    if (isChrome()) {
	      var tries = 0;
	      var timer = $interval(function () {
	        tries += 1;
	        if (tries > MAX_TRIES) {
	          $interval.cancel(timer);
	        }
	        if (elem[0].querySelector('input[type=password]:-webkit-autofill')) {
	          elem.addClass('md-input-has-value');
	          $interval.cancel(timer);
	        }
	      }, TRY_INTERVAL);
	    }
	  }
	
	  return {
	    restrict: 'E',
	    link: linkFn
	  };
	}
	
	/**
	* element.matches() pollyfill
	*/
	
	function matchesFn(ElementPrototype) {
	  ElementPrototype.matches = ElementPrototype.matchesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.msMatchesSelector || ElementPrototype.oMatchesSelector || ElementPrototype.webkitMatchesSelector || function f(selector) {
	    var node = this;
	    var nodes = (node.parentNode || node.document).querySelectorAll(selector);
	    var i = -1;
	
	    /* eslint no-plusplus: 0 */
	    while (nodes[++i] && nodes[i] !== node) {}
	
	    return !!nodes[i];
	  };
	}
	
	if (Element) {
	  matchesFn(Element.prototype);
	}
	
	/**
	* @ngdoc module
	* @name chrome-autofill-fix
	* @module chrome-autofill-fix
	* @description
	* A tiny fix for chrome problems regarding auto-filled passwords
	*
	*/
	var chromeAutofillFixModule = _angular2.default.module('chrome-autofill-fix', [])
	/**
	* @ngdoc directive
	* @module chrome-autofill-fix
	* @name mdInputContainer
	* Prevents floating label collapsing in [angular-material](https://material.angularjs.org/latest/demo/input) inputs
	*
	*/
	.directive('mdInputContainer', ['$interval', mdInputContainerDirective])
	/**
	* @ngdoc directive
	* @module chrome-autofill-fix
	* @name required
	* Overrides the default `required` validator to take Chrome auto-filling into account
	*/
	.directive('required', ['$interval', '$log', requiredDirective]);
	
	exports.default = chromeAutofillFixModule;

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var forgotPasswordConfig = function forgotPasswordConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('forgot-password', {
	    url: '/forgot-password',
	    template: '<app-forgot-password></app-forgot-password>',
	    access: {
	      loginRequired: false
	    },
	    resolve: {
	      // used to set the page title
	      $title: function $title() {
	        return 'Forgot Password';
	      }
	    }
	  });
	};
	forgotPasswordConfig.$inject = ["$stateProvider"];
	
	exports.default = forgotPasswordConfig;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _forgotPassword = __webpack_require__(249);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	var _forgotPassword3 = __webpack_require__(217);
	
	var _forgotPassword4 = _interopRequireDefault(_forgotPassword3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var forgotPasswordModule = _angular2.default.module('meredicte.forgotPassword', []).component('appForgotPassword', _forgotPassword4.default).config(_forgotPassword2.default);
	
	exports.default = forgotPasswordModule;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var homeConfig = function homeConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('home', {
	    url: '/home',
	    template: '<app-home></app-home>',
	    access: {
	      loginRequired: true,
	      roles: [_config.ROLES.USER]
	    }
	  });
	};
	homeConfig.$inject = ["$stateProvider"];
	
	exports.default = homeConfig;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(251);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(219);
	
	var _home4 = _interopRequireDefault(_home3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeModule = _angular2.default.module('meredicte.home', []).component('appHome', _home4.default).config(_home2.default);
	
	exports.default = homeModule;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var landingConfig = function landingConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('landing', {
	    url: '/',
	    template: '<app-landing></app-landing>',
	    access: {
	      loginRequired: false
	    }
	  }).state('meredicte', {
	    url: '/meredicte',
	    template: '<app-meredicte></app-meredicte>',
	    access: {
	      loginRequired: false
	    }
	  }).state('thesafezone', {
	    url: '/thesafezone',
	    template: '<app-thesafezone></app-thesafezone>',
	    access: {
	      loginRequired: false
	    }
	  });
	};
	landingConfig.$inject = ["$stateProvider"];
	
	exports.default = landingConfig;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _landing = __webpack_require__(253);
	
	var _landing2 = _interopRequireDefault(_landing);
	
	var _landing3 = __webpack_require__(220);
	
	var _landing4 = _interopRequireDefault(_landing3);
	
	var _meredicte = __webpack_require__(222);
	
	var _meredicte2 = _interopRequireDefault(_meredicte);
	
	var _thesafezone = __webpack_require__(229);
	
	var _thesafezone2 = _interopRequireDefault(_thesafezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var landingModule = _angular2.default.module('meredicte.landing', []).component('appLanding', _landing4.default).component('appMeredicte', _meredicte2.default).component('appThesafezone', _thesafezone2.default).config(_landing2.default);
	
	exports.default = landingModule;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loginConfig = function loginConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('login', {
	    url: '/login',
	    params: {
	      obj: null
	    },
	    template: '<app-login></app-login>',
	    access: {
	      loginRequired: false
	    },
	    resolve: {
	      // used to set the page title
	      $title: function $title() {
	        return 'Login';
	      }
	    }
	  });
	};
	loginConfig.$inject = ["$stateProvider"];
	
	exports.default = loginConfig;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(255);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(221);
	
	var _login4 = _interopRequireDefault(_login3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginModule = _angular2.default.module('meredicte.login', []).component('appLogin', _login4.default).config(_login2.default);
	
	exports.default = loginModule;

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var passwordRecoveryConfig = function passwordRecoveryConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('password-recovery', {
	    url: '/password-recovery?e&t',
	    template: '<app-password-recovery></app-password-recovery>',
	    access: {
	      loginRequired: false
	    },
	    resolve: {
	      // used to set the page title
	      $title: function $title() {
	        return 'Password recovery';
	      }
	    }
	  });
	};
	passwordRecoveryConfig.$inject = ["$stateProvider"];
	
	exports.default = passwordRecoveryConfig;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _passwordRecovery = __webpack_require__(257);
	
	var _passwordRecovery2 = _interopRequireDefault(_passwordRecovery);
	
	var _passwordRecovery3 = __webpack_require__(223);
	
	var _passwordRecovery4 = _interopRequireDefault(_passwordRecovery3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var passwordRecoveryModule = _angular2.default.module('meredicte.passwordRecovery', []).component('appPasswordRecovery', _passwordRecovery4.default).config(_passwordRecovery2.default);
	
	exports.default = passwordRecoveryModule;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var plansConfig = function plansConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('plans', {
	    url: '/admin/plans',
	    template: '<app-plans></app-plans>',
	    access: {
	      loginRequired: true,
	      roles: [_config.ROLES.ADMIN]
	    }
	  });
	};
	plansConfig.$inject = ["$stateProvider"];
	
	exports.default = plansConfig;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _plans = __webpack_require__(259);
	
	var _plans2 = _interopRequireDefault(_plans);
	
	var _plans3 = __webpack_require__(224);
	
	var _plans4 = _interopRequireDefault(_plans3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plansModule = _angular2.default.module('meredicte.plans', []).component('appPlans', _plans4.default).config(_plans2.default);
	
	exports.default = plansModule;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var reportEditConfig = function reportEditConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('report', {
	    url: '/report/{id}?v',
	    template: '<report-edit></report-edit>',
	    params: {
	      extras: null
	    },
	    access: {
	      loginRequired: true,
	      roles: [_config.ROLES.USER, _config.ROLES.ADMIN]
	    },
	    resolve: {
	      // meredicteParams: (CatalogService) => CatalogService.getMeredicteParams(),
	    }
	  });
	};
	reportEditConfig.$inject = ["$stateProvider"];
	
	exports.default = reportEditConfig;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _reportEdit = __webpack_require__(261);
	
	var _reportEdit2 = _interopRequireDefault(_reportEdit);
	
	var _reportEdit3 = __webpack_require__(225);
	
	var _reportEdit4 = _interopRequireDefault(_reportEdit3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportEditModule = _angular2.default.module('meredicte.reportEdit', []).component('reportEdit', _reportEdit4.default).config(_reportEdit2.default);
	
	exports.default = reportEditModule;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var settingsConfig = function settingsConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('settings', {
	    url: '/settings',
	    template: '<app-settings></app-settings>',
	    access: {
	      loginRequired: true,
	      roles: [_config.ROLES.USER, _config.ROLES.ADMIN]
	    },
	    resolve: {
	      // used to set the page title
	      $title: function $title() {
	        return 'Perfil';
	      }
	    }
	  });
	};
	settingsConfig.$inject = ["$stateProvider"];
	
	exports.default = settingsConfig;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(263);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _settings3 = __webpack_require__(226);
	
	var _settings4 = _interopRequireDefault(_settings3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settingsModule = _angular2.default.module('meredicte.settings', []).component('appSettings', _settings4.default).config(_settings2.default);
	
	exports.default = settingsModule;

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var signupConfig = function signupConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('signup', {
	    url: '/signup',
	    template: '<app-signup></app-signup>',
	    access: {
	      loginRequired: false
	    },
	    resolve: {
	      // used to set the page title
	      $title: function $title() {
	        return 'Signup';
	      }
	    }
	  });
	};
	signupConfig.$inject = ["$stateProvider"];
	
	exports.default = signupConfig;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(265);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _signup3 = __webpack_require__(227);
	
	var _signup4 = _interopRequireDefault(_signup3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var signupModule = _angular2.default.module('meredicte.signup', []).component('appSignup', _signup4.default).config(_signup2.default);
	
	exports.default = signupModule;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var subscriptionsConfig = function subscriptionsConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('subscriptions', {
	    url: '/subscriptions',
	    template: '<app-subscriptions></app-subscriptions>',
	    access: {
	      loginRequired: true,
	      roles: [_config.ROLES.USER]
	    }
	  });
	};
	subscriptionsConfig.$inject = ["$stateProvider"];
	
	exports.default = subscriptionsConfig;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _subscriptions = __webpack_require__(267);
	
	var _subscriptions2 = _interopRequireDefault(_subscriptions);
	
	var _subscriptions3 = __webpack_require__(228);
	
	var _subscriptions4 = _interopRequireDefault(_subscriptions3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionsModule = _angular2.default.module('meredicte.subscriptions', []).component('appSubscriptions', _subscriptions4.default).config(_subscriptions2.default);
	
	exports.default = subscriptionsModule;

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var verifyAccountConfig = function verifyAccountConfig($stateProvider) {
	
	  'ngInject';
	
	  $stateProvider.state('verifyAccount', {
	    url: '/verify-account?e={email}&t={token}',
	    template: '<verify-account></verify-account>',
	    access: {
	      loginRequired: false
	    },
	    resolve: {
	      // used to set the page title
	      $title: function $title() {
	        return 'Validación de la cuenta';
	      }
	    }
	  });
	};
	verifyAccountConfig.$inject = ["$stateProvider"];
	
	exports.default = verifyAccountConfig;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _verifyAccount = __webpack_require__(269);
	
	var _verifyAccount2 = _interopRequireDefault(_verifyAccount);
	
	var _verifyAccount3 = __webpack_require__(230);
	
	var _verifyAccount4 = _interopRequireDefault(_verifyAccount3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var verifyAccountModule = _angular2.default.module('meredicte.verifyAccount', []).component('verifyAccount', _verifyAccount4.default).config(_verifyAccount2.default);
	
	exports.default = verifyAccountModule;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AdminService.$inject = ["$http", "$resource"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	function AdminService($http, $resource) {
	
	  'ngInject';
	
	  var SubscriptionResource = $resource(_config.API.ADMIN.SUBSCRIPTIONS, { subscription_id: '@id' }, {
	    get: {
	      method: 'GET',
	      isArray: true
	    },
	    create: {
	      method: 'POST'
	    },
	    update: {
	      method: 'PUT'
	    },
	    delete: {
	      method: 'DELETE'
	    }
	  });
	
	  return {
	    createSubscription: function createSubscription(companyId, subscription) {
	      return SubscriptionResource.create({ companyId: companyId }, subscription).$promise;
	    },
	
	    updateSubscription: function updateSubscription(companyId, subscriptionId, subscription) {
	      return SubscriptionResource.update({ companyId: companyId, subscriptionId: subscriptionId }, subscription).$promise;
	    },
	
	    deleteSubscription: function deleteSubscription(companyId, subscriptionId) {
	      return SubscriptionResource.delete({ companyId: companyId, subscriptionId: subscriptionId }).$promise;
	    },
	
	    getSubscriptions: function getSubscriptions(companyId) {
	      return SubscriptionResource.get({ companyId: companyId }).$promise;
	    }
	  };
	}
	
	exports.default = AdminService;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuthService.$inject = ["$http", "$rootScope", "$localStorage"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(6);
	
	var AUTH = _config.API.AUTH;
	
	function AuthService($http, $rootScope, $localStorage) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.setCredentials = function (user) {
	    $localStorage.user = user;
	    $rootScope.$broadcast('authenticated', true);
	  };
	
	  this.fetch = function () {
	    $http.get(_config.API.USER).then(function (response) {
	      _this.setCredentials(response.data);
	    }).catch(function (err) {
	      throw err;
	    });
	  };
	
	  this.clearCredentials = function () {
	    delete $localStorage.user;
	  };
	
	  this.getAuthenticatedUser = function () {
	    return $localStorage.user;
	  };
	
	  this.getRoles = function () {
	    return _this.getAuthenticatedUser().roles;
	  };
	
	  this.hasRoles = function (roles) {
	    var hasRoles = false;
	    var userRoles = _this.getRoles();
	    if ((0, _lodash.isArray)(roles)) {
	      hasRoles = (0, _lodash.intersection)(userRoles, roles).length > 0;
	    } else {
	      hasRoles = (0, _lodash.includes)(userRoles, roles);
	    }
	    return hasRoles;
	  };
	
	  this.getPlan = function () {
	    return _this.getAuthenticatedUser().plan;
	  };
	  this.hasProfressionalPlan = function () {
	    return _this.getPlan() === _config.PLANS.PROFESSIONAL;
	  };
	  this.hasEnterprisePlan = function () {
	    return _this.getPlan() === _config.PLANS.ENTERPRISE;
	  };
	  this.hasExpertoPlan = function () {
	    return _this.getPlan() === _config.PLANS.EXPERTO;
	  };
	  this.hasValidacionPlan = function () {
	    return _this.getPlan() === _config.PLANS.VALIDACION;
	  };
	  this.hasFreePlan = function () {
	    return (0, _lodash.indexOf)((0, _lodash.keys)(_config.PLANS), _this.getPlan()) === -1;
	  };
	  this.hasPlan = function () {
	    return !_this.hasFreePlan();
	  };
	
	  return {
	
	    login: function login(email, password) {
	      var data = {
	        username: email,
	        password: password
	      };
	      var headers = {
	        'content-type': 'application/x-www-form-urlencoded'
	      };
	      return $http.post(AUTH.LOGIN + '?username=' + email + '&password=' + password, data, headers);
	    },
	
	    logout: function logout() {
	      $rootScope.$broadcast('authenticated', false);
	      _this.clearCredentials();
	      return $http.get(AUTH.LOGOUT);
	    },
	
	    ping: function ping() {
	      return $http.get(_config.API.PING);
	    },
	
	    signup: function signup(email, password, companyName) {
	      var data = {
	        email: email,
	        password: password,
	        confirmPassword: password,
	        companyName: companyName
	      };
	      return $http.post(AUTH.SIGNUP, data);
	    },
	
	    verifyAccount: function verifyAccount(email, token) {
	      var data = {
	        email: email,
	        token: token
	      };
	      return $http.post(AUTH.VERIFY_ACCOUNT, data);
	    },
	
	    forgotPassword: function forgotPassword(email) {
	      var data = {
	        email: email
	      };
	      return $http.post(AUTH.FORGOT_PASSWORD, data);
	    },
	
	    changePassword: function changePassword(email, token, password) {
	      var data = {
	        email: email,
	        token: token,
	        password: password
	      };
	      return $http.post(AUTH.CHANGE_PASSWORD, data);
	    },
	
	    updatePassword: function updatePassword(currentPassword, newPassword) {
	      var data = {
	        currentPassword: currentPassword,
	        newPassword: newPassword
	      };
	      return $http.post(AUTH.UPDATE_PASSWORD, data);
	    },
	
	    mergeCredentials: function mergeCredentials(user) {
	      return _this.setCredentials((0, _lodash.merge)(_this.getAuthenticatedUser(), user));
	    },
	    setCredentials: function setCredentials(user) {
	      return _this.setCredentials(user);
	    },
	    clearCredentials: function clearCredentials() {
	      return _this.clearCredentials();
	    },
	    fetch: function fetch() {
	      return _this.fetch();
	    },
	    isAuthenticated: function isAuthenticated() {
	      return typeof _this.getAuthenticatedUser() !== 'undefined';
	    },
	    getAuthenticatedUser: function getAuthenticatedUser() {
	      return _this.getAuthenticatedUser();
	    },
	    getUserId: function getUserId() {
	      return _this.getAuthenticatedUser().id;
	    },
	    getCompanyId: function getCompanyId() {
	      return _this.getAuthenticatedUser().companyId;
	    },
	    getPlan: function getPlan() {
	      return _this.getPlan();
	    },
	    hasExpertoPlan: function hasExpertoPlan() {
	      return _this.hasExpertoPlan();
	    },
	    hasValidacionPlan: function hasValidacionPlan() {
	      return _this.hasValidacionPlan();
	    },
	    hasProfressionalPlan: function hasProfressionalPlan() {
	      return _this.hasProfressionalPlan();
	    },
	    hasEnterprisePlan: function hasEnterprisePlan() {
	      return _this.hasEnterprisePlan();
	    },
	    hasPlan: function hasPlan() {
	      return _this.hasPlan();
	    },
	    hasRoles: function hasRoles(roles) {
	      return _this.hasRoles(roles);
	    },
	    isUser: function isUser() {
	      return _this.hasRoles(_config.ROLES.USER);
	    },
	    isAdmin: function isAdmin() {
	      return _this.hasRoles(_config.ROLES.ADMIN);
	    },
	
	    canSeeCuantitativeResults: function canSeeCuantitativeResults() {
	      return !_this.hasFreePlan();
	    },
	    canGenerateReports: function canGenerateReports() {
	      return !(_this.hasExpertoPlan() || _this.hasValidacionPlan());
	    },
	    canEditParameters: function canEditParameters() {
	      return !_this.hasValidacionPlan();
	    },
	    canCompareProjects: function canCompareProjects() {
	      return !_this.hasFreePlan();
	    }
	  };
	}
	
	exports.default = AuthService;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CatalogService.$inject = ["$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	function CatalogService($http) {
	
	  'ngInject';
	
	  return {
	
	    getReportSchema: function getReportSchema(version) {
	      return $http.get(_config.API.BASE_CATALOG + '/report_schema_' + version + '.json');
	    }
	
	  };
	}
	
	exports.default = CatalogService;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CompanyService.$inject = ["$http", "$resource", "$mdDialog", "$tszToast"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	function CompanyService($http, $resource, $mdDialog, $tszToast) {
	
	  'ngInject';
	
	  var CompanyResource = $resource(_config.API.COMPANIES, { id: '@id' }, {
	    get: {
	      method: 'GET'
	    },
	    create: {
	      method: 'POST'
	    },
	    update: {
	      method: 'PUT'
	    },
	    delete: {
	      method: 'DELETE'
	    },
	    list: {
	      method: 'GET',
	      isArray: true
	    },
	    invite: {
	      method: 'POST',
	      url: _config.API.COMPANY.USERS
	    },
	    users: {
	      method: 'GET',
	      url: _config.API.COMPANY.USERS,
	      isArray: true
	    },
	    get_payment_details: {
	      method: 'POST',
	      url: _config.API.COMPANY.REPORT
	    }
	  });
	
	  return {
	    get: function get(id) {
	      return CompanyResource.get({ id: id }).$promise;
	    },
	    create: function create(company) {
	      return CompanyResource.create(company).$promise;
	    },
	    update: function update(id, company) {
	      return CompanyResource.update({ id: id }, company).$promise;
	    },
	    delete: function _delete(id) {
	      return CompanyResource.delete({ id: id }).$promise;
	    },
	    invite: function invite(id, invitation) {
	      return CompanyResource.invite({ id: id }, invitation).$promise;
	    },
	    list: function list() {
	      return CompanyResource.list().$promise;
	    },
	    users: function users(id) {
	      return CompanyResource.users({ id: id }).$promise;
	    },
	
	    getPaymentDetails: function getPaymentDetails(companyId, reportId) {
	      return CompanyResource.get_payment_details({ companyId: companyId, reportId: reportId }, {}).$promise;
	    },
	
	    deleteAction: function deleteAction(company, ev, callback) {
	
	      var companyName = company.name;
	      if (!companyName) {
	        companyName = company.id;
	      }
	
	      var confirm = $mdDialog.confirm().clickOutsideToClose(true).title('Estás seguro de que quieres eliminar esta compañía?').textContent('Esta operaci\xF3n eliminar\xE1 de forma irreversible la compa\xF1\xEDa "' + companyName + '"').ariaLabel('Confirmar eliminación compañía').targetEvent(ev).ok('Eliminar').cancel('Cancelar');
	
	      $mdDialog.show(confirm).then(function () {
	        CompanyResource.delete({ id: company.id }).$promise.then(function () {
	          $tszToast.showSuccess('La compa\xF1\xEDa "' + companyName + '" ha sido eliminada');
	          callback(company.id);
	        }).catch(function (err) {
	          console.error(err.message);
	          $tszToast.showError('Se ha producido un error al eliminar la compa\xF1\xEDa "' + companyName + '"');
	        });
	      });
	    }
	  };
	}
	
	exports.default = CompanyService;

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';
	
	ConfigService.$inject = ["$localStorage"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function ConfigService($localStorage) {
	
	  'ngInject';
	
	  var _this = this;
	
	  this.set = function (name, value) {
	    $localStorage[name] = value;
	  };
	
	  this.get = function (name, defaultValue) {
	    if ($localStorage[name]) {
	      return $localStorage[name];
	    } else if (defaultValue) {
	      return defaultValue;
	    }
	    return null;
	  };
	
	  return {
	    set: function set(name, value) {
	      return _this.set(name, value);
	    },
	    get: function get(name, defaultValue) {
	      return _this.get(name, defaultValue);
	    }
	  };
	}
	
	exports.default = ConfigService;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ContactService.$inject = ["$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	function ContactService($http) {
	
	  'ngInject';
	
	  return {
	    send: function send(message) {
	      return $http.post(_config.API.CONTACT, message);
	    }
	  };
	}
	
	exports.default = ContactService;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	PlanService.$inject = ["$http", "$resource"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	function PlanService($http, $resource) {
	
	  'ngInject';
	
	  var PlanResource = $resource(_config.API.PLAN, { id: '@id' }, {
	    list: {
	      method: 'GET',
	      isArray: true
	    },
	    save: {
	      method: 'POST'
	    }
	  });
	
	  return {
	    list: function list(id) {
	      return PlanResource.list({ id: id }).$promise;
	    },
	    save: function save(plan) {
	      return PlanResource.save(plan).$promise;
	    }
	  };
	}
	
	exports.default = PlanService;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	PropertyService.$inject = ["$resource"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	function PropertyService($resource) {
	
	  'ngInject';
	
	  var PropertyResource = $resource(_config.API.CONFIG, { id: '@id' }, {
	    get: {
	      method: 'GET'
	    },
	    save: {
	      method: 'POST'
	    }
	  });
	
	  return {
	    get: function get(id) {
	      return PropertyResource.get({ id: id }).$promise;
	    },
	    save: function save(property) {
	      return PropertyResource.save(property).$promise;
	    }
	  };
	}
	
	exports.default = PropertyService;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ReportService.$inject = ["$http", "$q", "$resource", "$tszToast", "$mdDialog", "$base64", "FileSaver", "Blob"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	function ReportService($http, $q, $resource, $tszToast, $mdDialog, $base64, FileSaver, Blob) {
	
	  'ngInject';
	
	  var ReportResource = $resource(_config.API.REPORTS, { report_id: '@id' }, {
	    get: {
	      method: 'GET'
	    },
	    download: {
	      method: 'GET',
	      headers: {
	        accept: 'application/pdf'
	      },
	      responseType: 'arraybuffer',
	      url: _config.API.REPORTS + '/pdf',
	      transformResponse: function transformResponse(data) {
	        var pdf = void 0;
	        if (data) {
	          pdf = new Blob([data], {
	            type: 'application/pdf'
	          });
	        }
	        return {
	          response: pdf
	        };
	      }
	    },
	    generate: {
	      method: 'POST',
	      url: '' + _config.API.REPORT.GENERATE
	    },
	    verify_csv: {
	      method: 'GET',
	      url: '' + _config.API.REPORT.VERIFY_CSV
	    },
	    download_csv: {
	      method: 'GET',
	      url: _config.API.REPORT.DOWNLOAD_CSV
	    },
	    create: {
	      method: 'POST'
	    },
	    duplicate: {
	      method: 'POST',
	      url: _config.API.REPORT.DUPLICATE
	    },
	    update: {
	      method: 'PUT'
	    },
	    delete: {
	      method: 'DELETE'
	    },
	    list: {
	      method: 'GET',
	      isArray: true
	    },
	    company_reports: {
	      method: 'GET',
	      url: _config.API.COMPANY.REPORTS,
	      isArray: true
	    },
	    get_calculated_reports: {
	      method: 'GET',
	      url: _config.API.COMPANY.CALCULATED_REPORTS,
	      isArray: true
	    },
	    get_report_price: {
	      method: 'POST',
	      url: _config.API.COMPANY.REPORTS + '/price'
	    },
	    get_price: {
	      method: 'POST',
	      url: '' + _config.API.REPORT.PRICE
	    },
	    calculate: {
	      method: 'POST',
	      url: '/api/reports/calculate'
	    }
	  });
	
	  return {
	    get: function get(reportId) {
	      return ReportResource.get({ report_id: reportId }).$promise;
	    },
	    create: function create(report) {
	      return ReportResource.create(report).$promise;
	    },
	    update: function update(report) {
	      return ReportResource.update(report).$promise;
	    },
	    delete: function _delete(reportId) {
	      return ReportResource.delete({ report_id: reportId }).$promise;
	    },
	    duplicate: function duplicate(reportId) {
	      return ReportResource.duplicate({ id: reportId }).$promise;
	    },
	    list: function list() {
	      return ReportResource.list().$promise;
	    },
	    company_reports: function company_reports(companyId) {
	      return ReportResource.company_reports({ id: companyId }).$promise;
	    },
	    get_calculated_reports: function get_calculated_reports(companyId) {
	      return ReportResource.get_calculated_reports({ id: companyId }).$promise;
	    },
	    calculate: function calculate(report) {
	      return ReportResource.calculate({}, report).$promise;
	    },
	    // calculate: (report) => $http.post(`${API.REPORTS.CALCULATE}`, report),
	    generate: function generate(reportId) {
	      return ReportResource.generate({ id: reportId, report_id: reportId }).$promise;
	    },
	    verify_csv: function verify_csv(csv) {
	      return ReportResource.verify_csv({ csv: csv }).$promise;
	    },
	    download_csv: function download_csv(csv) {
	      return ReportResource.download_csv({ csv: csv }).$promise;
	    },
	
	    export: function _export(report) {
	      var data = new Blob([$base64.encode(JSON.stringify(report, null, '\t'))], { type: 'text/plain;charset=utf-8' });
	      FileSaver.saveAs(data, report.name + '.tsz');
	    },
	
	    download: function download(report) {
	      ReportResource.download({ report_id: report.id }).$promise.then(function (blob) {
	        // const data = new Blob([response.data], { type: 'application/pdf;' });
	        FileSaver.saveAs(blob.response, report.name + '.pdf');
	      }).catch(function () {
	        $tszToast.showError('Se ha producido un error al descargar el informe');
	      });
	    },
	
	    getPrice1: function getPrice1(report) {
	      if (report.building_usage && report.design_type && report.area) {
	        var bu = _config.CONSTANTS.BUILDING_USAGE[report.building_usage].value;
	        var pt = _config.CONSTANTS.PROJECT_TYPE[report.design_type].value;
	        var area = report.area;
	        var minPrice = _config.CONSTANTS.PROJECT_TYPE[report.design_type].min_price;
	
	        var price = bu * pt * area;
	        if (price < minPrice) {
	          price = minPrice;
	        }
	        return price;
	      }
	      return 0;
	    },
	
	    getPrice: function getPrice(companyId, report) {
	      return ReportResource.get_report_price({ id: companyId }, {
	        area: report.area,
	        buildingUsage: report.building_usage,
	        projectType: report.design_type
	      }).$promise;
	    },
	
	    getBasePrice: function getBasePrice(report) {
	      return ReportResource.get_price({
	        area: report.area,
	        buildingUsage: report.building_usage,
	        projectType: report.design_type
	      }).$promise;
	    },
	
	    deleteAction: function deleteAction(report, ev, callback) {
	
	      var confirm = $mdDialog.confirm().clickOutsideToClose(true).title('Estás seguro de que quieres eliminar este informe?').textContent('Esta operaci\xF3n eliminar\xE1 de forma irreversible el informe "' + report.name + '"').ariaLabel('Confirmar eliminación informe').targetEvent(ev).ok('Eliminar').cancel('Cancelar');
	
	      $mdDialog.show(confirm).then(function () {
	        ReportResource.delete({ report_id: report.id }).$promise.then(function () {
	          $tszToast.showSuccess('El informe "' + report.name + '" ha sido eliminado');
	          // scope.$emit('report_deleted', report.id);
	          callback(report.id);
	        }).catch(function (err) {
	          console.error(err.message);
	          $tszToast.showError('Se ha producido un error al eliminar el informe "' + report.name + '"');
	        });
	      });
	    }
	  };
	}
	
	exports.default = ReportService;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	SubscriptionService.$inject = ["$http", "$resource"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	function SubscriptionService($http, $resource) {
	
	  'ngInject';
	
	  var SubscriptionResource = $resource(_config.API.COMPANY.SUBSCRIPTIONS, { companyId: '@companyId', subscriptionId: '@subscriptionId' }, {
	    get: {
	      method: 'GET'
	    },
	    create: {
	      method: 'POST'
	    },
	    cancel: {
	      method: 'DELETE',
	      url: _config.API.COMPANY.SUBSCRIPTIONS + '/:subscriptionId'
	    }
	  });
	
	  return {
	    create: function create(companyId, plan, monthly) {
	      return SubscriptionResource.create({ companyId: companyId }, { plan: plan, monthly: monthly }).$promise;
	    },
	    get: function get(companyId) {
	      return SubscriptionResource.get({ companyId: companyId }).$promise;
	    },
	    cancel: function cancel(companyId, subscriptionId) {
	      return SubscriptionResource.cancel({ companyId: companyId, subscriptionId: subscriptionId }).$promise;
	    }
	  };
	}
	
	exports.default = SubscriptionService;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UserService.$inject = ["$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	function UserService($http) {
	
	  'ngInject';
	
	  return {
	    update: function update(user) {
	      return $http.put(_config.API.USER, user);
	    }
	  };
	}
	
	exports.default = UserService;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _Admin = __webpack_require__(271);
	
	var _Admin2 = _interopRequireDefault(_Admin);
	
	var _Auth = __webpack_require__(272);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Catalog = __webpack_require__(273);
	
	var _Catalog2 = _interopRequireDefault(_Catalog);
	
	var _Config = __webpack_require__(275);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _Contact = __webpack_require__(276);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Plan = __webpack_require__(277);
	
	var _Plan2 = _interopRequireDefault(_Plan);
	
	var _Property = __webpack_require__(278);
	
	var _Property2 = _interopRequireDefault(_Property);
	
	var _Report = __webpack_require__(279);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	var _Company = __webpack_require__(274);
	
	var _Company2 = _interopRequireDefault(_Company);
	
	var _User = __webpack_require__(281);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Subscription = __webpack_require__(280);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var servicesModule = _angular2.default.module('meredicte.services', []);
	
	servicesModule.service('AdminService', _Admin2.default).service('AuthService', _Auth2.default).service('CatalogService', _Catalog2.default).service('ConfigService', _Config2.default).service('ContactService', _Contact2.default).service('PlanService', _Plan2.default).service('PropertyService', _Property2.default).service('ReportService', _Report2.default).service('CompanyService', _Company2.default).service('UserService', _User2.default).service('SubscriptionService', _Subscription2.default);
	
	exports.default = servicesModule;

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var translations = {
	
	  APP_NAME: 'theSafeZone',
	
	  LOGIN: {
	    HEADER: 'Inicia sesión en theSafeZone',
	    EMAIL: 'Email',
	    FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
	    INVALID_EMAIL: 'El email introducido no es válido',
	    INVALID_PASSWORD: 'La contraseña introducida debe tener al menos 6 caracteres',
	    LOGIN: 'Iniciar sesión',
	    PASSWORD: 'Contraseña',
	    SIGN_UP: 'Regístrate'
	  },
	
	  SIGNUP: {
	    HEADER: 'Regístrate en theSafeZone',
	    ALREADY_REGISTERED: '¿Ya estás registrado?',
	    COMPANY: 'Organización',
	    EMAIL: 'Email',
	    PASSWORD: 'Contraseña',
	    CONFIRM_PASSWORD: 'Repetir Contraseña',
	    SIGN_UP: 'Regístrate'
	  },
	
	  FORGOT_PASSWORD: {
	    HEADER: '¿Olvidaste tu contraseña?',
	    RECOVER_PASSWORD: 'Recuperar contraseña'
	  },
	
	  PASSWORD_RECOVERY: {
	    HEADER: 'Restablecer contraseña',
	    CHANGE_PASSWORD: 'Cambiar contraseña'
	  },
	
	  MENU: {
	    LOGIN: 'Iniciar sesión',
	    SIGN_UP: 'Registrarse',
	    PROFILE: 'Mi perfil',
	    HELP: 'Ayuda',
	    LOGOUT: 'Cerrar sesión',
	    REPORTS: 'Proyectos',
	    SUBSCRIPTIONS: 'Suscripciones',
	    SUPPORT: 'Soporte',
	    USERS: 'Usuarios',
	    PLANS: 'Planes',
	    THESAFEZONE: 'Nuestra solución',
	    MEREDICTE: 'Meredicte ©',
	    BLOG: 'Blog'
	  },
	
	  SETTINGS: {
	    SAVE: 'Guardar'
	  },
	
	  REPORT: {
	    BUILDING: 'Nombre del sector'
	  },
	
	  ERROR: {
	    INVALID_TOKEN: 'El token especificado no es válido',
	    MAXIMUM_SESSIONS_EXCEEDED: 'Ya existe una sesión iniciada con las credenciales introducidas. Debe cerrar sesión antes de poder iniciar una nueva.',
	    USER_ALREADY_EXISTS: 'El email especificado ya está dado de alta en el sistema',
	    USER_NOT_FOUND: 'El usuario especificado no está dado de alta en el sistema',
	    USER_NOT_VALIDATED: 'Debes validar la cuenta para poder acceder. Se envió un email tras el registro con instrucciones para validar la cuenta.',
	    INVALID_PASSWORD: 'La contraseña introducida no es correcta',
	    NAME_ALREADY_EXISTS: 'Ya existe un proyecto con este mismo nombre. Debe especificar uno nuevo.'
	  },
	
	  SUBSCRIPTIONS: {
	    PURCHASE: 'Contratar'
	  },
	
	  FOOTER: {
	    OUR_SOLUTION: 'Nuestra Solución',
	    WHAT_IS: '¿Qué es Meredicte?',
	    LEGAL_TERMS: 'AVISO LEGAL',
	    USAGE_TERMS: 'TÉRMINOS DE USO',
	    PRIVACY_POLICY: 'PRIVACIDAD',
	    COOKIES: 'COOKIES',
	    COPYRIGHT: 'Todos los derechos reservados'
	  }
	
	};
	
	exports.default = translations;

/***/ }),
/* 284 */,
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	     _ _      _       _
	 ___| (_) ___| | __  (_)___
	/ __| | |/ __| |/ /  | / __|
	\__ \ | | (__|   < _ | \__ \
	|___/_|_|\___|_|\_(_)/ |___/
	                   |__/
	
	 Version: 1.6.0
	  Author: Ken Wheeler
	 Website: http://kenwheeler.github.io
	    Docs: http://kenwheeler.github.io/slick
	    Repo: http://github.com/kenwheeler/slick
	  Issues: http://github.com/kenwheeler/slick/issues
	
	 */
	/* global window, document, define, jQuery, setInterval, clearInterval */
	(function(factory) {
	    'use strict';
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	
	}(function($) {
	    'use strict';
	    var Slick = window.Slick || {};
	
	    Slick = (function() {
	
	        var instanceUid = 0;
	
	        function Slick(element, settings) {
	
	            var _ = this, dataSettings;
	
	            _.defaults = {
	                accessibility: true,
	                adaptiveHeight: false,
	                appendArrows: $(element),
	                appendDots: $(element),
	                arrows: true,
	                asNavFor: null,
	                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
	                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
	                autoplay: false,
	                autoplaySpeed: 3000,
	                centerMode: false,
	                centerPadding: '50px',
	                cssEase: 'ease',
	                customPaging: function(slider, i) {
	                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
	                },
	                dots: false,
	                dotsClass: 'slick-dots',
	                draggable: true,
	                easing: 'linear',
	                edgeFriction: 0.35,
	                fade: false,
	                focusOnSelect: false,
	                infinite: true,
	                initialSlide: 0,
	                lazyLoad: 'ondemand',
	                mobileFirst: false,
	                pauseOnHover: true,
	                pauseOnFocus: true,
	                pauseOnDotsHover: false,
	                respondTo: 'window',
	                responsive: null,
	                rows: 1,
	                rtl: false,
	                slide: '',
	                slidesPerRow: 1,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                speed: 500,
	                swipe: true,
	                swipeToSlide: false,
	                touchMove: true,
	                touchThreshold: 5,
	                useCSS: true,
	                useTransform: true,
	                variableWidth: false,
	                vertical: false,
	                verticalSwiping: false,
	                waitForAnimate: true,
	                zIndex: 1000
	            };
	
	            _.initials = {
	                animating: false,
	                dragging: false,
	                autoPlayTimer: null,
	                currentDirection: 0,
	                currentLeft: null,
	                currentSlide: 0,
	                direction: 1,
	                $dots: null,
	                listWidth: null,
	                listHeight: null,
	                loadIndex: 0,
	                $nextArrow: null,
	                $prevArrow: null,
	                slideCount: null,
	                slideWidth: null,
	                $slideTrack: null,
	                $slides: null,
	                sliding: false,
	                slideOffset: 0,
	                swipeLeft: null,
	                $list: null,
	                touchObject: {},
	                transformsEnabled: false,
	                unslicked: false
	            };
	
	            $.extend(_, _.initials);
	
	            _.activeBreakpoint = null;
	            _.animType = null;
	            _.animProp = null;
	            _.breakpoints = [];
	            _.breakpointSettings = [];
	            _.cssTransitions = false;
	            _.focussed = false;
	            _.interrupted = false;
	            _.hidden = 'hidden';
	            _.paused = true;
	            _.positionProp = null;
	            _.respondTo = null;
	            _.rowCount = 1;
	            _.shouldClick = true;
	            _.$slider = $(element);
	            _.$slidesCache = null;
	            _.transformType = null;
	            _.transitionType = null;
	            _.visibilityChange = 'visibilitychange';
	            _.windowWidth = 0;
	            _.windowTimer = null;
	
	            dataSettings = $(element).data('slick') || {};
	
	            _.options = $.extend({}, _.defaults, settings, dataSettings);
	
	            _.currentSlide = _.options.initialSlide;
	
	            _.originalSettings = _.options;
	
	            if (typeof document.mozHidden !== 'undefined') {
	                _.hidden = 'mozHidden';
	                _.visibilityChange = 'mozvisibilitychange';
	            } else if (typeof document.webkitHidden !== 'undefined') {
	                _.hidden = 'webkitHidden';
	                _.visibilityChange = 'webkitvisibilitychange';
	            }
	
	            _.autoPlay = $.proxy(_.autoPlay, _);
	            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
	            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
	            _.changeSlide = $.proxy(_.changeSlide, _);
	            _.clickHandler = $.proxy(_.clickHandler, _);
	            _.selectHandler = $.proxy(_.selectHandler, _);
	            _.setPosition = $.proxy(_.setPosition, _);
	            _.swipeHandler = $.proxy(_.swipeHandler, _);
	            _.dragHandler = $.proxy(_.dragHandler, _);
	            _.keyHandler = $.proxy(_.keyHandler, _);
	
	            _.instanceUid = instanceUid++;
	
	            // A simple way to check for HTML strings
	            // Strict HTML recognition (must start with <)
	            // Extracted from jQuery v1.11 source
	            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
	
	
	            _.registerBreakpoints();
	            _.init(true);
	
	        }
	
	        return Slick;
	
	    }());
	
	    Slick.prototype.activateADA = function() {
	        var _ = this;
	
	        _.$slideTrack.find('.slick-active').attr({
	            'aria-hidden': 'false'
	        }).find('a, input, button, select').attr({
	            'tabindex': '0'
	        });
	
	    };
	
	    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            addBefore = index;
	            index = null;
	        } else if (index < 0 || (index >= _.slideCount)) {
	            return false;
	        }
	
	        _.unload();
	
	        if (typeof(index) === 'number') {
	            if (index === 0 && _.$slides.length === 0) {
	                $(markup).appendTo(_.$slideTrack);
	            } else if (addBefore) {
	                $(markup).insertBefore(_.$slides.eq(index));
	            } else {
	                $(markup).insertAfter(_.$slides.eq(index));
	            }
	        } else {
	            if (addBefore === true) {
	                $(markup).prependTo(_.$slideTrack);
	            } else {
	                $(markup).appendTo(_.$slideTrack);
	            }
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slides.each(function(index, element) {
	            $(element).attr('data-slick-index', index);
	        });
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.animateHeight = function() {
	        var _ = this;
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.animate({
	                height: targetHeight
	            }, _.options.speed);
	        }
	    };
	
	    Slick.prototype.animateSlide = function(targetLeft, callback) {
	
	        var animProps = {},
	            _ = this;
	
	        _.animateHeight();
	
	        if (_.options.rtl === true && _.options.vertical === false) {
	            targetLeft = -targetLeft;
	        }
	        if (_.transformsEnabled === false) {
	            if (_.options.vertical === false) {
	                _.$slideTrack.animate({
	                    left: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            } else {
	                _.$slideTrack.animate({
	                    top: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            }
	
	        } else {
	
	            if (_.cssTransitions === false) {
	                if (_.options.rtl === true) {
	                    _.currentLeft = -(_.currentLeft);
	                }
	                $({
	                    animStart: _.currentLeft
	                }).animate({
	                    animStart: targetLeft
	                }, {
	                    duration: _.options.speed,
	                    easing: _.options.easing,
	                    step: function(now) {
	                        now = Math.ceil(now);
	                        if (_.options.vertical === false) {
	                            animProps[_.animType] = 'translate(' +
	                                now + 'px, 0px)';
	                            _.$slideTrack.css(animProps);
	                        } else {
	                            animProps[_.animType] = 'translate(0px,' +
	                                now + 'px)';
	                            _.$slideTrack.css(animProps);
	                        }
	                    },
	                    complete: function() {
	                        if (callback) {
	                            callback.call();
	                        }
	                    }
	                });
	
	            } else {
	
	                _.applyTransition();
	                targetLeft = Math.ceil(targetLeft);
	
	                if (_.options.vertical === false) {
	                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
	                } else {
	                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
	                }
	                _.$slideTrack.css(animProps);
	
	                if (callback) {
	                    setTimeout(function() {
	
	                        _.disableTransition();
	
	                        callback.call();
	                    }, _.options.speed);
	                }
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.getNavTarget = function() {
	
	        var _ = this,
	            asNavFor = _.options.asNavFor;
	
	        if ( asNavFor && asNavFor !== null ) {
	            asNavFor = $(asNavFor).not(_.$slider);
	        }
	
	        return asNavFor;
	
	    };
	
	    Slick.prototype.asNavFor = function(index) {
	
	        var _ = this,
	            asNavFor = _.getNavTarget();
	
	        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
	            asNavFor.each(function() {
	                var target = $(this).slick('getSlick');
	                if(!target.unslicked) {
	                    target.slideHandler(index, true);
	                }
	            });
	        }
	
	    };
	
	    Slick.prototype.applyTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        if (_.options.fade === false) {
	            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
	        } else {
	            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
	        }
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.autoPlay = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        if ( _.slideCount > _.options.slidesToShow ) {
	            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
	        }
	
	    };
	
	    Slick.prototype.autoPlayClear = function() {
	
	        var _ = this;
	
	        if (_.autoPlayTimer) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	    };
	
	    Slick.prototype.autoPlayIterator = function() {
	
	        var _ = this,
	            slideTo = _.currentSlide + _.options.slidesToScroll;
	
	        if ( !_.paused && !_.interrupted && !_.focussed ) {
	
	            if ( _.options.infinite === false ) {
	
	                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
	                    _.direction = 0;
	                }
	
	                else if ( _.direction === 0 ) {
	
	                    slideTo = _.currentSlide - _.options.slidesToScroll;
	
	                    if ( _.currentSlide - 1 === 0 ) {
	                        _.direction = 1;
	                    }
	
	                }
	
	            }
	
	            _.slideHandler( slideTo );
	
	        }
	
	    };
	
	    Slick.prototype.buildArrows = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true ) {
	
	            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
	            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
	
	            if( _.slideCount > _.options.slidesToShow ) {
	
	                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	
	                if (_.htmlExpr.test(_.options.prevArrow)) {
	                    _.$prevArrow.prependTo(_.options.appendArrows);
	                }
	
	                if (_.htmlExpr.test(_.options.nextArrow)) {
	                    _.$nextArrow.appendTo(_.options.appendArrows);
	                }
	
	                if (_.options.infinite !== true) {
	                    _.$prevArrow
	                        .addClass('slick-disabled')
	                        .attr('aria-disabled', 'true');
	                }
	
	            } else {
	
	                _.$prevArrow.add( _.$nextArrow )
	
	                    .addClass('slick-hidden')
	                    .attr({
	                        'aria-disabled': 'true',
	                        'tabindex': '-1'
	                    });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.buildDots = function() {
	
	        var _ = this,
	            i, dot;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$slider.addClass('slick-dotted');
	
	            dot = $('<ul />').addClass(_.options.dotsClass);
	
	            for (i = 0; i <= _.getDotCount(); i += 1) {
	                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
	            }
	
	            _.$dots = dot.appendTo(_.options.appendDots);
	
	            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');
	
	        }
	
	    };
	
	    Slick.prototype.buildOut = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slider
	                .children( _.options.slide + ':not(.slick-cloned)')
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        _.$slides.each(function(index, element) {
	            $(element)
	                .attr('data-slick-index', index)
	                .data('originalStyling', $(element).attr('style') || '');
	        });
	
	        _.$slider.addClass('slick-slider');
	
	        _.$slideTrack = (_.slideCount === 0) ?
	            $('<div class="slick-track"/>').appendTo(_.$slider) :
	            _.$slides.wrapAll('<div class="slick-track"/>').parent();
	
	        _.$list = _.$slideTrack.wrap(
	            '<div aria-live="polite" class="slick-list"/>').parent();
	        _.$slideTrack.css('opacity', 0);
	
	        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
	            _.options.slidesToScroll = 1;
	        }
	
	        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
	
	        _.setupInfinite();
	
	        _.buildArrows();
	
	        _.buildDots();
	
	        _.updateDots();
	
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        if (_.options.draggable === true) {
	            _.$list.addClass('draggable');
	        }
	
	    };
	
	    Slick.prototype.buildRows = function() {
	
	        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;
	
	        newSlides = document.createDocumentFragment();
	        originalSlides = _.$slider.children();
	
	        if(_.options.rows > 1) {
	
	            slidesPerSection = _.options.slidesPerRow * _.options.rows;
	            numOfSlides = Math.ceil(
	                originalSlides.length / slidesPerSection
	            );
	
	            for(a = 0; a < numOfSlides; a++){
	                var slide = document.createElement('div');
	                for(b = 0; b < _.options.rows; b++) {
	                    var row = document.createElement('div');
	                    for(c = 0; c < _.options.slidesPerRow; c++) {
	                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
	                        if (originalSlides.get(target)) {
	                            row.appendChild(originalSlides.get(target));
	                        }
	                    }
	                    slide.appendChild(row);
	                }
	                newSlides.appendChild(slide);
	            }
	
	            _.$slider.empty().append(newSlides);
	            _.$slider.children().children().children()
	                .css({
	                    'width':(100 / _.options.slidesPerRow) + '%',
	                    'display': 'inline-block'
	                });
	
	        }
	
	    };
	
	    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
	
	        var _ = this,
	            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
	        var sliderWidth = _.$slider.width();
	        var windowWidth = window.innerWidth || $(window).width();
	
	        if (_.respondTo === 'window') {
	            respondToWidth = windowWidth;
	        } else if (_.respondTo === 'slider') {
	            respondToWidth = sliderWidth;
	        } else if (_.respondTo === 'min') {
	            respondToWidth = Math.min(windowWidth, sliderWidth);
	        }
	
	        if ( _.options.responsive &&
	            _.options.responsive.length &&
	            _.options.responsive !== null) {
	
	            targetBreakpoint = null;
	
	            for (breakpoint in _.breakpoints) {
	                if (_.breakpoints.hasOwnProperty(breakpoint)) {
	                    if (_.originalSettings.mobileFirst === false) {
	                        if (respondToWidth < _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    } else {
	                        if (respondToWidth > _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    }
	                }
	            }
	
	            if (targetBreakpoint !== null) {
	                if (_.activeBreakpoint !== null) {
	                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
	                        _.activeBreakpoint =
	                            targetBreakpoint;
	                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                            _.unslick(targetBreakpoint);
	                        } else {
	                            _.options = $.extend({}, _.originalSettings,
	                                _.breakpointSettings[
	                                    targetBreakpoint]);
	                            if (initial === true) {
	                                _.currentSlide = _.options.initialSlide;
	                            }
	                            _.refresh(initial);
	                        }
	                        triggerBreakpoint = targetBreakpoint;
	                    }
	                } else {
	                    _.activeBreakpoint = targetBreakpoint;
	                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                        _.unslick(targetBreakpoint);
	                    } else {
	                        _.options = $.extend({}, _.originalSettings,
	                            _.breakpointSettings[
	                                targetBreakpoint]);
	                        if (initial === true) {
	                            _.currentSlide = _.options.initialSlide;
	                        }
	                        _.refresh(initial);
	                    }
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            } else {
	                if (_.activeBreakpoint !== null) {
	                    _.activeBreakpoint = null;
	                    _.options = _.originalSettings;
	                    if (initial === true) {
	                        _.currentSlide = _.options.initialSlide;
	                    }
	                    _.refresh(initial);
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            }
	
	            // only trigger breakpoints during an actual break. not on initialize.
	            if( !initial && triggerBreakpoint !== false ) {
	                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
	            }
	        }
	
	    };
	
	    Slick.prototype.changeSlide = function(event, dontAnimate) {
	
	        var _ = this,
	            $target = $(event.currentTarget),
	            indexOffset, slideOffset, unevenOffset;
	
	        // If target is a link, prevent default action.
	        if($target.is('a')) {
	            event.preventDefault();
	        }
	
	        // If target is not the <li> element (ie: a child), find the <li>.
	        if(!$target.is('li')) {
	            $target = $target.closest('li');
	        }
	
	        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
	        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
	
	        switch (event.data.message) {
	
	            case 'previous':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'next':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'index':
	                var index = event.data.index === 0 ? 0 :
	                    event.data.index || $target.index() * _.options.slidesToScroll;
	
	                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
	                $target.children().trigger('focus');
	                break;
	
	            default:
	                return;
	        }
	
	    };
	
	    Slick.prototype.checkNavigable = function(index) {
	
	        var _ = this,
	            navigables, prevNavigable;
	
	        navigables = _.getNavigableIndexes();
	        prevNavigable = 0;
	        if (index > navigables[navigables.length - 1]) {
	            index = navigables[navigables.length - 1];
	        } else {
	            for (var n in navigables) {
	                if (index < navigables[n]) {
	                    index = prevNavigable;
	                    break;
	                }
	                prevNavigable = navigables[n];
	            }
	        }
	
	        return index;
	    };
	
	    Slick.prototype.cleanUpEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots && _.$dots !== null) {
	
	            $('li', _.$dots)
	                .off('click.slick', _.changeSlide)
	                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	        _.$slider.off('focus.slick blur.slick');
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
	            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
	        }
	
	        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
	        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
	        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
	        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
	
	        _.$list.off('click.slick', _.clickHandler);
	
	        $(document).off(_.visibilityChange, _.visibility);
	
	        _.cleanUpSlideEvents();
	
	        if (_.options.accessibility === true) {
	            _.$list.off('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
	        }
	
	        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
	
	        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
	
	        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
	
	        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);
	
	    };
	
	    Slick.prototype.cleanUpSlideEvents = function() {
	
	        var _ = this;
	
	        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
	        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	    };
	
	    Slick.prototype.cleanUpRows = function() {
	
	        var _ = this, originalSlides;
	
	        if(_.options.rows > 1) {
	            originalSlides = _.$slides.children().children();
	            originalSlides.removeAttr('style');
	            _.$slider.empty().append(originalSlides);
	        }
	
	    };
	
	    Slick.prototype.clickHandler = function(event) {
	
	        var _ = this;
	
	        if (_.shouldClick === false) {
	            event.stopImmediatePropagation();
	            event.stopPropagation();
	            event.preventDefault();
	        }
	
	    };
	
	    Slick.prototype.destroy = function(refresh) {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        _.touchObject = {};
	
	        _.cleanUpEvents();
	
	        $('.slick-cloned', _.$slider).detach();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	
	        if ( _.$prevArrow && _.$prevArrow.length ) {
	
	            _.$prevArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.prevArrow )) {
	                _.$prevArrow.remove();
	            }
	        }
	
	        if ( _.$nextArrow && _.$nextArrow.length ) {
	
	            _.$nextArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.nextArrow )) {
	                _.$nextArrow.remove();
	            }
	
	        }
	
	
	        if (_.$slides) {
	
	            _.$slides
	                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
	                .removeAttr('aria-hidden')
	                .removeAttr('data-slick-index')
	                .each(function(){
	                    $(this).attr('style', $(this).data('originalStyling'));
	                });
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slideTrack.detach();
	
	            _.$list.detach();
	
	            _.$slider.append(_.$slides);
	        }
	
	        _.cleanUpRows();
	
	        _.$slider.removeClass('slick-slider');
	        _.$slider.removeClass('slick-initialized');
	        _.$slider.removeClass('slick-dotted');
	
	        _.unslicked = true;
	
	        if(!refresh) {
	            _.$slider.trigger('destroy', [_]);
	        }
	
	    };
	
	    Slick.prototype.disableTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        transition[_.transitionType] = '';
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.fadeSlide = function(slideIndex, callback) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).css({
	                zIndex: _.options.zIndex
	            });
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 1
	            }, _.options.speed, _.options.easing, callback);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 1,
	                zIndex: _.options.zIndex
	            });
	
	            if (callback) {
	                setTimeout(function() {
	
	                    _.disableTransition(slideIndex);
	
	                    callback.call();
	                }, _.options.speed);
	            }
	
	        }
	
	    };
	
	    Slick.prototype.fadeSlideOut = function(slideIndex) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            }, _.options.speed, _.options.easing);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            });
	
	        }
	
	    };
	
	    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
	
	        var _ = this;
	
	        if (filter !== null) {
	
	            _.$slidesCache = _.$slides;
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.focusHandler = function() {
	
	        var _ = this;
	
	        _.$slider
	            .off('focus.slick blur.slick')
	            .on('focus.slick blur.slick',
	                '*:not(.slick-arrow)', function(event) {
	
	            event.stopImmediatePropagation();
	            var $sf = $(this);
	
	            setTimeout(function() {
	
	                if( _.options.pauseOnFocus ) {
	                    _.focussed = $sf.is(':focus');
	                    _.autoPlay();
	                }
	
	            }, 0);
	
	        });
	    };
	
	    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
	
	        var _ = this;
	        return _.currentSlide;
	
	    };
	
	    Slick.prototype.getDotCount = function() {
	
	        var _ = this;
	
	        var breakPoint = 0;
	        var counter = 0;
	        var pagerQty = 0;
	
	        if (_.options.infinite === true) {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        } else if (_.options.centerMode === true) {
	            pagerQty = _.slideCount;
	        } else if(!_.options.asNavFor) {
	            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
	        }else {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        }
	
	        return pagerQty - 1;
	
	    };
	
	    Slick.prototype.getLeft = function(slideIndex) {
	
	        var _ = this,
	            targetLeft,
	            verticalHeight,
	            verticalOffset = 0,
	            targetSlide;
	
	        _.slideOffset = 0;
	        verticalHeight = _.$slides.first().outerHeight(true);
	
	        if (_.options.infinite === true) {
	            if (_.slideCount > _.options.slidesToShow) {
	                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
	                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
	            }
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
	                    if (slideIndex > _.slideCount) {
	                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
	                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
	                    } else {
	                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
	                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
	                    }
	                }
	            }
	        } else {
	            if (slideIndex + _.options.slidesToShow > _.slideCount) {
	                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
	                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
	            }
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = 0;
	            verticalOffset = 0;
	        }
	
	        if (_.options.centerMode === true && _.options.infinite === true) {
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
	        } else if (_.options.centerMode === true) {
	            _.slideOffset = 0;
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
	        }
	
	        if (_.options.vertical === false) {
	            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
	        } else {
	            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
	        }
	
	        if (_.options.variableWidth === true) {
	
	            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	            } else {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
	            }
	
	            if (_.options.rtl === true) {
	                if (targetSlide[0]) {
	                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                } else {
	                    targetLeft =  0;
	                }
	            } else {
	                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	            }
	
	            if (_.options.centerMode === true) {
	                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	                } else {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
	                }
	
	                if (_.options.rtl === true) {
	                    if (targetSlide[0]) {
	                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                    } else {
	                        targetLeft =  0;
	                    }
	                } else {
	                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	                }
	
	                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
	            }
	        }
	
	        return targetLeft;
	
	    };
	
	    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
	
	        var _ = this;
	
	        return _.options[option];
	
	    };
	
	    Slick.prototype.getNavigableIndexes = function() {
	
	        var _ = this,
	            breakPoint = 0,
	            counter = 0,
	            indexes = [],
	            max;
	
	        if (_.options.infinite === false) {
	            max = _.slideCount;
	        } else {
	            breakPoint = _.options.slidesToScroll * -1;
	            counter = _.options.slidesToScroll * -1;
	            max = _.slideCount * 2;
	        }
	
	        while (breakPoint < max) {
	            indexes.push(breakPoint);
	            breakPoint = counter + _.options.slidesToScroll;
	            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	        }
	
	        return indexes;
	
	    };
	
	    Slick.prototype.getSlick = function() {
	
	        return this;
	
	    };
	
	    Slick.prototype.getSlideCount = function() {
	
	        var _ = this,
	            slidesTraversed, swipedSlide, centerOffset;
	
	        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
	
	        if (_.options.swipeToSlide === true) {
	            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
	                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
	                    swipedSlide = slide;
	                    return false;
	                }
	            });
	
	            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
	
	            return slidesTraversed;
	
	        } else {
	            return _.options.slidesToScroll;
	        }
	
	    };
	
	    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'index',
	                index: parseInt(slide)
	            }
	        }, dontAnimate);
	
	    };
	
	    Slick.prototype.init = function(creation) {
	
	        var _ = this;
	
	        if (!$(_.$slider).hasClass('slick-initialized')) {
	
	            $(_.$slider).addClass('slick-initialized');
	
	            _.buildRows();
	            _.buildOut();
	            _.setProps();
	            _.startLoad();
	            _.loadSlider();
	            _.initializeEvents();
	            _.updateArrows();
	            _.updateDots();
	            _.checkResponsive(true);
	            _.focusHandler();
	
	        }
	
	        if (creation) {
	            _.$slider.trigger('init', [_]);
	        }
	
	        if (_.options.accessibility === true) {
	            _.initADA();
	        }
	
	        if ( _.options.autoplay ) {
	
	            _.paused = false;
	            _.autoPlay();
	
	        }
	
	    };
	
	    Slick.prototype.initADA = function() {
	        var _ = this;
	        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
	            'aria-hidden': 'true',
	            'tabindex': '-1'
	        }).find('a, input, button, select').attr({
	            'tabindex': '-1'
	        });
	
	        _.$slideTrack.attr('role', 'listbox');
	
	        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
	            $(this).attr({
	                'role': 'option',
	                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''
	            });
	        });
	
	        if (_.$dots !== null) {
	            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
	                $(this).attr({
	                    'role': 'presentation',
	                    'aria-selected': 'false',
	                    'aria-controls': 'navigation' + _.instanceUid + i + '',
	                    'id': 'slick-slide' + _.instanceUid + i + ''
	                });
	            })
	                .first().attr('aria-selected', 'true').end()
	                .find('button').attr('role', 'button').end()
	                .closest('div').attr('role', 'toolbar');
	        }
	        _.activateADA();
	
	    };
	
	    Slick.prototype.initArrowEvents = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'previous'
	               }, _.changeSlide);
	            _.$nextArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'next'
	               }, _.changeSlide);
	        }
	
	    };
	
	    Slick.prototype.initDotEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	            $('li', _.$dots).on('click.slick', {
	                message: 'index'
	            }, _.changeSlide);
	        }
	
	        if ( _.options.dots === true && _.options.pauseOnDotsHover === true ) {
	
	            $('li', _.$dots)
	                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initSlideEvents = function() {
	
	        var _ = this;
	
	        if ( _.options.pauseOnHover ) {
	
	            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
	            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initializeEvents = function() {
	
	        var _ = this;
	
	        _.initArrowEvents();
	
	        _.initDotEvents();
	        _.initSlideEvents();
	
	        _.$list.on('touchstart.slick mousedown.slick', {
	            action: 'start'
	        }, _.swipeHandler);
	        _.$list.on('touchmove.slick mousemove.slick', {
	            action: 'move'
	        }, _.swipeHandler);
	        _.$list.on('touchend.slick mouseup.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	        _.$list.on('touchcancel.slick mouseleave.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	
	        _.$list.on('click.slick', _.clickHandler);
	
	        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
	
	        if (_.options.accessibility === true) {
	            _.$list.on('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
	
	        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
	
	        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
	
	        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);
	
	    };
	
	    Slick.prototype.initUI = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.show();
	            _.$nextArrow.show();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.show();
	
	        }
	
	    };
	
	    Slick.prototype.keyHandler = function(event) {
	
	        var _ = this;
	         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	            if (event.keyCode === 37 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'next' :  'previous'
	                    }
	                });
	            } else if (event.keyCode === 39 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'previous' : 'next'
	                    }
	                });
	            }
	        }
	
	    };
	
	    Slick.prototype.lazyLoad = function() {
	
	        var _ = this,
	            loadRange, cloneRange, rangeStart, rangeEnd;
	
	        function loadImages(imagesScope) {
	
	            $('img[data-lazy]', imagesScope).each(function() {
	
	                var image = $(this),
	                    imageSource = $(this).attr('data-lazy'),
	                    imageToLoad = document.createElement('img');
	
	                imageToLoad.onload = function() {
	
	                    image
	                        .animate({ opacity: 0 }, 100, function() {
	                            image
	                                .attr('src', imageSource)
	                                .animate({ opacity: 1 }, 200, function() {
	                                    image
	                                        .removeAttr('data-lazy')
	                                        .removeClass('slick-loading');
	                                });
	                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                        });
	
	                };
	
	                imageToLoad.onerror = function() {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                };
	
	                imageToLoad.src = imageSource;
	
	            });
	
	        }
	
	        if (_.options.centerMode === true) {
	            if (_.options.infinite === true) {
	                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
	                rangeEnd = rangeStart + _.options.slidesToShow + 2;
	            } else {
	                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
	                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
	            }
	        } else {
	            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
	            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
	            if (_.options.fade === true) {
	                if (rangeStart > 0) rangeStart--;
	                if (rangeEnd <= _.slideCount) rangeEnd++;
	            }
	        }
	
	        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
	        loadImages(loadRange);
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-slide');
	            loadImages(cloneRange);
	        } else
	        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
	            loadImages(cloneRange);
	        } else if (_.currentSlide === 0) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
	            loadImages(cloneRange);
	        }
	
	    };
	
	    Slick.prototype.loadSlider = function() {
	
	        var _ = this;
	
	        _.setPosition();
	
	        _.$slideTrack.css({
	            opacity: 1
	        });
	
	        _.$slider.removeClass('slick-loading');
	
	        _.initUI();
	
	        if (_.options.lazyLoad === 'progressive') {
	            _.progressiveLazyLoad();
	        }
	
	    };
	
	    Slick.prototype.next = Slick.prototype.slickNext = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'next'
	            }
	        });
	
	    };
	
	    Slick.prototype.orientationChange = function() {
	
	        var _ = this;
	
	        _.checkResponsive();
	        _.setPosition();
	
	    };
	
	    Slick.prototype.pause = Slick.prototype.slickPause = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	        _.paused = true;
	
	    };
	
	    Slick.prototype.play = Slick.prototype.slickPlay = function() {
	
	        var _ = this;
	
	        _.autoPlay();
	        _.options.autoplay = true;
	        _.paused = false;
	        _.focussed = false;
	        _.interrupted = false;
	
	    };
	
	    Slick.prototype.postSlide = function(index) {
	
	        var _ = this;
	
	        if( !_.unslicked ) {
	
	            _.$slider.trigger('afterChange', [_, index]);
	
	            _.animating = false;
	
	            _.setPosition();
	
	            _.swipeLeft = null;
	
	            if ( _.options.autoplay ) {
	                _.autoPlay();
	            }
	
	            if (_.options.accessibility === true) {
	                _.initADA();
	            }
	
	        }
	
	    };
	
	    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'previous'
	            }
	        });
	
	    };
	
	    Slick.prototype.preventDefault = function(event) {
	
	        event.preventDefault();
	
	    };
	
	    Slick.prototype.progressiveLazyLoad = function( tryCount ) {
	
	        tryCount = tryCount || 1;
	
	        var _ = this,
	            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
	            image,
	            imageSource,
	            imageToLoad;
	
	        if ( $imgsToLoad.length ) {
	
	            image = $imgsToLoad.first();
	            imageSource = image.attr('data-lazy');
	            imageToLoad = document.createElement('img');
	
	            imageToLoad.onload = function() {
	
	                image
	                    .attr( 'src', imageSource )
	                    .removeAttr('data-lazy')
	                    .removeClass('slick-loading');
	
	                if ( _.options.adaptiveHeight === true ) {
	                    _.setPosition();
	                }
	
	                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
	                _.progressiveLazyLoad();
	
	            };
	
	            imageToLoad.onerror = function() {
	
	                if ( tryCount < 3 ) {
	
	                    /**
	                     * try to load the image 3 times,
	                     * leave a slight delay so we don't get
	                     * servers blocking the request.
	                     */
	                    setTimeout( function() {
	                        _.progressiveLazyLoad( tryCount + 1 );
	                    }, 500 );
	
	                } else {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                    _.progressiveLazyLoad();
	
	                }
	
	            };
	
	            imageToLoad.src = imageSource;
	
	        } else {
	
	            _.$slider.trigger('allImagesLoaded', [ _ ]);
	
	        }
	
	    };
	
	    Slick.prototype.refresh = function( initializing ) {
	
	        var _ = this, currentSlide, lastVisibleIndex;
	
	        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
	
	        // in non-infinite sliders, we don't want to go past the
	        // last visible index.
	        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
	            _.currentSlide = lastVisibleIndex;
	        }
	
	        // if less slides than to show, go to start.
	        if ( _.slideCount <= _.options.slidesToShow ) {
	            _.currentSlide = 0;
	
	        }
	
	        currentSlide = _.currentSlide;
	
	        _.destroy(true);
	
	        $.extend(_, _.initials, { currentSlide: currentSlide });
	
	        _.init();
	
	        if( !initializing ) {
	
	            _.changeSlide({
	                data: {
	                    message: 'index',
	                    index: currentSlide
	                }
	            }, false);
	
	        }
	
	    };
	
	    Slick.prototype.registerBreakpoints = function() {
	
	        var _ = this, breakpoint, currentBreakpoint, l,
	            responsiveSettings = _.options.responsive || null;
	
	        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {
	
	            _.respondTo = _.options.respondTo || 'window';
	
	            for ( breakpoint in responsiveSettings ) {
	
	                l = _.breakpoints.length-1;
	                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
	
	                if (responsiveSettings.hasOwnProperty(breakpoint)) {
	
	                    // loop through the breakpoints and cut out any existing
	                    // ones with the same breakpoint number, we don't want dupes.
	                    while( l >= 0 ) {
	                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
	                            _.breakpoints.splice(l,1);
	                        }
	                        l--;
	                    }
	
	                    _.breakpoints.push(currentBreakpoint);
	                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
	
	                }
	
	            }
	
	            _.breakpoints.sort(function(a, b) {
	                return ( _.options.mobileFirst ) ? a-b : b-a;
	            });
	
	        }
	
	    };
	
	    Slick.prototype.reinit = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slideTrack
	                .children(_.options.slide)
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
	            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }
	
	        _.registerBreakpoints();
	
	        _.setProps();
	        _.setupInfinite();
	        _.buildArrows();
	        _.updateArrows();
	        _.initArrowEvents();
	        _.buildDots();
	        _.updateDots();
	        _.initDotEvents();
	        _.cleanUpSlideEvents();
	        _.initSlideEvents();
	
	        _.checkResponsive(false, true);
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        _.setPosition();
	        _.focusHandler();
	
	        _.paused = !_.options.autoplay;
	        _.autoPlay();
	
	        _.$slider.trigger('reInit', [_]);
	
	    };
	
	    Slick.prototype.resize = function() {
	
	        var _ = this;
	
	        if ($(window).width() !== _.windowWidth) {
	            clearTimeout(_.windowDelay);
	            _.windowDelay = window.setTimeout(function() {
	                _.windowWidth = $(window).width();
	                _.checkResponsive();
	                if( !_.unslicked ) { _.setPosition(); }
	            }, 50);
	        }
	    };
	
	    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            removeBefore = index;
	            index = removeBefore === true ? 0 : _.slideCount - 1;
	        } else {
	            index = removeBefore === true ? --index : index;
	        }
	
	        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
	            return false;
	        }
	
	        _.unload();
	
	        if (removeAll === true) {
	            _.$slideTrack.children().remove();
	        } else {
	            _.$slideTrack.children(this.options.slide).eq(index).remove();
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.setCSS = function(position) {
	
	        var _ = this,
	            positionProps = {},
	            x, y;
	
	        if (_.options.rtl === true) {
	            position = -position;
	        }
	        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
	        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
	
	        positionProps[_.positionProp] = position;
	
	        if (_.transformsEnabled === false) {
	            _.$slideTrack.css(positionProps);
	        } else {
	            positionProps = {};
	            if (_.cssTransitions === false) {
	                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
	                _.$slideTrack.css(positionProps);
	            } else {
	                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
	                _.$slideTrack.css(positionProps);
	            }
	        }
	
	    };
	
	    Slick.prototype.setDimensions = function() {
	
	        var _ = this;
	
	        if (_.options.vertical === false) {
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: ('0px ' + _.options.centerPadding)
	                });
	            }
	        } else {
	            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: (_.options.centerPadding + ' 0px')
	                });
	            }
	        }
	
	        _.listWidth = _.$list.width();
	        _.listHeight = _.$list.height();
	
	
	        if (_.options.vertical === false && _.options.variableWidth === false) {
	            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
	            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));
	
	        } else if (_.options.variableWidth === true) {
	            _.$slideTrack.width(5000 * _.slideCount);
	        } else {
	            _.slideWidth = Math.ceil(_.listWidth);
	            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
	        }
	
	        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
	        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
	
	    };
	
	    Slick.prototype.setFade = function() {
	
	        var _ = this,
	            targetLeft;
	
	        _.$slides.each(function(index, element) {
	            targetLeft = (_.slideWidth * index) * -1;
	            if (_.options.rtl === true) {
	                $(element).css({
	                    position: 'relative',
	                    right: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            } else {
	                $(element).css({
	                    position: 'relative',
	                    left: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            }
	        });
	
	        _.$slides.eq(_.currentSlide).css({
	            zIndex: _.options.zIndex - 1,
	            opacity: 1
	        });
	
	    };
	
	    Slick.prototype.setHeight = function() {
	
	        var _ = this;
	
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.css('height', targetHeight);
	        }
	
	    };
	
	    Slick.prototype.setOption =
	    Slick.prototype.slickSetOption = function() {
	
	        /**
	         * accepts arguments in format of:
	         *
	         *  - for changing a single option's value:
	         *     .slick("setOption", option, value, refresh )
	         *
	         *  - for changing a set of responsive options:
	         *     .slick("setOption", 'responsive', [{}, ...], refresh )
	         *
	         *  - for updating multiple values at once (not responsive)
	         *     .slick("setOption", { 'option': value, ... }, refresh )
	         */
	
	        var _ = this, l, item, option, value, refresh = false, type;
	
	        if( $.type( arguments[0] ) === 'object' ) {
	
	            option =  arguments[0];
	            refresh = arguments[1];
	            type = 'multiple';
	
	        } else if ( $.type( arguments[0] ) === 'string' ) {
	
	            option =  arguments[0];
	            value = arguments[1];
	            refresh = arguments[2];
	
	            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {
	
	                type = 'responsive';
	
	            } else if ( typeof arguments[1] !== 'undefined' ) {
	
	                type = 'single';
	
	            }
	
	        }
	
	        if ( type === 'single' ) {
	
	            _.options[option] = value;
	
	
	        } else if ( type === 'multiple' ) {
	
	            $.each( option , function( opt, val ) {
	
	                _.options[opt] = val;
	
	            });
	
	
	        } else if ( type === 'responsive' ) {
	
	            for ( item in value ) {
	
	                if( $.type( _.options.responsive ) !== 'array' ) {
	
	                    _.options.responsive = [ value[item] ];
	
	                } else {
	
	                    l = _.options.responsive.length-1;
	
	                    // loop through the responsive object and splice out duplicates.
	                    while( l >= 0 ) {
	
	                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {
	
	                            _.options.responsive.splice(l,1);
	
	                        }
	
	                        l--;
	
	                    }
	
	                    _.options.responsive.push( value[item] );
	
	                }
	
	            }
	
	        }
	
	        if ( refresh ) {
	
	            _.unload();
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.setPosition = function() {
	
	        var _ = this;
	
	        _.setDimensions();
	
	        _.setHeight();
	
	        if (_.options.fade === false) {
	            _.setCSS(_.getLeft(_.currentSlide));
	        } else {
	            _.setFade();
	        }
	
	        _.$slider.trigger('setPosition', [_]);
	
	    };
	
	    Slick.prototype.setProps = function() {
	
	        var _ = this,
	            bodyStyle = document.body.style;
	
	        _.positionProp = _.options.vertical === true ? 'top' : 'left';
	
	        if (_.positionProp === 'top') {
	            _.$slider.addClass('slick-vertical');
	        } else {
	            _.$slider.removeClass('slick-vertical');
	        }
	
	        if (bodyStyle.WebkitTransition !== undefined ||
	            bodyStyle.MozTransition !== undefined ||
	            bodyStyle.msTransition !== undefined) {
	            if (_.options.useCSS === true) {
	                _.cssTransitions = true;
	            }
	        }
	
	        if ( _.options.fade ) {
	            if ( typeof _.options.zIndex === 'number' ) {
	                if( _.options.zIndex < 3 ) {
	                    _.options.zIndex = 3;
	                }
	            } else {
	                _.options.zIndex = _.defaults.zIndex;
	            }
	        }
	
	        if (bodyStyle.OTransform !== undefined) {
	            _.animType = 'OTransform';
	            _.transformType = '-o-transform';
	            _.transitionType = 'OTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.MozTransform !== undefined) {
	            _.animType = 'MozTransform';
	            _.transformType = '-moz-transform';
	            _.transitionType = 'MozTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.webkitTransform !== undefined) {
	            _.animType = 'webkitTransform';
	            _.transformType = '-webkit-transform';
	            _.transitionType = 'webkitTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.msTransform !== undefined) {
	            _.animType = 'msTransform';
	            _.transformType = '-ms-transform';
	            _.transitionType = 'msTransition';
	            if (bodyStyle.msTransform === undefined) _.animType = false;
	        }
	        if (bodyStyle.transform !== undefined && _.animType !== false) {
	            _.animType = 'transform';
	            _.transformType = 'transform';
	            _.transitionType = 'transition';
	        }
	        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
	    };
	
	
	    Slick.prototype.setSlideClasses = function(index) {
	
	        var _ = this,
	            centerOffset, allSlides, indexOffset, remainder;
	
	        allSlides = _.$slider
	            .find('.slick-slide')
	            .removeClass('slick-active slick-center slick-current')
	            .attr('aria-hidden', 'true');
	
	        _.$slides
	            .eq(index)
	            .addClass('slick-current');
	
	        if (_.options.centerMode === true) {
	
	            centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	            if (_.options.infinite === true) {
	
	                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
	
	                    _.$slides
	                        .slice(index - centerOffset, index + centerOffset + 1)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    indexOffset = _.options.slidesToShow + index;
	                    allSlides
	                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	                if (index === 0) {
	
	                    allSlides
	                        .eq(allSlides.length - 1 - _.options.slidesToShow)
	                        .addClass('slick-center');
	
	                } else if (index === _.slideCount - 1) {
	
	                    allSlides
	                        .eq(_.options.slidesToShow)
	                        .addClass('slick-center');
	
	                }
	
	            }
	
	            _.$slides
	                .eq(index)
	                .addClass('slick-center');
	
	        } else {
	
	            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {
	
	                _.$slides
	                    .slice(index, index + _.options.slidesToShow)
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else if (allSlides.length <= _.options.slidesToShow) {
	
	                allSlides
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else {
	
	                remainder = _.slideCount % _.options.slidesToShow;
	                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
	
	                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {
	
	                    allSlides
	                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    allSlides
	                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	            }
	
	        }
	
	        if (_.options.lazyLoad === 'ondemand') {
	            _.lazyLoad();
	        }
	
	    };
	
	    Slick.prototype.setupInfinite = function() {
	
	        var _ = this,
	            i, slideIndex, infiniteCount;
	
	        if (_.options.fade === true) {
	            _.options.centerMode = false;
	        }
	
	        if (_.options.infinite === true && _.options.fade === false) {
	
	            slideIndex = null;
	
	            if (_.slideCount > _.options.slidesToShow) {
	
	                if (_.options.centerMode === true) {
	                    infiniteCount = _.options.slidesToShow + 1;
	                } else {
	                    infiniteCount = _.options.slidesToShow;
	                }
	
	                for (i = _.slideCount; i > (_.slideCount -
	                        infiniteCount); i -= 1) {
	                    slideIndex = i - 1;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex - _.slideCount)
	                        .prependTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                for (i = 0; i < infiniteCount; i += 1) {
	                    slideIndex = i;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex + _.slideCount)
	                        .appendTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
	                    $(this).attr('id', '');
	                });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.interrupt = function( toggle ) {
	
	        var _ = this;
	
	        if( !toggle ) {
	            _.autoPlay();
	        }
	        _.interrupted = toggle;
	
	    };
	
	    Slick.prototype.selectHandler = function(event) {
	
	        var _ = this;
	
	        var targetElement =
	            $(event.target).is('.slick-slide') ?
	                $(event.target) :
	                $(event.target).parents('.slick-slide');
	
	        var index = parseInt(targetElement.attr('data-slick-index'));
	
	        if (!index) index = 0;
	
	        if (_.slideCount <= _.options.slidesToShow) {
	
	            _.setSlideClasses(index);
	            _.asNavFor(index);
	            return;
	
	        }
	
	        _.slideHandler(index);
	
	    };
	
	    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
	
	        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
	            _ = this, navTarget;
	
	        sync = sync || false;
	
	        if (_.animating === true && _.options.waitForAnimate === true) {
	            return;
	        }
	
	        if (_.options.fade === true && _.currentSlide === index) {
	            return;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            return;
	        }
	
	        if (sync === false) {
	            _.asNavFor(index);
	        }
	
	        targetSlide = index;
	        targetLeft = _.getLeft(targetSlide);
	        slideLeft = _.getLeft(_.currentSlide);
	
	        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
	
	        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        }
	
	        if ( _.options.autoplay ) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	        if (targetSlide < 0) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
	            } else {
	                animSlide = _.slideCount + targetSlide;
	            }
	        } else if (targetSlide >= _.slideCount) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = 0;
	            } else {
	                animSlide = targetSlide - _.slideCount;
	            }
	        } else {
	            animSlide = targetSlide;
	        }
	
	        _.animating = true;
	
	        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
	
	        oldSlide = _.currentSlide;
	        _.currentSlide = animSlide;
	
	        _.setSlideClasses(_.currentSlide);
	
	        if ( _.options.asNavFor ) {
	
	            navTarget = _.getNavTarget();
	            navTarget = navTarget.slick('getSlick');
	
	            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
	                navTarget.setSlideClasses(_.currentSlide);
	            }
	
	        }
	
	        _.updateDots();
	        _.updateArrows();
	
	        if (_.options.fade === true) {
	            if (dontAnimate !== true) {
	
	                _.fadeSlideOut(oldSlide);
	
	                _.fadeSlide(animSlide, function() {
	                    _.postSlide(animSlide);
	                });
	
	            } else {
	                _.postSlide(animSlide);
	            }
	            _.animateHeight();
	            return;
	        }
	
	        if (dontAnimate !== true) {
	            _.animateSlide(targetLeft, function() {
	                _.postSlide(animSlide);
	            });
	        } else {
	            _.postSlide(animSlide);
	        }
	
	    };
	
	    Slick.prototype.startLoad = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.hide();
	            _.$nextArrow.hide();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.hide();
	
	        }
	
	        _.$slider.addClass('slick-loading');
	
	    };
	
	    Slick.prototype.swipeDirection = function() {
	
	        var xDist, yDist, r, swipeAngle, _ = this;
	
	        xDist = _.touchObject.startX - _.touchObject.curX;
	        yDist = _.touchObject.startY - _.touchObject.curY;
	        r = Math.atan2(yDist, xDist);
	
	        swipeAngle = Math.round(r * 180 / Math.PI);
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }
	
	        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
	            return (_.options.rtl === false ? 'right' : 'left');
	        }
	        if (_.options.verticalSwiping === true) {
	            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
	                return 'down';
	            } else {
	                return 'up';
	            }
	        }
	
	        return 'vertical';
	
	    };
	
	    Slick.prototype.swipeEnd = function(event) {
	
	        var _ = this,
	            slideCount,
	            direction;
	
	        _.dragging = false;
	        _.interrupted = false;
	        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;
	
	        if ( _.touchObject.curX === undefined ) {
	            return false;
	        }
	
	        if ( _.touchObject.edgeHit === true ) {
	            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
	        }
	
	        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {
	
	            direction = _.swipeDirection();
	
	            switch ( direction ) {
	
	                case 'left':
	                case 'down':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
	                            _.currentSlide + _.getSlideCount();
	
	                    _.currentDirection = 0;
	
	                    break;
	
	                case 'right':
	                case 'up':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
	                            _.currentSlide - _.getSlideCount();
	
	                    _.currentDirection = 1;
	
	                    break;
	
	                default:
	
	
	            }
	
	            if( direction != 'vertical' ) {
	
	                _.slideHandler( slideCount );
	                _.touchObject = {};
	                _.$slider.trigger('swipe', [_, direction ]);
	
	            }
	
	        } else {
	
	            if ( _.touchObject.startX !== _.touchObject.curX ) {
	
	                _.slideHandler( _.currentSlide );
	                _.touchObject = {};
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.swipeHandler = function(event) {
	
	        var _ = this;
	
	        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
	            return;
	        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
	            return;
	        }
	
	        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
	            event.originalEvent.touches.length : 1;
	
	        _.touchObject.minSwipe = _.listWidth / _.options
	            .touchThreshold;
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.minSwipe = _.listHeight / _.options
	                .touchThreshold;
	        }
	
	        switch (event.data.action) {
	
	            case 'start':
	                _.swipeStart(event);
	                break;
	
	            case 'move':
	                _.swipeMove(event);
	                break;
	
	            case 'end':
	                _.swipeEnd(event);
	                break;
	
	        }
	
	    };
	
	    Slick.prototype.swipeMove = function(event) {
	
	        var _ = this,
	            edgeWasHit = false,
	            curLeft, swipeDirection, swipeLength, positionOffset, touches;
	
	        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
	
	        if (!_.dragging || touches && touches.length !== 1) {
	            return false;
	        }
	
	        curLeft = _.getLeft(_.currentSlide);
	
	        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
	        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
	
	        _.touchObject.swipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.swipeLength = Math.round(Math.sqrt(
	                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
	        }
	
	        swipeDirection = _.swipeDirection();
	
	        if (swipeDirection === 'vertical') {
	            return;
	        }
	
	        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
	            event.preventDefault();
	        }
	
	        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
	        if (_.options.verticalSwiping === true) {
	            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
	        }
	
	
	        swipeLength = _.touchObject.swipeLength;
	
	        _.touchObject.edgeHit = false;
	
	        if (_.options.infinite === false) {
	            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
	                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
	                _.touchObject.edgeHit = true;
	            }
	        }
	
	        if (_.options.vertical === false) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        } else {
	            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
	        }
	        if (_.options.verticalSwiping === true) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        }
	
	        if (_.options.fade === true || _.options.touchMove === false) {
	            return false;
	        }
	
	        if (_.animating === true) {
	            _.swipeLeft = null;
	            return false;
	        }
	
	        _.setCSS(_.swipeLeft);
	
	    };
	
	    Slick.prototype.swipeStart = function(event) {
	
	        var _ = this,
	            touches;
	
	        _.interrupted = true;
	
	        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
	            _.touchObject = {};
	            return false;
	        }
	
	        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
	            touches = event.originalEvent.touches[0];
	        }
	
	        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
	        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
	
	        _.dragging = true;
	
	    };
	
	    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
	
	        var _ = this;
	
	        if (_.$slidesCache !== null) {
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.unload = function() {
	
	        var _ = this;
	
	        $('.slick-cloned', _.$slider).remove();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
	            _.$prevArrow.remove();
	        }
	
	        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
	            _.$nextArrow.remove();
	        }
	
	        _.$slides
	            .removeClass('slick-slide slick-active slick-visible slick-current')
	            .attr('aria-hidden', 'true')
	            .css('width', '');
	
	    };
	
	    Slick.prototype.unslick = function(fromBreakpoint) {
	
	        var _ = this;
	        _.$slider.trigger('unslick', [_, fromBreakpoint]);
	        _.destroy();
	
	    };
	
	    Slick.prototype.updateArrows = function() {
	
	        var _ = this,
	            centerOffset;
	
	        centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	        if ( _.options.arrows === true &&
	            _.slideCount > _.options.slidesToShow &&
	            !_.options.infinite ) {
	
	            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            if (_.currentSlide === 0) {
	
	                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.updateDots = function() {
	
	        var _ = this;
	
	        if (_.$dots !== null) {
	
	            _.$dots
	                .find('li')
	                .removeClass('slick-active')
	                .attr('aria-hidden', 'true');
	
	            _.$dots
	                .find('li')
	                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
	                .addClass('slick-active')
	                .attr('aria-hidden', 'false');
	
	        }
	
	    };
	
	    Slick.prototype.visibility = function() {
	
	        var _ = this;
	
	        if ( _.options.autoplay ) {
	
	            if ( document[_.hidden] ) {
	
	                _.interrupted = true;
	
	            } else {
	
	                _.interrupted = false;
	
	            }
	
	        }
	
	    };
	
	    $.fn.slick = function() {
	        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if (typeof opt == 'object' || typeof opt == 'undefined')
	                _[i].slick = new Slick(_[i], opt);
	            else
	                ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };
	
	}));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(87);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./admin-company-detail.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./admin-company-detail.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 287 */
[345, 88],
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(89);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./app.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./app.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(90);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./footer.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./footer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(91);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./forgot-password.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./forgot-password.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(92);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./header.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./header.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 292 */
[345, 93],
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(94);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./landing.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./landing.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(95);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./login.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./login.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(96);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./meredicte.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./meredicte.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(97);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./password-recovery.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./password-recovery.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(98);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./plans.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./plans.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(99);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./report-edit.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./report-edit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(100);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./settings.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./settings.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(101);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./signup.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./signup.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(102);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./subscriptions.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./subscriptions.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(103);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./thesafezone.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./thesafezone.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(104);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./verify-account.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./verify-account.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c90552e59e8c7b07bbbaaa4c8970f2da.png";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ff13c502555d7f0cca07e331d6a74b1d.png";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ef134d91018b4a5b65882ae4a1bf39c4.png";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "12f790adb99e408d7d765835d4121252.png";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2395bd55683f135fbf3ca77e726f276e.png";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "61d387edd9eb40ae2fd9d8025618ccdc.png";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dc298a5b27660f37f84bd8e2b128b049.png";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e345214c7bb62ad594c6681f5f6cb16b.png";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dc838bf91144595e95c5372a88ed1f5c.png";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3f3ef6c134ff41c0944c0d586f8eb43e.png";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bdc040e69caea1be390da16f5eb26a3f.png";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b42798e27ab89f5c2a6880c9ca036e64.png";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7e78447eecd1b13fe8d1ae4cf88331b4.png";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f561531fe650874e2f75112facc8e1c.jpg";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "768d7fba5893f519bf1942c76906b602.png";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4279811fc52151d89e6a41d8b7540a86.png";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d8fa7d09e6284007e5a4adca7e41b75b.png";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "56d7289476fc3ae0c2f13fae5650205f.png";

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6acb6f14242679e1652c89d302a8ff83.png";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "959cc0fd8b4a267654d94f7a7eb95555.png";

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2db263ca1f088fd74a759ff46ee570c4.jpg";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "180a0634761ed7ca4e0b98224739fb8d.png";

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0e80d6666ec6e98df1c793f85f058ded.jpg";

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7495c9e189dad10c5bafe28fbdb6f1ca.png";

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "170d21a16af2a830c0423f35ba6c51e7.jpg";

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "36b2427f02dc3c9c6ae7fb2eafad4155.jpg";

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "38afc08c9736a1df5acd94fe049a4651.jpg";

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5f06680f64fb3bb86fea3d9ed329b858.jpg";

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "779426b4fc57ea700f00bd2e0986183a.jpg";

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "39946d3f4d8f9bc5eb94dff5871d61c0.png";

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f9e52830aeba2f2fa7e1d52e33fe78ae.jpg";

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "290187cc1a9f6663fe0fa4782c0be897.jpg";

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2f0afbdcdd55d9874737e66dfa606346.png";

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9f6d22b243645dbd2672ae69c61b2a41.jpg";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "182f27335026b61039e52c924c32c86f.jpg";

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2478428cd8ef268d640043a098fa7cb2.jpg";

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7bfc31d398798449a4ae4524df21ec9f.jpg";

/***/ }),
/* 341 */,
/* 342 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(342)
	var ieee754 = __webpack_require__(169)
	var isArray = __webpack_require__(344)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./home.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/stylus-loader/index.js!./home.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })
]);


// WEBPACK FOOTER //
// app.js